
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5zs0K", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactSalesPage", function () { return $e1f31a069d086db8$export$2202168fcdf44c37; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oLEw");
var $1AtJz = parcelRequire("1AtJz");
const $e1f31a069d086db8$export$2202168fcdf44c37 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1AtJz.EnterpriseContactSalesPageTemplate), {});

});
parcelRegister("1oLEw", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactSalesPageTemplate", function () { return (parcelRequire("1AtJz")).EnterpriseContactSalesPageTemplate; });

var $1AtJz = parcelRequire("1AtJz");

});
parcelRegister("1AtJz", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactSalesPageTemplate", function () { return $dbc224b0e5c61a42$export$4ae072e91f67c1c7; });

var $7VQPk = parcelRequire("7VQPk");

var $8LaTa = parcelRequire("8LaTa");

var $6E42A = parcelRequire("6E42A");

var $a7Sh0 = parcelRequire("a7Sh0");
const $dbc224b0e5c61a42$export$4ae072e91f67c1c7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6E42A.EnterprisePageProductNav), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a7Sh0.default), {})
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("a7Sh0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9fd18bfe4f963e55$export$2e2bcd8739ae039; });
/* constant-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $hhv63 = parcelRequire("hhv63");

var $21NKE = parcelRequire("21NKE");

var $bskue = parcelRequire("bskue");

var $9Dk5S = parcelRequire("9Dk5S");

var $g06pB = parcelRequire("g06pB");

var $5mbMi = parcelRequire("5mbMi");
const $9fd18bfe4f963e55$var$wrapperStyle = null;
const $9fd18bfe4f963e55$var$mainContainerStyle = null;
const $9fd18bfe4f963e55$var$rowStyle = null;
const $9fd18bfe4f963e55$var$formStyle = null;
const $9fd18bfe4f963e55$var$selectorStyle = null;
const $9fd18bfe4f963e55$var$ConstantSelector = ()=>{
    const intl = (0, $8e22h.default)();
    const discussText = intl.formatMessage({
        id: "constant-selector.main.discuss",
        defaultMessage: "I'd like to discuss "
    });
    const productFeaturesText = intl.formatMessage({
        id: "constant-selector.main.product-features",
        defaultMessage: "product features"
    });
    const pricingQuotesText = intl.formatMessage({
        id: "constant-selector.main.pricing-quotes",
        defaultMessage: "pricing & quotes"
    });
    const migrationOptionsText = intl.formatMessage({
        id: "constant-selector.main.migration-options",
        defaultMessage: "migration options"
    });
    const billingLicensingText = intl.formatMessage({
        id: "constant-selector.main.billing-licensing",
        defaultMessage: "billing & licensing"
    });
    const technicalSupportText = intl.formatMessage({
        id: "constant-selector.main.technical-support",
        defaultMessage: "technical support"
    });
    const urlParams = new URLSearchParams(window.location.search);
    const formType = urlParams.get("formType");
    const formTypeOptions = {
        "product-features": "product features",
        "pricing-quotes": "pricing & quotes",
        "migration-options": "migration options",
        "billing-licensing": "billing & licensing",
        "technical-support": "technical support"
    };
    const formTypeOption = formTypeOptions[formType || "product-features"];
    const [selectedOption, setSelectedOption] = (0, $1oC0p.useState)(formTypeOption);
    const handleChange = (event)=>{
        setSelectedOption(event.target.value);
        const newParams = new URLSearchParams(window.location.search);
        newParams.set("formType", event.target.value.replace(/&/g, "").replace(/\s+/g, "-"));
        window.history.pushState({}, "", `?${newParams.toString()}`);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhv63.ConsentHubClientConfigProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _ahbq1wug _12l21wug _1pfhidpf _1q5146v8"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _vchhusvi _1e0c1ule _6rth1ylp"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_12l21wug _ahbq1wug _p12f1fra"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_ahbqgktf _vwz411ph _1wybbs2l _1bsb1osq _ect4du8v _k48pbfng _1dyz165v _s7n410ig _syaz1bqd _2u5gusvi _suga1ule _1rfm1a5k"
                            ]),
                            children: discussText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                            value: selectedOption,
                            onChange: handleChange,
                            className: (0, $2jatx.default)([
                                "_1h6d1j28 _189et94y _vchhusvi _ect4du8v _p12fdgin _ca0q1skh _u5f38vuz _n3td1crf _19bv1crf _k48p1nn1 _1wybahaf _vwz4cjiy _2rko14y2 _y3gn1e5h _4cvr1h6o _syazrbzz _bfhk1hxd _1p1d1qyh _wstuglyw _80omtlke _1itk31me _1lrw1xbb _ouxlm83n _12vemgnk _irr3uzct _11cg7vkz _1rkb1a5k"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                    value: "product features",
                                    children: productFeaturesText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                    value: "pricing & quotes",
                                    children: pricingQuotesText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                    value: "migration options",
                                    children: migrationOptionsText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                    value: "billing & licensing",
                                    children: billingLicensingText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                    value: "technical support",
                                    children: technicalSupportText
                                })
                            ]
                        }),
                        selectedOption === "product features" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g06pB.default), {}),
                        selectedOption === "pricing & quotes" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Dk5S.default), {}),
                        selectedOption === "migration options" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bskue.default), {}),
                        selectedOption === "billing & licensing" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $21NKE.default), {}),
                        selectedOption === "technical support" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5mbMi.default), {})
                    ]
                })
            })
        })
    });
};
var $9fd18bfe4f963e55$export$2e2bcd8739ae039 = $9fd18bfe4f963e55$var$ConstantSelector;

});
parcelRegister("21NKE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26bcf019da5598a3$export$2e2bcd8739ae039; });
/* billing-licensing.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $fJP6M = parcelRequire("fJP6M");

var $kooLp = parcelRequire("kooLp");
const $26bcf019da5598a3$var$containerStyle = null;
const $26bcf019da5598a3$var$innerContainerStyle = null;
const $26bcf019da5598a3$var$textContainer = null;
const $26bcf019da5598a3$var$buttonStyle = null;
const $26bcf019da5598a3$var$buttonContainer = null;
const $26bcf019da5598a3$var$BillingLicensing = ()=>{
    const intl = (0, $8e22h.default)();
    const contactSupportText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.billing-licensing.contact-support",
        defaultMessage: "Contact support"
    });
    const billingText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.billing-licensing.billing",
        defaultMessage: `If you\u{2019}re wondering how billing works for a product you\u{2019}d like to purchase, select \u{201C}pricing & quotes\u{201D}.`
    });
    const assistanceText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.billing-licensing.assitance",
        defaultMessage: "For assistance with products you already own, please raise a support ticket."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _p12f1fra _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4y94u"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _p12f1c1k _1ul91ssb"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syazvwuj"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: billingText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: assistanceText
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1pfh1ylp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.default), {
                        text: contactSupportText,
                        "aria-label": contactSupportText,
                        color: "darkblue",
                        url: (0, $kooLp.useLocalizedHref)("/company/contact/purchasing-licensing"),
                        dataEventProps: {
                            "data-product-key": "jiraSoftwareFeature",
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-label": contactSupportText
                        },
                        className: (0, $2jatx.default)([
                            "_18s81ag2 _k48pbfng _1tke1ylp _3fcw1g80 _s7n41q9y _d5ymcfaq _ect4lnmy _6rth1tcg"
                        ])
                    })
                })
            ]
        })
    });
};
var $26bcf019da5598a3$export$2e2bcd8739ae039 = $26bcf019da5598a3$var$BillingLicensing;

});

parcelRegister("bskue", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d0aa98f0fec04aa1$export$2e2bcd8739ae039; });
/* migration-options.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lX14w = parcelRequire("lX14w");
var $ff3wF = parcelRequire("ff3wF");
var $igGC3 = parcelRequire("igGC3");
var $gacwQ = parcelRequire("gacwQ");
var $kR3EL = parcelRequire("kR3EL");

var $9BG80 = parcelRequire("9BG80");

var $8KJ2x = parcelRequire("8KJ2x");

var $fJP6M = parcelRequire("fJP6M");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $1rGpC = parcelRequire("1rGpC");

var $2ve7k = parcelRequire("2ve7k");

var $lBgvn = parcelRequire("lBgvn");

var $3bkHm = parcelRequire("3bkHm");

var $izhAl = parcelRequire("izhAl");

var $e0MOs = parcelRequire("e0MOs");

var $ai7AF = parcelRequire("ai7AF");

var $9xhTf = parcelRequire("9xhTf");

var $8Fvhz = parcelRequire("8Fvhz");
const $d0aa98f0fec04aa1$var$dropdownSelectorStyle = null;
const $d0aa98f0fec04aa1$var$MigratingFromDropdown = ({ onChangeHandler: onChangeHandler })=>{
    const [selectedOption, setSelectedOption] = (0, $1oC0p.useState)("");
    const onClick = (event)=>{
        const selected = String(event.target.value);
        setSelectedOption(selected);
        onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler(selected);
    };
    const intl = (0, $8e22h.default)();
    const serverToCloud = intl.formatMessage({
        id: "migrationOptions.serverToCloud",
        defaultMessage: "Server to Cloud"
    });
    const serverToDataCenter = intl.formatMessage({
        id: "migrationOptions.serverToDataCenter",
        defaultMessage: "Server to Data Center"
    });
    const dataCenterToCloud = intl.formatMessage({
        id: "migrationOptions.dataCenterToCloud",
        defaultMessage: "Data Center to Cloud"
    });
    const iDontKnowYet = intl.formatMessage({
        id: "migrationOptions.iDontKnowYet",
        defaultMessage: "I don't know yet"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
        id: "options",
        value: selectedOption,
        onChange: onClick,
        "data-testid": "migration-options",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _vchhusvi _1e0c1ule _ca0q1skh _u5f38vuz _n3td1crf _19bv1crf _1tkeckbl _1reoewfl _18m9ewfl _1bsb1osq _ect418gv _1iqs4jg8 _66a41wug _1pyn1wug _1wyb7vkz _1nx91osq _zg8l4jg8 _k48p1nn1 _1dyz4jg8 _vwz4cjiy _y3gn1e5h _azhwidpf _w19jglyw _1p1dglyw _3fcw1q9c _d5ymcfaq _1ccq4jg8 _syaz1bqd _bfhk1hxd _2rko14y2 _1itk1kto _1xys1hni _uokl1vk8 _12veeva1 _1lrw1yzm _lv3yidpf _wii51fhb _1rx61osq _19itglyw _80omtlke _wstuglyw _irr3uzct _nt751r31 _49pcglyw _1hvw1o36 _1ohht94y _1ya5nqa1 _858uu7gi _mizu1r31 _ra3xglyw _128m1o36 _1lwit94y _10knnqa1 _pojju7gi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: ""
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Server to cloud",
                children: serverToCloud
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Server to Data Center",
                children: serverToDataCenter
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Data Center to Cloud",
                children: dataCenterToCloud
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "I don\u2019t know",
                children: iDontKnowYet
            })
        ]
    });
};
const $d0aa98f0fec04aa1$var$LearnAboutMigrationsDropdown = ({ onChangeHandler: onChangeHandler })=>{
    const [selectedOption, setSelectedOption] = (0, $1oC0p.useState)("");
    const onClick = (event)=>{
        const selected = String(event.target.value);
        setSelectedOption(selected);
        onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler(selected);
    };
    const intl = (0, $8e22h.default)();
    const pricingAndQuotes = intl.formatMessage({
        id: "migrationOptions.pricingAndQuotes",
        defaultMessage: "Pricing and quotes"
    });
    const securityAndCompliance = intl.formatMessage({
        id: "migrationOptions.securityAndCompliance",
        defaultMessage: "Security and compliance"
    });
    const productFeatures = intl.formatMessage({
        id: "migrationOptions.productFeatures",
        defaultMessage: "Product features"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
        id: "options",
        value: selectedOption,
        onChange: onClick,
        "data-testid": "migration-learn-options",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _vchhusvi _1e0c1ule _ca0q1skh _u5f38vuz _n3td1crf _19bv1crf _1tkeckbl _1reoewfl _18m9ewfl _1bsb1osq _ect418gv _1iqs4jg8 _66a41wug _1pyn1wug _1wyb7vkz _1nx91osq _zg8l4jg8 _k48p1nn1 _1dyz4jg8 _vwz4cjiy _y3gn1e5h _azhwidpf _w19jglyw _1p1dglyw _3fcw1q9c _d5ymcfaq _1ccq4jg8 _syaz1bqd _bfhk1hxd _2rko14y2 _1itk1kto _1xys1hni _uokl1vk8 _12veeva1 _1lrw1yzm _lv3yidpf _wii51fhb _1rx61osq _19itglyw _80omtlke _wstuglyw _irr3uzct _nt751r31 _49pcglyw _1hvw1o36 _1ohht94y _1ya5nqa1 _858uu7gi _mizu1r31 _ra3xglyw _128m1o36 _1lwit94y _10knnqa1 _pojju7gi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: ""
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Pricing and quotes",
                children: pricingAndQuotes
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Security and compliance",
                children: securityAndCompliance
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Product features",
                children: productFeatures
            })
        ]
    });
};
const $d0aa98f0fec04aa1$var$containerStyle = null;
const $d0aa98f0fec04aa1$var$innerContainerStyle = null;
// tech debt that should be addressed separately
const $d0aa98f0fec04aa1$var$formStyle = null;
const $d0aa98f0fec04aa1$var$textContainer = null;
const $d0aa98f0fec04aa1$var$MigrationOptions = ()=>{
    const intl = (0, $8e22h.default)();
    const userInfo = (0, $2ve7k.useLoggedInUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [fieldHasError, setFieldHasError] = (0, $1oC0p.useState)({});
    const [errorMessageText, setErrorMessageText] = (0, $1oC0p.useState)("");
    const [selectedProduct] = (0, $1oC0p.useState)("");
    const [isInvalid, setIsInvalid] = (0, $1oC0p.useState)(true);
    const [showProductField, setShowProductField] = (0, $1oC0p.useState)(false);
    const [changeContactInfo, setChangeContactInfo] = (0, $1oC0p.useState)(false);
    const [migrationDirection, setMigrationDirection] = (0, $1oC0p.useState)("");
    const NEXT_PUBLIC_IDENTITY_BASE_URL = "https://id.atlassian.com";
    const getSwitchAccountURL = (continueUrlParam)=>{
        const continueUrl = continueUrlParam ? continueUrlParam : window.location.href;
        return `${NEXT_PUBLIC_IDENTITY_BASE_URL}/login/select-account?continue=${encodeURIComponent(continueUrl)}`;
    };
    /* 
     Prompts
  */ const yourCompanyEmailPrompt = intl.formatMessage({
        id: "migrationOptions.yourCompanyEmail",
        defaultMessage: "Your company email"
    });
    const personalEmailDomainsErrorPrompt = intl.formatMessage({
        id: "migrationOptions.personalEmailDomainsPrompt",
        defaultMessage: "Personal email domains will result in an error."
    });
    const learnAboutMigrationsPrompt = intl.formatMessage({
        id: "migrationOptions.learnAboutMigrationsPrompt",
        defaultMessage: "This sets some context for our conversation."
    });
    /*
      Error Messages
  */ const firstNameErrorMessage = intl.formatMessage({
        id: "migrationOptions.firstNameErrorMessage",
        defaultMessage: "Your first name is required."
    });
    const lastNameErrorMessage = intl.formatMessage({
        id: "migrationOptions.lastNameErrorMessage",
        defaultMessage: "Your last name is required."
    });
    const companyErrorMessage = intl.formatMessage({
        id: "migrationOptions.companyErrorMessage",
        defaultMessage: "Your company name is required."
    });
    const jobTitleErrorMessage = intl.formatMessage({
        id: "migrationOptions.jobTitleErrorMessage",
        defaultMessage: "Your job title is required."
    });
    const migratingFromErrorMessage = intl.formatMessage({
        id: "migrationOptions.migratingFromErrorMessage",
        defaultMessage: "Select a migration path to continue."
    });
    const productErrorMessage = intl.formatMessage({
        id: "migrationOptions.productErrorMessage",
        defaultMessage: "Select a product or service to continue."
    });
    const notEmailErrorMessage = intl.formatMessage({
        id: "migrationOptions.notEmailErrorMessage",
        defaultMessage: "Enter a valid email address."
    });
    const personalDomainErrorMessage = intl.formatMessage({
        id: "migrationOptions.personalDomainErrorMessage",
        defaultMessage: "Enter an email with a company domain."
    });
    const whatDoYouWantToLearnErrorMessage = intl.formatMessage({
        id: "migrationOptions.whatDoYouWantToLearnErrorMessage",
        defaultMessage: "Select a topic to continue."
    });
    const yourQuestionErrorMessage = intl.formatMessage({
        id: "migrationOptions.yourQuestionErrorMessage",
        defaultMessage: "Enter a quick description of your question."
    });
    const userCountGreaterThan5000Error = intl.formatMessage({
        id: "migrationOptions.userCountErrorMessage",
        defaultMessage: "Enter a number that\u2019s less than 5,000,000."
    });
    const companyNameLengthError = intl.formatMessage({
        id: "migrationOptions.companyNameLengthErrorMessage",
        defaultMessage: "Enter a company name that\u2019s at least two characters."
    });
    const isPersonalDomain = (value)=>{
        const emailDomain = value.split("@")[1];
        return (0, $ai7AF.default).has(String(emailDomain));
    };
    // @ts-ignore
    const handleBlurEvent = (event)=>{
        const { name: name, value: value } = event.currentTarget;
        if (name === "email") {
            if (!value) {
                setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                    [name]: true
                }));
                setErrorMessageText("NOT_EMAIL");
                setIsInvalid(true);
            } else if ((0, $9xhTf.isEmailFormat)(value) && !isPersonalDomain(value)) {
                setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                    [name]: false
                }));
                setErrorMessageText("IS_VALID");
                setIsInvalid(false);
            } else {
                setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                    [name]: true
                }));
                setIsInvalid(true);
                if (!(0, $9xhTf.isEmailFormat)(value)) setErrorMessageText("NOT_EMAIL");
                else if (isPersonalDomain(value)) setErrorMessageText("PERSONAL_DOMAIN");
            }
        } else {
            setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                [name]: !value
            }));
            setIsInvalid(!value);
        }
    };
    // eslint-disable-next-line complexity
    const handleSubmit = (form)=>{
        const errors = {};
        // eslint-disable-next-line @typescript-eslint/no-for-in-array
        for(const field in form)if (form[field] === undefined || fieldHasError[field]) switch(field){
            case "email":
                if (fieldHasError[field]) {
                    if (isPersonalDomain(form[field])) errors["email"] = personalDomainErrorMessage;
                }
                errors["email"] = notEmailErrorMessage;
                break;
            case "firstName":
                errors["firstName"] = firstNameErrorMessage;
                break;
            case "lastName":
                errors["lastName"] = lastNameErrorMessage;
                break;
            case "company":
                errors["company"] = companyErrorMessage;
                break;
            case "title":
                errors["title"] = jobTitleErrorMessage;
                break;
            case "migrationPath":
                errors["migrationPath"] = migratingFromErrorMessage;
                break;
            case "product":
                errors["product"] = productErrorMessage;
                break;
            case "numberOfUsers":
                errors["numberOfUsers"] = numberOfUsersProductErrorMessage;
                break;
            case "formChoices":
                errors["formChoices"] = whatDoYouWantToLearnErrorMessage;
                break;
            case "opportunity_Description__c":
                errors["opportunity_Description__c"] = yourQuestionErrorMessage;
                break;
        }
        if (Object.keys(errors).length > 0) return errors;
        else return (0, $9xhTf.submitContactForm)(form, "migration-options", createAnalyticsEvent).then(()=>{
            window.location.assign(redirectPath);
        }).catch(()=>{
            var _document_querySelector;
            (_document_querySelector = document.querySelector(".post-submit")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.replace("post-submit", "post-submit-error");
        });
    };
    const localizedContactLink = (0, $kooLp.useLocalizedHref)("/contact");
    const redirectPath = (0, $kooLp.useLocalizedHref)(`/enterprise/contact-thanks?formType=migration-options`);
    const SubTextSection = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syazvwuj"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "migrationOptions.formBestFitMigrationPathSubText",
                        defaultMessage: "We can help you assess which migration path is the best fit for your Server or Data Center licenses."
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "migrationOptions.decidedToAlreadyMigrateSubText",
                        defaultMessage: "<span>If you've already decided to migrate, please <raiseASupportTicketLink>raise a support ticket</raiseASupportTicketLink> for help with migration planning and execution.</span>",
                        values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                            raiseASupportTicketLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    "aria-label": text,
                                    text: text,
                                    href: localizedContactLink,
                                    type: "inline"
                                })
                        })
                    })
                })
            ]
        });
    const MigrationFromField = (setFieldValue)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q51ftgi"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                name: "migrationPath",
                label: intl.formatMessage({
                    id: "migrationOptions.migratingFrom",
                    defaultMessage: "Where are you migrating from?"
                }) + " *",
                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($d0aa98f0fec04aa1$var$MigratingFromDropdown, (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                onChangeHandler: (migrationPath)=>{
                                    setFieldValue("migrationPath", migrationPath);
                                    setShowProductField(true);
                                    setMigrationDirection(migrationPath);
                                    fieldProps.onChange;
                                }
                            })),
                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                children: migratingFromErrorMessage
                            })
                        ]
                    })
            })
        });
    };
    const ProductSelectorDropdown = ({ onChangeHandler: onChangeHandler })=>{
        const [selectedOption, setSelectedOption] = (0, $1oC0p.useState)("");
        const onClick = (event)=>{
            const selected = String(event.target.value);
            setSelectedOption(selected);
            onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler(selected);
        };
        const intl = (0, $8e22h.default)();
        const jiraSoftwareOption = intl.formatMessage({
            id: migrationDirection !== "Server to Data Center" ? "migrationOptions.jira" : "migrationOptions.jiraSoftware",
            defaultMessage: migrationDirection !== "Server to Data Center" ? "Jira" : "Jira Software"
        });
        const confluenceOption = intl.formatMessage({
            id: "migrationOptions.confluence",
            defaultMessage: "Confluence"
        });
        const bitbucketOption = intl.formatMessage({
            id: "migrationOptions.bitbucket",
            defaultMessage: "Bitbucket"
        });
        const crowdOption = intl.formatMessage({
            id: "migrationOptions.crowd",
            defaultMessage: "Crowd"
        });
        const jsmOption = intl.formatMessage({
            id: "migrationOptions.jsm",
            defaultMessage: "Jira Service Management"
        });
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
            id: "options",
            value: selectedOption,
            onChange: onClick,
            "data-testid": "migration-options-product-dropdown",
            className: (0, $2jatx.default)([
                "_4cvr1h6o _vchhusvi _1e0c1ule _ca0q1skh _u5f38vuz _n3td1crf _19bv1crf _1tkeckbl _1reoewfl _18m9ewfl _1bsb1osq _ect418gv _1iqs4jg8 _66a41wug _1pyn1wug _1wyb7vkz _1nx91osq _zg8l4jg8 _k48p1nn1 _1dyz4jg8 _vwz4cjiy _y3gn1e5h _azhwidpf _w19jglyw _1p1dglyw _3fcw1q9c _d5ymcfaq _1ccq4jg8 _syaz1bqd _bfhk1hxd _2rko14y2 _1itk1kto _1xys1hni _uokl1vk8 _12veeva1 _1lrw1yzm _lv3yidpf _wii51fhb _1rx61osq _19itglyw _80omtlke _wstuglyw _irr3uzct _nt751r31 _49pcglyw _1hvw1o36 _1ohht94y _1ya5nqa1 _858uu7gi _mizu1r31 _ra3xglyw _128m1o36 _1lwit94y _10knnqa1 _pojju7gi"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: ""
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: jiraSoftwareOption,
                    children: jiraSoftwareOption
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: "Confluence",
                    children: confluenceOption
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: "Bitbucket",
                    children: bitbucketOption
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: "Crowd",
                    children: crowdOption
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: "Jira Service Management",
                    children: jsmOption
                })
            ]
        });
    };
    const ProductField = (setFieldValue)=>{
        return showProductField && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q5114no"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                name: "product",
                label: intl.formatMessage({
                    id: "migrationOptions.product",
                    defaultMessage: "Which product are you inquiring about?"
                }) + " *",
                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)(ProductSelectorDropdown, (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                onChangeHandler: (product)=>{
                                    setFieldValue("product", product);
                                    fieldProps.onChange;
                                }
                            })),
                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                children: productErrorMessage
                            }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                children: intl.formatMessage({
                                    id: "migrationOptions.productHelper",
                                    defaultMessage: "If you want to migrate multiple products, select the one with the most users."
                                })
                            })
                        ]
                    })
            })
        });
    };
    const numberOfUsersProductErrorMessage = (0, $8e22h.default)().formatMessage({
        id: "migrationOptions.numberOfUsersProductErrorMessage",
        defaultMessage: "Enter the number of users for this product."
    });
    const WhatDoYouWantToLearnField = (setFieldValue)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q5114no _85i514no"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                name: "formChoices",
                label: intl.formatMessage({
                    id: "migrationOptions.whatDoYouWantToLearn",
                    defaultMessage: "What do you want to learn about migrations?"
                }) + " *",
                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($d0aa98f0fec04aa1$var$LearnAboutMigrationsDropdown, (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                onChangeHandler: (formChoice)=>{
                                    setFieldValue("formChoices", formChoice);
                                    fieldProps.onChange;
                                }
                            })),
                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                children: whatDoYouWantToLearnErrorMessage
                            }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                children: learnAboutMigrationsPrompt
                            })
                        ]
                    })
            })
        });
    const FooterSection = (onSubmit)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                        inputType: "button",
                        text: intl.formatMessage({
                            id: "migrationOptions.submit",
                            defaultMessage: "Submit"
                        }),
                        type: "primary",
                        color: isInvalid ? "gray" : "darkblue",
                        onClick: ()=>{
                            onSubmit();
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "post-submit",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        children: intl.formatMessage({
                            id: "migrationOptions.submitError",
                            defaultMessage: "An error has occurred. Please try again later."
                        })
                    })
                })
            ]
        });
    const loggedOutView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
        selectedProduct: selectedProduct,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_syazvwuj _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)(SubTextSection, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                            onSubmit: handleSubmit,
                            children: ({ formProps: formProps, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                                    className: (0, $2jatx.default)([
                                        "_1bsb1osq _18dc18gv _ytel1j6v _jgjs8pqr _wdh21du8 _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961du8 _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1hxd _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r1jbj _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _16w9idpf _lyghidpf _x68d1hxd _1c8s1j28 _wqgkviql _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1du8"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                name: "email",
                                                label: yourCompanyEmailPrompt + " *",
                                                validate: (value)=>{
                                                    setFieldValue("email", value);
                                                },
                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                value: fieldProps.value || "",
                                                                onBlur: handleBlurEvent
                                                            })),
                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                children: errorMessageText === "NOT_EMAIL" ? notEmailErrorMessage : errorMessageText === "PERSONAL_DOMAIN" ? personalDomainErrorMessage : error
                                                            }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                children: personalEmailDomainsErrorPrompt
                                                            })
                                                        ]
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                    layout: "6-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                            name: "firstName",
                                                            label: intl.formatMessage({
                                                                id: "migrationOptions.forename",
                                                                defaultMessage: "First name"
                                                            }) + " *",
                                                            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                            value: fieldProps.value || "",
                                                                            onBlur: handleBlurEvent
                                                                        })),
                                                                        error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                            children: firstNameErrorMessage
                                                                        })
                                                                    ]
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                            name: "lastName",
                                                            label: intl.formatMessage({
                                                                id: "migrationOptions.surname",
                                                                defaultMessage: "Last name"
                                                            }) + " *",
                                                            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                            value: fieldProps.value || "",
                                                                            onBlur: handleBlurEvent
                                                                        })),
                                                                        error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                            children: lastNameErrorMessage
                                                                        })
                                                                    ]
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                    layout: "6-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                            name: "company",
                                                            label: intl.formatMessage({
                                                                id: "migrationOptions.company",
                                                                defaultMessage: "Company"
                                                            }) + " *",
                                                            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                            value: fieldProps.value || "",
                                                                            onBlur: handleBlurEvent
                                                                        })),
                                                                        error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                            children: companyErrorMessage
                                                                        })
                                                                    ]
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                            name: "title",
                                                            label: intl.formatMessage({
                                                                id: "migrationOptions.title",
                                                                defaultMessage: "Job title"
                                                            }) + " *",
                                                            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                            value: fieldProps.value || "",
                                                                            onBlur: handleBlurEvent
                                                                        })),
                                                                        error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                            children: jobTitleErrorMessage
                                                                        })
                                                                    ]
                                                                })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
                                            children: [
                                                MigrationFromField(setFieldValue),
                                                ProductField(setFieldValue),
                                                (0, $3bkHm.NumberOfUsersField)(setFieldValue),
                                                WhatDoYouWantToLearnField(setFieldValue),
                                                (0, $e0MOs.QuestionField)("migration-options", handleBlurEvent)
                                            ]
                                        }),
                                        (0, $lBgvn.ConsentInfo)(setFieldValue),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gacwQ.default), {
                                            align: "start",
                                            children: FooterSection(formProps.onSubmit)
                                        })
                                    ]
                                }))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Fvhz.default), {})
            ]
        })
    });
    const loggedInView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
        selectedProduct: selectedProduct,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_syazvwuj _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)(SubTextSection, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                            onSubmit: handleSubmit,
                            children: ({ formProps: formProps, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                                    className: (0, $2jatx.default)([
                                        "_1bsb1osq _18dc18gv _ytel1j6v _jgjs8pqr _wdh21du8 _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961du8 _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1hxd _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r1jbj _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _16w9idpf _lyghidpf _x68d1hxd _1c8s1j28 _wqgkviql _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1du8"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            children: intl.formatMessage({
                                                id: "migrationOptions.contactInfo",
                                                defaultMessage: "You're logged in as:"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                            children: setFieldValue("email", userInfo.email)
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                            children: setFieldValue("name", userInfo.name)
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                            className: (0, $2jatx.default)([
                                                "_1wyb1k92"
                                            ]),
                                            children: [
                                                userInfo.name,
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                                userInfo.email
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1wyboqnp _syazrbzz _59381r31 _yha2glyw _1nmznqa1 _43dsrbzz _1hw71o8l _1r8v1ul9 _1enu1j6v _6b8d1j28"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                    href: "#changeContactInfo",
                                                    onClick: ()=>setChangeContactInfo(true),
                                                    children: [
                                                        intl.formatMessage({
                                                            id: "migrationOptions.updateInfo",
                                                            defaultMessage: "Update contact info"
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_z6uan7od"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                label: ""
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                    href: getSwitchAccountURL(),
                                                    children: [
                                                        intl.formatMessage({
                                                            id: "migrationOptions.differentAccount",
                                                            defaultMessage: "Log in with a different Atlassian account"
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_z6uan7od"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                label: ""
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                name: "title",
                                                label: intl.formatMessage({
                                                    id: "migrationOptions.yourJobTitle",
                                                    defaultMessage: "Your job title"
                                                }) + " *",
                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                value: fieldProps.value || "",
                                                                onBlur: handleBlurEvent
                                                            })),
                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                children: jobTitleErrorMessage
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                children: intl.formatMessage({
                                                                    id: "migrationOptions.yourJobTitleHelper",
                                                                    defaultMessage: "We ask this to connect you to the best expert for your role."
                                                                })
                                                            })
                                                        ]
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
                                            children: [
                                                MigrationFromField(setFieldValue),
                                                ProductField(setFieldValue),
                                                (0, $3bkHm.NumberOfUsersField)(setFieldValue),
                                                WhatDoYouWantToLearnField(setFieldValue),
                                                (0, $e0MOs.QuestionField)("migration-options", handleBlurEvent)
                                            ]
                                        }),
                                        (0, $lBgvn.ConsentInfo)(setFieldValue),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gacwQ.default), {
                                            align: "start",
                                            children: FooterSection(formProps.onSubmit)
                                        })
                                    ]
                                }))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Fvhz.default), {})
            ]
        })
    });
    if (userInfo.isUserLoggedIn && userInfo.email) {
        if (isPersonalDomain(userInfo.email) || userInfo.email.includes("atlassian.com") || changeContactInfo) return loggedOutView;
        else return loggedInView;
    }
    return loggedOutView;
};
var $d0aa98f0fec04aa1$export$2e2bcd8739ae039 = $d0aa98f0fec04aa1$var$MigrationOptions;

});
parcelRegister("lBgvn", function(module, exports) {
$parcel$export(module.exports, "ConsentInfo", function () { return $1d00cd15230eb761$export$99cac8d72a646928; });
/* consent-info.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");
var $kR3EL = parcelRequire("kR3EL");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $hhv63 = parcelRequire("hhv63");
const $1d00cd15230eb761$var$privacyPolicyParagraphStyle = null;
const $1d00cd15230eb761$var$linkStyle = null;
const $1d00cd15230eb761$var$consentBoxTextStyle = null;
const $1d00cd15230eb761$export$99cac8d72a646928 = (setFieldValue)=>{
    const locale = (0, $hhv63.useConsentHubClientConfig)();
    const intl = (0, $8e22h.default)();
    const privacyLink = (0, $kooLp.useLocalizedHref)("/legal/privacy-policy");
    const [showConsent, setShowConsent] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        if (!locale.localeRequiresMarketingCommunicationOptIn) {
            setShowConsent(false);
            setFieldValue("consent", true);
        }
    }, [
        locale.localeRequiresMarketingCommunicationOptIn,
        setFieldValue
    ]);
    const PrivacyPolicyComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            className: (0, $2jatx.default)([
                "_syazvwuj"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "enterpriseContactSales.privacyPolicy",
                defaultMessage: "By submitting this form, I acknowledge receipt of Atlassian's <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    privacyPolicyLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                            text: text,
                            href: privacyLink,
                            type: "inline",
                            className: (0, $2jatx.default)([
                                "_30l3r3uz _1up4glyw _9oik1r31 _1bnx8stv _jf4cnqa1"
                            ])
                        })
                })
            })
        })
    });
    const ConsentComponent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
        name: "consent",
        children: (_param)=>{
            var { fieldProps: { isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid } } = _param, validProps = (0, $aPnCa._)(_param.fieldProps, [
                "isRequired",
                "isDisabled",
                "isInvalid"
            ]);
            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("input", (0, $6ogO3._)({
                        type: "checkbox"
                    }, validProps)),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                        htmlFor: "consent",
                        className: (0, $2jatx.default)([
                            "_ect4hikz _1wyb7vkz _k48pbfng _vwz4bs82 _syazvwuj"
                        ]),
                        children: intl.formatMessage({
                            id: "enterpriseContactSales.consent",
                            defaultMessage: "Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates."
                        })
                    })
                ]
            });
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
            children: [
                PrivacyPolicyComponent,
                showConsent && ConsentComponent
            ]
        })
    });
};

});

parcelRegister("3bkHm", function(module, exports) {
$parcel$export(module.exports, "NumberOfUsersField", function () { return $9a66b9fcb0b09791$export$350ae1f4a524679c; });
$parcel$export(module.exports, "NumberOfUsersInput", function () { return $9a66b9fcb0b09791$export$ff93b145cbbace9e; });
/* number-of-users-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $ff3wF = parcelRequire("ff3wF");
var $igGC3 = parcelRequire("igGC3");
const $9a66b9fcb0b09791$export$bc90e1fab1ccc92 = {
    id: "migrationOptions.numberOfUsersProductErrorMessage",
    defaultMessage: "Enter the number of users for this product."
};
const $9a66b9fcb0b09791$export$350ae1f4a524679c = (setFieldValue)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1q5114no"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            name: "numberOfUsers",
            label: (0, $8e22h.default)().formatMessage({
                id: "migrationOptions.numberOfUsersForProduct",
                defaultMessage: "Number of users for this product"
            }) + " *",
            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($9a66b9fcb0b09791$export$ff93b145cbbace9e, (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                            onChangeHandler: (numberOfUsers)=>{
                                setFieldValue("numberOfUsers", Number(numberOfUsers));
                                fieldProps.onChange;
                            }
                        })),
                        error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                            children: intl.formatMessage($9a66b9fcb0b09791$export$bc90e1fab1ccc92)
                        })
                    ]
                })
        })
    });
};
const $9a66b9fcb0b09791$export$ff93b145cbbace9e = ({ onChangeHandler: onChangeHandler })=>{
    const [numberOfUsers, setNumberOfUsers] = (0, $1oC0p.useState)("");
    const inputStyle = null;
    const handleChange = (event)=>{
        const inputValue = event.target.value;
        setNumberOfUsers(inputValue);
        onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler(inputValue);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
        type: "number",
        min: "1",
        value: numberOfUsers,
        onChange: handleChange,
        className: (0, $2jatx.default)([
            "_vchhusvi _1e0c1ule _bozgw1gv _y4tigktf _1tkeckbl _1bsb1osq _k48p1nn1 _1dyz4jg8 _y3gnv2br _vwz4cs5v _2rko14y2 _syaz1bqd _bfhk1hxd _19itglyw _lv3yidpf _wii51fhb _1rx61osq _80om1kdv _wstuglyw _858uu7gi _1ya5nqa1 _1mb8t94y _nt751r31 _49pcglyw _1hvwidpf _pojju7gi _10knnqa1 _1wyst94y _mizu1r31 _ra3xglyw _128midpf"
        ])
    });
};

});

parcelRegister("izhAl", function(module, exports) {
$parcel$export(module.exports, "SelectedProductProvider", function () { return $fc81eb68b85a0e06$export$62e7d2f649413b82; });
$parcel$export(module.exports, "ProductSelector", function () { return $fc81eb68b85a0e06$export$2e2ab7553631f1f9; });
/* product-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $3L8ZR = parcelRequire("3L8ZR");

var $5RBBI = parcelRequire("5RBBI");

var $99VqK = parcelRequire("99VqK");
var $4HBPY = parcelRequire("4HBPY");

var $lawKK = parcelRequire("lawKK");
var $9T4IS = parcelRequire("9T4IS");
var $6dioi = parcelRequire("6dioi");

var $2tb46 = parcelRequire("2tb46");

var $32ng3 = parcelRequire("32ng3");

var $89erU = parcelRequire("89erU");
const $fc81eb68b85a0e06$var$SelectedProductContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    selectedProduct: ""
});
const $fc81eb68b85a0e06$export$387e1da2bc9c93cc = ()=>{
    const context = (0, $1oC0p.useContext)($fc81eb68b85a0e06$var$SelectedProductContext);
    if (!context) throw new Error("useSelectedProduct must be used within a SelectedProductProvider");
    return context;
};
const $fc81eb68b85a0e06$export$62e7d2f649413b82 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($fc81eb68b85a0e06$var$SelectedProductContext.Provider, {
        value: {
            selectedProduct: props.selectedProduct
        },
        children: props.children
    });
};
const $fc81eb68b85a0e06$var$prefillableProducts = {
    rovo: "Rovo"
};
const $fc81eb68b85a0e06$var$cloudPlatform = "Cloud";
const $fc81eb68b85a0e06$var$customTabStyles = (0, $4HBPY.xcss)({
    alignItems: "flex-start",
    boxSizing: "border-box",
    display: "block",
    fontFamily: `"Charlie Text", -apple-system, "system-ui", "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`,
    fontFeatureSettings: "normal",
    fontKerning: "auto",
    fontOpticalSizing: "auto",
    fontSize: "16px",
    fontStretch: "100%",
    fontStyle: "normal",
    fontVariationSettings: "normal",
    fontWeight: "400",
    letterSpacing: "normal",
    lineHeight: "normal",
    textAlign: "center",
    textIndent: "0px",
    textShadow: "none",
    textTransform: "none",
    wordSpacing: "0px"
});
const $fc81eb68b85a0e06$var$getDataEventProps = (text, key)=>{
    return {
        "data-label": text || "",
        "data-product-key": key || "",
        "data-event-component": "link",
        "data-event-container": "productSelector",
        "data-event": "clicked",
        "data-label-english": text
    };
};
const $fc81eb68b85a0e06$var$CustomTab = ({ label: label })=>{
    const tabAttributes = (0, $6dioi.useTab)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $99VqK.default), (0, $dPABA._)((0, $6ogO3._)({
        xcss: $fc81eb68b85a0e06$var$customTabStyles
    }, tabAttributes), {
        children: label
    }));
};
const $fc81eb68b85a0e06$export$e8adbb537d20ae7e = "Data Center";
const $fc81eb68b85a0e06$export$d82021d7cba718da = [
    {
        key: "jira-software",
        text: "Jira Software",
        dataEventProps: {
            "data-product-key": "jiraSoftware"
        }
    },
    {
        key: "confluence",
        text: "Confluence",
        dataEventProps: {
            "data-product-key": "confluence"
        }
    },
    {
        key: "jira-service-management",
        text: "Jira Service Management",
        dataEventProps: {
            "data-product-key": "jiraServiceManagement"
        }
    },
    {
        key: "bitbucket",
        text: "Bitbucket",
        dataEventProps: {
            "data-product-key": "bitbucket"
        }
    },
    {
        key: "bamboo",
        text: "Bamboo",
        dataEventProps: {
            "data-product-key": "bamboo"
        }
    },
    {
        key: "crowd",
        text: "Crowd",
        dataEventProps: {
            "data-product-key": "crowd"
        }
    }
];
const $fc81eb68b85a0e06$var$DCTab = ({ onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    const premierSupportText = intl.formatMessage({
        id: "migrationProductSelector.premierSupport",
        defaultMessage: "Premier Support"
    });
    const prioritySupportText = intl.formatMessage({
        id: "migrationProductSelector.prioritySupport",
        defaultMessage: "Priority Support"
    });
    const advisoryServicesText = intl.formatMessage({
        id: "migrationProductSelector.advisoryServices",
        defaultMessage: "Advisory Services"
    });
    const tabPanelAttributes = (0, $6dioi.useTabPanel)();
    const dataCenterProductsText = intl.formatMessage({
        id: "migrationProductSelector.dataCenterProducts",
        defaultMessage: "Data Center Products"
    });
    const dataCenterServicesLinkButtonProps = [
        {
            key: "premier-support",
            // text is internationalized here, but we don't want to use the internalized text
            // for the data-label-english attribute; but do we want to use it for the data-label
            // attribute? i think we should use the internalized text for the data-label attribute
            // but currently in prod it isn't internationalized
            text: premierSupportText,
            dataEventProps: {
                "data-label": "Premier Support",
                "data-label-english": "Premier Support",
                "data-product-key": "support"
            }
        },
        {
            key: "priority-support",
            text: prioritySupportText,
            dataEventProps: {
                "data-label": "Priority Support",
                "data-label-english": "Priority Support",
                "data-product-key": "support"
            }
        },
        {
            key: "advisory-services",
            text: advisoryServicesText,
            dataEventProps: {
                "data-label": "Advisory Services",
                "data-label-english": "Advisory Services",
                "data-product-key": "support"
            }
        }
    ];
    const servicesText = intl.formatMessage({
        id: "migrationProductSelector.services",
        defaultMessage: "Services"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", (0, $dPABA._)((0, $6ogO3._)({}, tabPanelAttributes), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                headerType: "h5",
                headerText: dataCenterProductsText,
                bodyComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: $fc81eb68b85a0e06$export$d82021d7cba718da.map(({ key: key, text: text, dataEventProps: dataEventProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $89erU.Option), (0, $dPABA._)((0, $6ogO3._)({}, $fc81eb68b85a0e06$var$getDataEventProps(text, key), dataEventProps), {
                            onClick: onClick($fc81eb68b85a0e06$export$e8adbb537d20ae7e),
                            children: text
                        }), key))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                headerText: servicesText,
                headerType: "h5",
                bodyComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: dataCenterServicesLinkButtonProps.map(({ key: key, text: text, dataEventProps: dataEventProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $89erU.Option), (0, $dPABA._)((0, $6ogO3._)({}, $fc81eb68b85a0e06$var$getDataEventProps(text, key), dataEventProps), {
                            onClick: onClick($fc81eb68b85a0e06$export$e8adbb537d20ae7e),
                            children: text
                        }), key))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthgktf"
                ])
            })
        ]
    }));
};
const $fc81eb68b85a0e06$var$CloudTab = ({ pageType: pageType, onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    const removeRovoFromPricingPage = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp5682RemoveRovoFromPricingForm);
    const isOpsgenieEOL = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp6474RemoveOpsgenieContactSalesForm);
    const isRovoEnabled = (0, $3L8ZR.default).checkGate("wac-rovo-enterprise-contact-sales");
    const isLoomEnabled = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-loom");
    const isJsmRepackagingEnabled = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-jsm-repackaging");
    const isTwCEnabled = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-twc");
    const isStrategyCollectionEnabled = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-strategy-collection");
    const isServiceCollectionEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8165EnterpriseContactServiceCollection);
    const isBackupRestoreEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9763BackupRestoreContactForm);
    const isAdditionalSandboxEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9608AdditionalSandboxContactForm);
    const cloudProductsText = intl.formatMessage({
        id: "migrationProductSelector.cloudProducts",
        defaultMessage: "Cloud Products"
    });
    const servicesText = intl.formatMessage({
        id: "migrationProductSelector.services",
        defaultMessage: "Services"
    });
    const advisoryServicesText = intl.formatMessage({
        id: "migrationProductSelector.advisoryServices",
        defaultMessage: "Advisory Services"
    });
    const cloudProductsLinkButtonProps = [
        {
            key: "atlassian-access",
            text: "Atlassian Guard",
            dataEventProps: {
                "data-product-key": "atlassianGuard"
            }
        },
        {
            key: "bitbucket",
            text: "Bitbucket",
            dataEventProps: {
                "data-product-key": "bitbucket"
            }
        },
        {
            key: "compass",
            text: "Compass",
            dataEventProps: {
                "data-product-key": "compass"
            }
        },
        {
            key: "confluence",
            text: "Confluence",
            dataEventProps: {
                "data-product-key": "confluence"
            }
        },
        ...isBackupRestoreEnabled ? [
            {
                key: "confluence-cloud-backup-restore",
                text: "Confluence Cloud Backup and Restore",
                dataEventProps: {
                    "data-product-key": "confluenceCloudBackupRestore"
                }
            }
        ] : [],
        ...isAdditionalSandboxEnabled ? [
            {
                key: "confluence-additional-sandbox",
                text: "Confluence Additional Sandbox",
                dataEventProps: {
                    "data-product-key": "confluenceAdditionalSandbox"
                }
            }
        ] : [],
        {
            key: "jira",
            text: "Jira",
            dataEventProps: {
                "data-product-key": "jira"
            }
        },
        ...!isTwCEnabled ? [
            {
                key: "jira-align",
                text: "Jira Align",
                dataEventProps: {
                    "data-product-key": "jiraAlign"
                }
            }
        ] : [],
        ...isBackupRestoreEnabled ? [
            {
                key: "jira-cloud-backup-restore",
                text: "Jira Cloud Backup and Restore",
                dataEventProps: {
                    "data-product-key": "jiraCloudBackupRestore"
                }
            }
        ] : [],
        {
            key: "jira-product-discovery",
            text: "Jira Product Discovery",
            dataEventProps: {
                "data-product-key": "jiraProductDiscovery"
            }
        },
        {
            key: "jira-service-management",
            text: "Jira Service Management",
            dataEventProps: {
                "data-product-key": "jiraServiceManagement"
            }
        },
        ...isJsmRepackagingEnabled ? [
            {
                key: "jira-service-management-assets",
                text: "Jira Service Management Assets",
                dataEventProps: {
                    "data-product-key": "jiraServiceManagementAssets"
                }
            },
            {
                key: "jira-service-management-virtual-service-agent",
                text: "Jira Service Management Virtual Service Agent",
                dataEventProps: {
                    "data-product-key": "jiraServiceManagementVirtualServiceAgent"
                }
            }
        ] : [],
        ...isBackupRestoreEnabled ? [
            {
                key: "jira-service-management-cloud-backup-restore",
                text: "Jira Service Management Cloud Backup and Restore",
                dataEventProps: {
                    "data-product-key": "jiraServiceManagementCloudBackupRestore"
                }
            }
        ] : [],
        ...isAdditionalSandboxEnabled ? [
            {
                key: "jira-additional-sandbox",
                text: "Jira Additional Sandbox",
                dataEventProps: {
                    "data-product-key": "jiraAdditionalSandbox"
                }
            }
        ] : [],
        ...isAdditionalSandboxEnabled ? [
            {
                key: "jira-product-discovery-additional-sandbox",
                text: "Jira Product Discovery Additional Sandbox",
                dataEventProps: {
                    "data-product-key": "jiraProductDiscoveryAdditionalSandbox"
                }
            }
        ] : [],
        ...isAdditionalSandboxEnabled ? [
            {
                key: "jira-service-management-additional-sandbox",
                text: "Jira Service Management Additional Sandbox",
                dataEventProps: {
                    "data-product-key": "jiraServiceManagementAdditionalSandbox"
                }
            }
        ] : [],
        ...isLoomEnabled ? [
            {
                key: "loom",
                text: "Loom",
                dataEventProps: {
                    "data-product-key": "loom"
                }
            }
        ] : [],
        ...!isOpsgenieEOL ? [
            {
                key: "opsgenie",
                text: "Opsgenie",
                dataEventProps: {
                    "data-product-key": "opsgenie"
                }
            }
        ] : [],
        ...isRovoEnabled && (!removeRovoFromPricingPage || pageType !== "pricing-quotes") ? [
            {
                key: "rovo",
                text: "Rovo",
                dataEventProps: {
                    "data-product-key": "rovo"
                }
            }
        ] : [],
        ...isServiceCollectionEnabled ? [
            {
                key: "service-collection",
                text: "Service Collection",
                dataEventProps: {
                    "data-product-key": "serviceCollection"
                }
            }
        ] : [],
        ...isStrategyCollectionEnabled ? [
            {
                key: "strategy-collection",
                text: "Strategy Collection",
                dataEventProps: {
                    "data-product-key": "strategyCollection"
                }
            }
        ] : [],
        ...isTwCEnabled ? [
            {
                key: "teamwork-collection",
                text: "Teamwork Collection",
                dataEventProps: {
                    "data-product-key": "teamworkCollection"
                }
            }
        ] : [],
        {
            key: "trello",
            text: "Trello",
            dataEventProps: {
                "data-product-key": "trello"
            }
        }
    ];
    const tabPanelAttributes = (0, $6dioi.useTabPanel)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", (0, $dPABA._)((0, $6ogO3._)({}, tabPanelAttributes), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                headerType: "h5",
                orientation: "vertical",
                headerText: cloudProductsText,
                bodyComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: cloudProductsLinkButtonProps.map(({ key: key, text: text, dataEventProps: dataEventProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $89erU.Option), (0, $dPABA._)((0, $6ogO3._)({}, $fc81eb68b85a0e06$var$getDataEventProps(text, key), dataEventProps), {
                            onClick: onClick($fc81eb68b85a0e06$var$cloudPlatform),
                            children: text
                        }), key))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                headerText: servicesText,
                headerType: "h5",
                orientation: "vertical",
                bodyComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $89erU.Option), (0, $dPABA._)((0, $6ogO3._)({}, $fc81eb68b85a0e06$var$getDataEventProps(advisoryServicesText, "advisoryServices")), {
                        "data-label": "Advisory Services",
                        "data-label-english": "Advisory Services",
                        onClick: onClick($fc81eb68b85a0e06$var$cloudPlatform),
                        children: advisoryServicesText
                    }), "advisoryServices")
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthgktf"
                ])
            })
        ]
    }));
};
const $fc81eb68b85a0e06$export$2e2ab7553631f1f9 = ({ onChangeHandler: onChangeHandler, pageType: pageType })=>{
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const toggleOpen = ()=>{
        setIsOpen(!isOpen);
    };
    const [selectedOption, setSelectedOption] = (0, $1oC0p.useState)("");
    (0, $1oC0p.useEffect)(()=>{
        if (selectedOption === "") {
            var _urlParams_get;
            const urlParams = new URLSearchParams(window.location.search);
            const initialProduct = (_urlParams_get = urlParams.get("product")) === null || _urlParams_get === void 0 ? void 0 : _urlParams_get.toLowerCase();
            if (initialProduct && $fc81eb68b85a0e06$var$prefillableProducts[initialProduct]) {
                setSelectedOption($fc81eb68b85a0e06$var$prefillableProducts[initialProduct]);
                onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler(initialProduct, $fc81eb68b85a0e06$var$cloudPlatform);
            }
        }
    }, [
        onChangeHandler,
        selectedOption
    ]);
    const productSelectorButtonStyle = [
        isOpen && null,
        !isOpen && null
    ];
    const productSelectorStyle = [
        isOpen && null,
        !isOpen && null
    ];
    const divCss = null;
    const onClick = (platform)=>(event)=>{
            const selected = String(event.currentTarget.dataset["label"]);
            setSelectedOption(selected);
            onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler(selected, platform);
            toggleOpen();
        };
    const tabs = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lawKK.default), {
        id: "product-selector",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9T4IS.default), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($fc81eb68b85a0e06$var$CustomTab, {
                        label: "Cloud"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($fc81eb68b85a0e06$var$CustomTab, {
                        label: "Data Center"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($fc81eb68b85a0e06$var$CloudTab, {
                pageType: pageType || "product-features",
                onClick: onClick
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($fc81eb68b85a0e06$var$DCTab, {
                onClick: onClick
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ect41flk _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1bsb1osq",
            "product-selector"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                type: "button",
                onClick: toggleOpen,
                className: (0, $2jatx.default)([
                    isOpen && "_1h6d1j28 _2rko1y44 _80omtlke _1e0c1txw _2lx2vrvc _1bah1yb4 _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4cvr1h6o _1qi0cs5v _tgs01j6v _rkvr1j6v _rywr1r31 _q4l3glyw _1ruunqa1 _n75918gv _1tp5usic _mdp01sub",
                    !isOpen && "_1h6d1j28 _2rko1y44 _80omtlke _1e0c1txw _2lx2vrvc _1bah1yb4 _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4cvr1h6o _1qi0cs5v _tgs01j6v _rkvr1j6v _rywr1r31 _q4l3glyw _1ruunqa1 _n75918gv _1tp5usic"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: "selected-option",
                        children: selectedOption
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: "arrow-down-icon",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                            label: isOpen ? "close menu" : "open menu"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    isOpen && "_1e0c1txw _2lx21bp4 _10ojagmp _1bsb1osq _1c3y1txw _5sqh1bp4 _1b2k11yk _hkvy1j6v _1yhx1nn1 _1qupo7ao _1v7hftgi _mcleo7ao _1at0ftgi _1ay04jg8 _1uf74jg8 _1quzr3uz _18z11y6m _1brjusvi _1cqa1ule _r10m4jg8 _26ke1wug _grvr1wug _1bh11osq _1snl4jg8 _rsv71h6o _g8j8idpf _wpl2glyw _143dglyw _1805idpf _1oazrbzz _163zrbzz _1n21tlke _1lpynqa1 _m2u8o7ao _1xi1ftgi _90o8o7ao _44jqftgi _18qtnkcj _12kz1j6v _aodzidpf _1k241j6v _1r6eidpf _hyslidpf _zvomidpf _xwbgidpf _esyridpf _o7cbnsd6 _mvqe18gv _auaybfng _aazrangw _ixhlt94y _1j8d1crf _1nazoqnp _1ee81txw _11of1bp4 _ow6u1y6m _1k99ftgi _13hxidpf _1f22ftgi _e0zmidpf _11c81nn1 _efjridpf _zqslidpf _3bxtidpf _1w8gidpf _8xawidpf _144pidpf _la7qidpf _ier6idpf _1d2yr3uz _115iglyw _5dta1r31 _69rz8stv _k2o0nqa1 _a8d3idpf",
                    !isOpen && "_1e0cglyw _10ojagmp _1bsb1osq _1c3y1txw _5sqh1bp4 _12kz1j6v _aodzidpf _1k241j6v _1r6eidpf _hyslidpf _zvomidpf _xwbgidpf _esyridpf _o7cbnsd6 _mvqe18gv _auaybfng _aazrangw _ixhlt94y _1j8d1crf _1nazoqnp _1ee81txw _11of1bp4 _ow6u1y6m _11c81nn1 _efjridpf _zqslidpf _3bxtidpf _1w8gidpf _8xawidpf _144pidpf _la7qidpf _ier6idpf _1d2yr3uz _115iglyw _5dta1r31 _69rz8stv _k2o0nqa1 _a8d3idpf"
                ]),
                children: tabs
            })
        ]
    });
};

});
parcelRegister("89erU", function(module, exports) {
$parcel$export(module.exports, "Option", function () { return $f00f8e60e73cfd39$export$36d18380658d5d20; });
/* option.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
// link colors matching the link component's anchor styles
const $f00f8e60e73cfd39$var$linkColors = {
    defaultColor: (0, $kbpa7.wacToken)("color.extended.blue700"),
    hoverColor: (0, $kbpa7.wacToken)("color.primary.black"),
    visitedColor: (0, $kbpa7.wacToken)("color.extended.purple800"),
    visitedHoverColor: (0, $kbpa7.wacToken)("color.primary.black")
};
const $f00f8e60e73cfd39$var$linkStyle = null;
const $f00f8e60e73cfd39$export$36d18380658d5d20 = (_param)=>{
    var { children: children, onClick: onClick, isSelected: isSelected = false } = _param, props = (0, $aPnCa._)(_param, [
        "children",
        "onClick",
        "isSelected"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", (0, $dPABA._)((0, $6ogO3._)({
        role: "option",
        tabIndex: 0,
        onClick: onClick,
        onKeyDown: (e)=>{
            // keyboard navigation for accessibility
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                // create a synthetic mouse event for consistency
                const syntheticEvent = (0, $dPABA._)((0, $6ogO3._)({}, e), {
                    currentTarget: e.currentTarget,
                    target: e.target
                });
                onClick(syntheticEvent);
            }
        },
        "aria-selected": isSelected
    }, props), {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _syazlodj _4bfu1r31 _1hmsglyw _ajmmnqa1 _vwz419ii _1wyb1j6v _ect41pz4 _80omtlke _ca0qftgi _n3tdftgi _f8pj19l6 _30l319l6 _1a3b1r31 _9oik1r31 _4fpr8stv _1bnx8stv _5goinqa1 _jf4cnqa1 _16btglyw _1up4glyw _1ygb1djl _1ah3yh40 _10531e6u _1ien1q9n _n0fx1q9n _1csf1r31 _l4td1r31 _nb418stv _snj98stv _32m2nqa1 _6afsnqa1"
        ]),
        style: {
            "--_ka49s4": (0, $6ZVlx.default)($f00f8e60e73cfd39$var$linkColors.defaultColor),
            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
            "--_hxrey7": (0, $6ZVlx.default)($f00f8e60e73cfd39$var$linkColors.hoverColor),
            "--_2z8vrb": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue600")),
            "--_19vwxf9": (0, $6ZVlx.default)($f00f8e60e73cfd39$var$linkColors.visitedColor),
            "--_1w8orp1": (0, $6ZVlx.default)($f00f8e60e73cfd39$var$linkColors.visitedHoverColor)
        },
        children: children
    }));
};

});


parcelRegister("e0MOs", function(module, exports) {
$parcel$export(module.exports, "QuestionField", function () { return $e9b303a7e1bca2e6$export$10bcf938e190348c; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $ff3wF = parcelRequire("ff3wF");
var $igGC3 = parcelRequire("igGC3");

var $P90vo = parcelRequire("P90vo");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");
const $e9b303a7e1bca2e6$export$10bcf938e190348c = (formType, onBlur)=>{
    const intl = (0, $8e22h.default)();
    const yourQuestionErrorMessage = intl.formatMessage({
        id: "productFeatures.yourQuestionErrorMessage",
        defaultMessage: "Please provide a question."
    });
    const yourQuestionHelperMessageSupportEn = formType === "migration-options" ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "enterpriseContactSales.yourQuestionHelper.entIdentifier",
        defaultMessage: "Include details like your SENs, ENs or Cloud URLs you're migrating from."
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "pricingQuotes.yourQuestionHelper.includeDetails.entIdentifier",
        defaultMessage: "Include details like your SENs (SEN-123456), ENs (E-XXX) or if you started a trial."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
        name: "opportunity_Description__c",
        label: intl.formatMessage({
            id: "enterpriseContactSales.yourQuestion",
            defaultMessage: "Your question"
        }) + " *",
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $P90vo.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                        onBlur: onBlur
                    })),
                    error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                        children: yourQuestionErrorMessage
                    }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                        children: yourQuestionHelperMessageSupportEn
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $ff3wF.HelperMessage), {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "enterpriseContactSales.yourQuestionHelper.findYourSen.entIdentifier",
                                defaultMessage: "Product admins, see how to <findYourSenLink>find your SEN</findYourSenLink> or how to <findYourEnLink>find your EN</findYourEnLink>.",
                                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                                    findYourSenLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                            text: text,
                                            href: "https://confluence.atlassian.com/support/how-to-find-your-support-entitlement-number-sen-229840018.html",
                                            type: "inline"
                                        }),
                                    findYourEnLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                            text: text,
                                            href: "https://support.atlassian.com/subscriptions-and-billing/docs/understand-the-improved-atlassian-billing-experience/#What-are-the-key-differences",
                                            type: "inline"
                                        })
                                })
                            }),
                            " "
                        ]
                    })
                ]
            })
    });
};

});

parcelRegister("ai7AF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8acea9a2b2a9060b$export$2e2bcd8739ae039; });
/**
 * Set of personal email domains, retrieved from the database.
 * @type {Set<string>}
 */ const $8acea9a2b2a9060b$var$personalEmailsDomains = new Set([
    "proinbox.com",
    "telkomsa.net",
    "whoever.com",
    "deliveryman.com",
    "bio-muesli.info",
    "correo.terra.com.gt",
    "fxsmails.com",
    "ghosttexter.de",
    "goldtoolbox.com",
    "hoopsmail.com",
    "icrazy.com",
    "linktrader.com",
    "mail2bio.com",
    "mail2don.com",
    "mail2jason.com",
    "mail2megan.com",
    "mail2missouri.com",
    "mail2sensual.com",
    "mail2single.com",
    "policeoffice.com",
    "test.de",
    "the-gentleman.com",
    "velnet.co.uk",
    "wehshee.com",
    "yapped.net",
    "googlemail.com",
    "126.com",
    "gmx.com",
    "hotmal.com",
    "netplus.ch",
    "tempomail.fr",
    "mydomain.com",
    "noavar.com",
    "mail2minnesota.com",
    "freezone.co.uk",
    "me.fr",
    "macmail.com",
    "20mail.it",
    "asheville.com",
    "buerotiger.de",
    "check1check.com",
    "chickmail.com",
    "crazymailing.com",
    "freeweb.org",
    "habmalnefrage.de",
    "kumarweb.com",
    "laoeq.com",
    "mail2uruguay.com",
    "nybella.com",
    "outlook.pt",
    "thewebpros.co.uk",
    "yuuhuu.net",
    "zwallet.com",
    "bol.com.br",
    "postmail.ch",
    "personal.ro",
    "rn.com",
    "izadpanah.com",
    "mail2fun.com",
    "asiansonly.net",
    "assamesemail.com",
    "bmlsports.net",
    "dispose.it",
    "fastmail.co.uk",
    "frommiami.com",
    "fromnebraska.com",
    "gyorsposta.com",
    "inbax.tk",
    "mail2beach.com",
    "mail2massachusetts.com",
    "mail2southdakota.com",
    "mail2splash.com",
    "mail2webtop.com",
    "mail2zoologist.com",
    "onet.com.pl",
    "raakim.com",
    "throwam.com",
    "portugalmail.pt",
    "spambog.com",
    "email.si",
    "fishburne.org",
    "lycosmail.com",
    "appraiser.net",
    "dutchmail.com",
    "exg6.exghost.com",
    "feyenoorder.com",
    "ffanet.com",
    "forpresident.com",
    "gothere.uk.com",
    "in-box.net",
    "konx.com",
    "mail2guard.com",
    "mail2mouseketeer.com",
    "pacific-ocean.com",
    "schoolemail.com",
    "schoolsucks.com",
    "syriamail.com",
    "the-gremlin.com",
    "theinternetemail.com",
    "whoopymail.com",
    "yahoo.com.co",
    "comcast.com",
    "iname.com",
    "ua.pt",
    "post.harvard.edu",
    "in.com",
    "emailengine.net",
    "mail2colorado.com",
    "anonymous.to",
    "city-of-manchester.com",
    "finebody.com",
    "fromcalifornia.com",
    "heerschap.com",
    "lroid.com",
    "mail2moon.com",
    "mail2ronnie.com",
    "our-office.com",
    "pakistanmail.com",
    "palestinemail.com",
    "search.ua",
    "slamdunkfan.com",
    "spambob.com",
    "yahoo.co.il",
    "outlook.com.br",
    "i.softbank.jp",
    "swissonline.ch",
    "bestmail.us",
    "slingshot.com",
    "spray.no",
    "mail2ahoy.com",
    "burnthespam.info",
    "cntv.cn",
    "crosswinds.net",
    "disign-concept.eu",
    "educacao.te.pt",
    "email.biz",
    "emailforyou.net",
    "england.edu",
    "galaxyhit.com",
    "i12.com",
    "isellcars.com",
    "mail2astronomer.com",
    "mail2girl.com",
    "mail2highschool.com",
    "mail2lawyer.com",
    "mail2newjersey.com",
    "netc.eu",
    "nikopage.com",
    "shitmail.de",
    "the-italian.com",
    "live.at",
    "qip.ru",
    "us.army.mil",
    "alibaba.com",
    "50mail.com",
    "mail2composer.com",
    "mailin8r.com",
    "auctioneer.net",
    "brazilmail.com.br",
    "casino.com",
    "cracker.hu",
    "earthalliance.com",
    "ich-will-net.de",
    "ihateyoualot.info",
    "invalid.com",
    "lovefootball.com",
    "mail2fat.com",
    "mail2vince.com",
    "metalfan.com",
    "mfsa.ru",
    "susi.ml",
    "yahoo.fi",
    "ya.ru",
    "bigpond.com",
    "o2online.de",
    "yahoo.com.my",
    "bigpond.com.au",
    "bolt.com",
    "acninc.net",
    "dubaimail.com",
    "emeil.in",
    "highmilton.com",
    "ididitmyway.com",
    "imapmail.org",
    "mail2arkansas.com",
    "mail2customs.com",
    "mail2emergency.com",
    "mail2milan.com",
    "netby.dk",
    "rockfan.com",
    "spoofmail.de",
    "ukmail.org",
    "uolmail.com",
    "wales2000.net",
    "weinenvorglueck.de",
    "zxcvbnm.com",
    "hotmail.no",
    "hotmail.de",
    "freemail.hu",
    "tpg.com.au",
    "cableone.net",
    "webmail.co.za",
    "shitmail.me",
    "catlover.com",
    "aknet.kg",
    "027168.com",
    "bartender.net",
    "celtic.com",
    "charmedmail.com",
    "fiberia.com",
    "goldenmail.ru",
    "idigjesus.com",
    "ignazio.it",
    "iheartspam.org",
    "loh.pp.ua",
    "mail.vasarhely.hu",
    "mail2computers.com",
    "mail2cry.com",
    "mail2daughter.com",
    "mail2downtown.com",
    "mail2lyle.com",
    "mail2paul.com",
    "mail2pediatrician.com",
    "mail2peru.com",
    "mail2singapore.com",
    "nakedgreens.com",
    "piracha.net",
    "qv7.info",
    "rr.com",
    "student.su",
    "telepac.pt",
    "tempmail2.com",
    "veryrealemail.com",
    "wegas.ru",
    "wegwerf-emails.de",
    "xms.nl",
    "internet.lu",
    "fuse.net",
    "ggaweb.ch",
    "gmx.li",
    "wavecable.com",
    "zehnminutenmail.de",
    "mail2winner.com",
    "mail2canada.com",
    "allergist.com",
    "attymail.com",
    "from-europe.com",
    "internet-mail.org",
    "ist-willig.de",
    "mail-filter.com",
    "mail.de",
    "mail2andorra.com",
    "mail2beyond.com",
    "mail2joey.com",
    "mail2millennium.com",
    "mail2persephone.com",
    "mail2republican.com",
    "mail2ronald.com",
    "mail2store.com",
    "mail2test.com",
    "sagra.lu",
    "shitmail.org",
    "sudomail.biz",
    "teachermail.net",
    "telpage.net",
    "the-spaceman.com",
    "terra.com.br",
    "mail.ee",
    "internetmailing.net",
    "bsnow.net",
    "mail2actor.com",
    "c2.hu",
    "dyndns.org",
    "fetchmail.co.uk",
    "fromillinois.com",
    "hitmail.com",
    "immo-gerance.info",
    "irelandmail.com",
    "mail2buy.com",
    "mail2rabbi.com",
    "mail2soccerfan.com",
    "nagpal.net",
    "oneoffmail.com",
    "petlover.com",
    "spameater.com",
    "spaminator.de",
    "teamtulsa.net",
    "the-professional.com",
    "unbounded.com",
    "universal.pt",
    "wegwerpmailadres.nl",
    "whipmail.com",
    "hetnet.nl",
    "ameritech.net",
    "sasktel.net",
    "inode.at",
    "about.com",
    "boom.com",
    "idirect.com",
    "mail2dream.com",
    "norika-fujiwara.com",
    "mail2fantasy.com",
    "cyber-phone.eu",
    "estranet.it",
    "fatflap.com",
    "free-online.net",
    "frommaine.net",
    "karachian.com",
    "km.ru",
    "mail2christy.com",
    "mail2lacrosse.com",
    "mail2libra.com",
    "mail2lloyd.com",
    "mail2navy.com",
    "mail2pan.com",
    "mail2paralegal.com",
    "mail2state.com",
    "myiris.com",
    "passwordmail.com",
    "quickwebmail.com",
    "spamkill.info",
    "mail.missouri.edu",
    "upcmail.nl",
    "9online.fr",
    "spaml.de",
    "devnullmail.com",
    "meltmail.com",
    "sanfranmail.com",
    "mail2alien.com",
    "otakumail.com",
    "yalla.com",
    "16mail.com",
    "buyersusa.com",
    "cyber-innovation.club",
    "gamno.config.work",
    "irj.hu",
    "kaffeeschluerfer.com",
    "killermail.com",
    "mail2anesthesiologist.com",
    "mail2iris.com",
    "mail2manhunter.com",
    "mail2rugby.com",
    "mail2taxi.com",
    "xyzfree.net",
    "gmail.com",
    "katamail.com",
    "gportal.hu",
    "omaninfo.com",
    "cyberservices.com",
    "fortuncity.com",
    "general-hospital.com",
    "golfemail.com",
    "ikbenspamvrij.nl",
    "italymail.com",
    "liberomail.com",
    "lovethecowboys.com",
    "mail2airport.com",
    "mail2bank.com",
    "mail2maggie.com",
    "mail2safe.com",
    "mail2school.com",
    "mail2wendy.com",
    "mailpick.biz",
    "mutantweb.com",
    "mynamedot.com",
    "nabc.biz",
    "outlook.ph",
    "uk2.net",
    "students.fhu.edu",
    "jubiimail.dk",
    "ny.com",
    "mail2ares.com",
    "columbusrr.com",
    "for-president.com",
    "gigileung.org",
    "lahoreoye.com",
    "legalrc.loan",
    "mail2chad.com",
    "mail2gordon.com",
    "mail2lithuania.com",
    "mail2nuclear.com",
    "mail2passion.com",
    "mail2tina.com",
    "net-c.com",
    "outlook.be",
    "remail.ga",
    "uni.de",
    "hotmai.com",
    "fastmail.fm",
    "telusplanet.net",
    "vodafone.it",
    "mail-page.com",
    "email.ee",
    "mail-temporaire.fr",
    "arcotronics.bg",
    "fastsuzuki.com",
    "from-argentina.com",
    "from-russia.com",
    "hkg.net",
    "inet.com",
    "kaazoo.com",
    "keyemail.com",
    "ksee24mail.com",
    "mail2aunt.com",
    "mail2dustin.com",
    "mail2exciting.com",
    "mail2sky.com",
    "mail2wisconsin.com",
    "mailshuttle.com",
    "millionaireintraining.com",
    "recyclermail.com",
    "tbwt.com",
    "the-chinese.com",
    "the-fool.com",
    "yahoofs.com",
    "gmx.at",
    "yaho.com",
    "cd2.com",
    "bugmenot.com",
    "cashette.com",
    "mail2albania.com",
    "123mail.org",
    "bimla.net",
    "boxbg.com",
    "calidifontain.be",
    "flipcode.com",
    "garbage.com",
    "lovethebroncos.com",
    "mail2doris.com",
    "mail2eris.com",
    "mail2hollywood.com",
    "mail2site.com",
    "mail2travel.com",
    "nafe.com",
    "parvazi.com",
    "pcsrock.com",
    "roanokemail.com",
    "space-ship.com",
    "spacemart.com",
    "stop-my-spam.pp.ua",
    "sudanmail.net",
    "uol.com.ve",
    "wearab.net",
    "web-ideal.fr",
    "online.no",
    "lineone.net",
    "nus.edu.sg",
    "japan.com",
    "guerrillamailblock.com",
    "fbi.hu",
    "freemail.it",
    "2trom.com",
    "anymoment.com",
    "bluesfan.com",
    "bollywoodz.com",
    "callsign.net",
    "fan.com",
    "getonemail.net",
    "infohq.com",
    "isonfire.com",
    "m-a-i-l.com",
    "mail2congo.com",
    "mail2jacob.com",
    "mail2melissa.com",
    "mail2pete.com",
    "mail2runner.com",
    "mail2worship.com",
    "pagons.org",
    "startkeys.com",
    "onet.pl",
    "mail.net.sa",
    "onlinehome.de",
    "mailcatch.com",
    "yahoo.cn",
    "gmx.eu",
    "post.ru",
    "fastimap.com",
    "mail2alexa.com",
    "mail2indonesia.com",
    "bio-muesli.net",
    "snail-mail.net",
    "8mail.ml",
    "antwerpen.com",
    "domforfb2.tk",
    "fromwisconsin.com",
    "krim.ws",
    "mail2caroline.com",
    "mail2kelly.com",
    "mail2tammy.com",
    "nameplanet.com",
    "nettemail.com",
    "outlook.com.gr",
    "partynight.at",
    "religious.com",
    "the-frenchman.com",
    "totalmusic.net",
    "vinbazar.com",
    "yahoo.com.ru",
    "net2000.ch",
    "tiscali.it",
    "cogeco.ca",
    "softhome.net",
    "mail-central.com",
    "spammotel.com",
    "mail2tanya.com",
    "socamail.com",
    "getonemail.com",
    "uboot.com",
    "1webave.com",
    "20mail.in",
    "discard.email",
    "gci.net",
    "geeklife.com",
    "mail2columbia.com",
    "mail2douglas.com",
    "mail2handhelds.com",
    "mail2marc.com",
    "mail2stan.com",
    "mail2tenderness.com",
    "phone.net",
    "soccermomz.com",
    "unihome.com",
    "worldnet.att.net",
    "za.com",
    "189.cn",
    "inwind.it",
    "temporarioemail.com.br",
    "megamail.pt",
    "netian.com",
    "x5g.com",
    "mail2boston.com",
    "1funplace.com",
    "3mail.ga",
    "consumerriot.com",
    "directbox.com",
    "earthonline.net",
    "ednatx.com",
    "fast-email.com",
    "getairmail.ga",
    "groupmail.com",
    "mail2airbag.com",
    "mail2boreas.com",
    "mail2bug.com",
    "mail2elvis.com",
    "mail2freddie.com",
    "mail2howard.com",
    "mail2lost.com",
    "mail2lynn.com",
    "mail2mycell.com",
    "mail2toby.com",
    "mailsurf.com",
    "nonspammer.de",
    "nzoomail.com",
    "reconmail.com",
    "suisse.org",
    "vip.citiz.net",
    "vp.pl",
    "mail.usf.edu",
    "net.hr",
    "prodigy.net.mx",
    "blueyonder.co.uk",
    "swbell.net",
    "bendbroadband.com",
    "owlpic.com",
    "mail2dennis.com",
    "zubee.com",
    "mail2mypc.com",
    "2d2i.com",
    "abwesend.de",
    "clubvdo.net",
    "gratisweb.com",
    "jetable.pp.ua",
    "mail2jones.com",
    "mail2myphone.com",
    "mail2taylor.com",
    "reggaefan.com",
    "rsub.com",
    "trash2010.com",
    "vjtimail.com",
    "yahoo.co.kr",
    "atlanticbb.net",
    "san.rr.com",
    "safe-mail.net",
    "mail2syria.com",
    "awsom.net",
    "cortinet.com",
    "honduras.com",
    "mail2beatles.com",
    "mail2chile.com",
    "mail2classifieds.com",
    "mail2darling.com",
    "mail2holland.com",
    "mail2marshallislands.com",
    "mail2tycoon.com",
    "mezimages.net",
    "netti.fi",
    "reallymymail.com",
    "sandelf.de",
    "thegolfcourse.com",
    "mail2pharmacist.com",
    "mail2prince.com",
    "mail2robert.com",
    "daha.com",
    "kitznet.at",
    "mail2oscars.com",
    "naseej.com",
    "fastmail.uk",
    "thai.com",
    "berlinexpo.de",
    "mail2saudiarabia.com",
    "mail2gold.com",
    "email.com",
    "mail2hongkong.com",
    "liverpoolfans.com",
    "4email.com",
    "chequemail.com",
    "hush.ai",
    "mail2human.com",
    "mail2airforce.com",
    "mail2santa.com",
    "mail2barbara.com",
    "waumail.com",
    "mail2recycle.com",
    "mail2pluto.com",
    "fsmail.net",
    "online.de",
    "yahoo.pl",
    "netvigator.com",
    "berlin.com",
    "onelinkpr.net",
    "antispam.de",
    "carioca.net",
    "einrot.de",
    "interburp.com",
    "koreamail.com",
    "mail2diehard.com",
    "mail2gambia.com",
    "mail2hannah.com",
    "mail2hermes.com",
    "mail2wonder.com",
    "mailbox.as",
    "meine-urlaubsfotos.de",
    "orthodontist.net",
    "outlook.lv",
    "psv-supporter.com",
    "qrio.com",
    "racingmail.com",
    "scifianime.com",
    "shitaway.ga",
    "swiftdesk.com",
    "telebot.com",
    "whatpaas.com",
    "yesey.net",
    "zydecofan.com",
    "investormail.com",
    "tfz.net",
    "mail2medieval.com",
    "mail2mini.com",
    "mail2danielle.com",
    "zhaowei.net",
    "the-davis-home.com",
    "cityofcardiff.net",
    "elitemail.org",
    "mail2delaware.com",
    "mail2eurus.com",
    "box.az",
    "mail2beast.com",
    "chattown.com",
    "mail2melody.com",
    "mail2monica.com",
    "mail2sweetheart.com",
    "nc.rr.com",
    "lhsdv.com",
    "4worldmail.com",
    "wonder-net.com",
    "frommichigan.com",
    "anjungcafe.com",
    "nauticom.net",
    "madrid.com",
    "posteo.de",
    "fwnb.com",
    "ihwy.com",
    "spam.la",
    "businessweekmail.com",
    "nobulk.com",
    "internode.on.net",
    "stribmail.com",
    "sx172.com",
    "emailstuff.com",
    "mail2washington.com",
    "xoommail.com",
    "chauhanweb.com",
    "counsellor.com",
    "geecities.com",
    "varbizmail.com",
    "medicinemail.com",
    "mail2northpole.com",
    "nyc.rr.com",
    "mail2somalia.com",
    "fastacura.com",
    "imposter.co.uk",
    "planetarymotion.net",
    "mail2wendell.com",
    "cybergrrl.com",
    "5star.com",
    "internet-club.com",
    "from-korea.com",
    "netcabo.pt",
    "brokenvalve.com",
    "center-mail.de",
    "mail2rss.org",
    "mailcat.biz",
    "photographer.net",
    "shieldedmail.com",
    "toast.com",
    "zzz.com",
    "mail2gabriel.com",
    "dawsonmail.com",
    "grandecom.net",
    "f1fans.net",
    "firehost.com",
    "officedomain.com",
    "kbjrmail.com",
    "zensearch.net",
    "repairman.com",
    "mail2banker.com",
    "bisons.com",
    "infinito.it",
    "mail2connect.com",
    "mail2charles.com",
    "hotmial.com",
    "emailsensei.com",
    "besonet.ch",
    "mantramail.com",
    "sci.fi",
    "ip3.com",
    "sialkotcity.com",
    "cegetel.net",
    "breadtimes.press",
    "tankpolice.com",
    "z1p.biz",
    "hotmail.co.uk",
    "hamburg.de",
    "ybb.ne.jp",
    "empal.com",
    "inorbit.com",
    "mail2world.com",
    "uggsrock.com",
    "myplace.com",
    "mail.net",
    "vipmail.ru",
    "getairmail.gq",
    "mail2cardinal.com",
    "mail2darren.com",
    "mail2georgia.com",
    "mail2kiss.com",
    "mail2mary.com",
    "mail2uptown.com",
    "resource.calendar.google.com",
    "secretservices.net",
    "sporttruckdriver.com",
    "supermail.ru",
    "yalla.com.lb",
    "yahoo.com.tw",
    "nifty.com",
    "ma.ru",
    "yahoo.com.tr",
    "netmadeira.com",
    "sendme.cz",
    "kittymail.com",
    "hol.gr",
    "whatever.com",
    "clubbers.net",
    "thewatercooler.com",
    "mail2pope.com",
    "1nsyncfan.com",
    "alloymail.com",
    "fastkawasaki.com",
    "imap-mail.com",
    "mail2filmfestival.com",
    "mail2karma.com",
    "mail2king.com",
    "mail2life.com",
    "mailbox80.biz",
    "mohammed.com",
    "mystupidjob.com",
    "netscapeonline.co.uk",
    "nirvanafan.com",
    "outlook.at",
    "planetout.com",
    "secure-mail.biz",
    "servermaps.net",
    "violinmakers.co.uk",
    "w3.to",
    "outlook.es",
    "yahoo.com.cn",
    "post.cz",
    "vodafone.es",
    "fastemail.us",
    "pookmail.com",
    "canoemail.com",
    "trash-amil.com",
    "chaiyomail.com",
    "echina.com",
    "england.com",
    "fromhawaii.net",
    "geopia.com",
    "mail2amazing.com",
    "mail2aquarius.com",
    "mail2claude.com",
    "mail2danny.com",
    "mail2free.com",
    "mail2herman.com",
    "mail2isaac.com",
    "mail2shirley.com",
    "renren.com",
    "scubadiving.com",
    "techspot.com",
    "truckracer.com",
    "live.de",
    "telenet.be",
    "volny.cz",
    "pandora.be",
    "freestart.hu",
    "airmail.net",
    "nb.sympatico.ca",
    "uol.com.ar",
    "maffia.hu",
    "surimail.com",
    "contractor.net",
    "facebookmail.gq",
    "fortunecity.com",
    "fuorissimo.com",
    "gaybrighton.co.uk",
    "lmxmail.sk",
    "mail2kuwait.com",
    "mail2malta.com",
    "mail2member.com",
    "mail2redhead.com",
    "mail2yemen.com",
    "mailbr.com.br",
    "outlook.ie",
    "tennismail.com",
    "mail.ru",
    "yahoo.com.br",
    "neuf.fr",
    "hotmail.co.jp",
    "student.swin.edu.au",
    "registerednurses.com",
    "financier.com",
    "breathe.com",
    "yapost.com",
    "99experts.com",
    "accountant.com",
    "cheatmail.de",
    "city-of-westminster.net",
    "emailgo.de",
    "f-m.fm",
    "globalsite.com.br",
    "hang-ten.com",
    "iowaemail.com",
    "mail2adorable.com",
    "mail2blind.com",
    "mail2gabon.com",
    "mail2joel.com",
    "martindalemail.com",
    "mm.st",
    "nowhere.org",
    "radiologist.net",
    "sebil.com",
    "st-davids.net",
    "ultapulta.com",
    "vodafonethuis.nl",
    "xww.ro",
    "yalook.com",
    "caiway.nl",
    "kpnmail.nl",
    "citromail.hu",
    "hot.rr.com",
    "37.com",
    "netposta.net",
    "mail2russia.com",
    "farifluset.mailexpire.com",
    "fromutah.com",
    "iamwaiting.com",
    "iroid.com",
    "liveradio.tk",
    "mail2australia.com",
    "mail2colombia.com",
    "mail2deanna.com",
    "mail2ethiopia.com",
    "mail2ok.com",
    "mycabin.com",
    "r-o-o-t.com",
    "reborn.com",
    "rickymail.com",
    "superstachel.de",
    "windrivers.net",
    "youmailr.com",
    "videotron.ca",
    "bell.net",
    "dr.com",
    "montevideo.com.uy",
    "mailbolt.com",
    "trashmail.ws",
    "mail2triallawyer.com",
    "mail2expert.com",
    "fastsubaru.com",
    "iobox.fi",
    "mail2aeolus.com",
    "mail2christmas.com",
    "mail2hygeia.com",
    "mail2ian.com",
    "mail2jail.com",
    "mail2peggy.com",
    "mail2stanley.com",
    "premium-mail.fr",
    "rastogi.net",
    "the-police.com",
    "vollbio.de",
    "xsecurity.org",
    "hochsitze.com",
    "fmguy.com",
    "singmail.com",
    "ak47.hu",
    "wx88.net",
    "bodhi.lawlita.com",
    "domforfb5.tk",
    "dontmesswithtexas.com",
    "dostmail.com",
    "fastservice.com",
    "friendsfan.com",
    "linkmaster.com",
    "mail2afghanistan.com",
    "mail2eric.com",
    "mail2erica.com",
    "mail2indian.com",
    "mail2kyrgyzstan.com",
    "mail2maurice.com",
    "mail2oliver.com",
    "mail2samantha.com",
    "mail2scorpio.com",
    "mail2studio54.com",
    "mailgenie.net",
    "mailtothis.com",
    "mlb.bounce.ed10.net",
    "mr-potatohead.com",
    "net-c.es",
    "ntlhelp.net",
    "pepbot.com",
    "popsmail.com",
    "sentrismail.com",
    "gmx.es",
    "live.fr",
    "t-email.hu",
    "cust.in",
    "email.wsu.edu",
    "insightbb.com",
    "email.ro",
    "canada-11.com",
    "biggerbadder.com",
    "email.org",
    "mail.com.tr",
    "mail2club.com",
    "mail2craig.com",
    "mail2florida.com",
    "mail2games.com",
    "mail2newzealand.com",
    "mail2nike.com",
    "mail2noelle.com",
    "mail2policewoman.com",
    "mail2unsubscribe.com",
    "mail2uzbekistan.com",
    "mail2waycool.com",
    "mostlysunny.com",
    "nemra1.com",
    "starplace.com",
    "t.psh.me",
    "talkinator.com",
    "uomail.com",
    "wingnutz.com",
    "sina.cn",
    "voila.fr",
    "aol.nl",
    "stanfordalumni.org",
    "c3.hu",
    "fmail.co.uk",
    "9.cn",
    "myspace.com",
    "uno.it",
    "1freeemail.com",
    "domforfb6.tk",
    "federalcontractors.com",
    "ghostmail.com",
    "gofree.co.uk",
    "jourrapide.com",
    "mail.org.uk",
    "mail2attitude.com",
    "mail2blake.com",
    "mail2cathy.com",
    "mail2earl.com",
    "mail2nicaragua.com",
    "mail2paris.com",
    "mail2planet.com",
    "mail2sail.com",
    "mail2susan.com",
    "mail2vanessa.com",
    "mail2venus.com",
    "net-c.pl",
    "odaymail.com",
    "our-computer.com",
    "papierkorb.me",
    "raubtierbaendiger.de",
    "thraml.com",
    "tidni.com",
    "twc.com",
    "hotmail.es",
    "post.com",
    "euronet.nl",
    "op.pl",
    "yahoo.com.sg",
    "nate.com",
    "lycos.co.uk",
    "fizmail.com",
    "bombdiggity.com",
    "bsdmail.com",
    "citlink.net",
    "disign-revelation.com",
    "earthcam.net",
    "ieatspam.info",
    "mail2africa.com",
    "mail2chinese.com",
    "mail2hera.com",
    "mail2janet.com",
    "mail2kenneth.com",
    "mail2trump.com",
    "mash4077.com",
    "mohmal.com",
    "postfach.cc",
    "spils.com",
    "theoffice.net",
    "aol.co.uk",
    "socal.rr.com",
    "sibmail.com",
    "q.com",
    "mailandftp.com",
    "portugalmail.com",
    "theend.hu",
    "h.mintemail.com",
    "8mail.ga",
    "armyspy.com",
    "asean-mail.com",
    "aussiemail.com.au",
    "bresnan.net",
    "city-of-cambridge.com",
    "handbag.com",
    "iamyours.com",
    "mail2austria.com",
    "mail2grandma.com",
    "mail2help.com",
    "mail2michelle.com",
    "mail2rock.com",
    "mail2spanish.com",
    "mail2tonga.com",
    "mail2tunisia.com",
    "mail2v.com",
    "mail2vamoose.com",
    "mancity.net",
    "moldova.com",
    "netlane.com",
    "skrx.tk",
    "yopweb.com",
    "sapo.pt",
    "columbus.rr.com",
    "freeserve.co.uk",
    "dingbone.com",
    "mail2nowhere.com",
    "lucidonline.co.uk",
    "mail2hindu.com",
    "blogmyway.org",
    "bouncr.com",
    "colleges.com",
    "digital-filestore.de",
    "dragoncon.net",
    "ezrs.com",
    "flashmail.net",
    "furnitureprovider.com",
    "goemailgo.com",
    "mail.htl22.at",
    "mail2spare.com",
    "mail2zipper.com",
    "mailclub.net",
    "mailfs.com",
    "mailslapping.com",
    "solar-impact.pro",
    "sudomail.net",
    "live.se",
    "bluemail.ch",
    "i.ua",
    "hot.ee",
    "dbzmail.com",
    "123.com",
    "intermail.co.il",
    "spymac.com",
    "mail2iran.com",
    "birdlover.com",
    "chef.net",
    "cynetcity.com",
    "emailage.ga",
    "fake-mail.cf",
    "gencmail.com",
    "home.no.net",
    "ilse.nl",
    "jobbikszimpatizans.hu",
    "mail2justin.com",
    "mail2max.com",
    "mail2neil.com",
    "mail2oregon.com",
    "mail2patty.com",
    "mail2soccer.com",
    "mail2swaziland.com",
    "nmail.cf",
    "office-email.com",
    "privy-mail.com",
    "whatiaas.com",
    "mail.mcgill.ca",
    "post.sk",
    "mail2brunei.com",
    "netster.com",
    "bullsgame.com",
    "email.ua",
    "geek.com",
    "goodstick.com",
    "ip6.pp.ua",
    "mail2dominic.com",
    "mail2kentucky.com",
    "mail2mail4.com",
    "mail2presbyterian.com",
    "mail2rob.com",
    "mail2stewart.com",
    "mail2tim.com",
    "mailwire.com",
    "meine-diashow.de",
    "okmagic.com",
    "olympist.net",
    "pianomail.com",
    "politician.com",
    "siteposter.net",
    "snakebite.com",
    "techscout.com",
    "the-stock-market.com",
    "thewizzkid.com",
    "wxs.net",
    "tele2.se",
    "primposta.hu",
    "bostonoffice.com",
    "thirdage.com",
    "1coolplace.com",
    "addcom.de",
    "airforce.net",
    "box.ua",
    "dotcom.fr",
    "dumpmail.de",
    "duskmail.com",
    "e-mail.com.tr",
    "elvisfan.com",
    "etranquil.com",
    "fnbmail.co.za",
    "from-australia.com",
    "luso.pt",
    "mail2billionaire.com",
    "mail2demeter.com",
    "mail2mrright.com",
    "mail2rap.com",
    "mail2shane.com",
    "manager.de",
    "quakemail.com",
    "sags-per-mail.de",
    "scarlet.nl",
    "spam.care",
    "the-army.com",
    "vip.126.com",
    "zuvio.com",
    "aol.de",
    "inbox.lv",
    "netvision.net.il",
    "bellaliant.net",
    "seed.net.tw",
    "inmail24.com",
    "ausi.com",
    "incognitomail.org",
    "dropzone.com",
    "centralpets.com",
    "chat.ru",
    "keko.com.ar",
    "movemail.com",
    "as-if.com",
    "bellair.net",
    "bigger.com",
    "dawnsonmail.com",
    "infospacemail.com",
    "mail2ernie.com",
    "mail2frank.com",
    "mail2gary.com",
    "mail2headhunter.com",
    "mail2irene.com",
    "mail2love.com",
    "mail2rusty.com",
    "mail2tony.com",
    "mehtaweb.com",
    "mynetstore.de",
    "quantentunnel.de",
    "regbypass.com",
    "space-man.com",
    "spl.at",
    "wormseo.cn",
    "wrongmail.com",
    "yahoo.ro",
    "your-mail.com",
    "web.de",
    "email.it",
    "europe.com",
    "space.com",
    "citiz.net",
    "dodgit.com",
    "slopsbox.com",
    "yuurok.com",
    "mail2hell.com",
    "arabia.com",
    "die-genossen.de",
    "dog.com",
    "handleit.com",
    "job4u.com",
    "listomail.com",
    "llandudno.com",
    "mail2arnold.com",
    "mail2disco.com",
    "mail2dive.com",
    "mail2economist.com",
    "mail2jed.com",
    "mail2louisiana.com",
    "mail2mba.com",
    "mail2sagittarius.com",
    "mail2samoa.com",
    "mail2suzie.com",
    "mail2tennis.com",
    "mns.ru",
    "mosaicfx.com",
    "most-wanted.com",
    "nchoicemail.com",
    "nexxmail.com",
    "slippery.email",
    "topsurf.com",
    "unofree.it",
    "compuserve.com",
    "keepmymail.com",
    "1chuan.com",
    "bizhosting.com",
    "dallasmail.com",
    "hitthe.net",
    "in2jesus.com",
    "mail2dinner.com",
    "mail2fancy.com",
    "mail2ny.com",
    "mail2slovakia.com",
    "mail2try.com",
    "netexpressway.com",
    "olemail.com",
    "project2k.com",
    "tritium.net",
    "wbdet.com",
    "weg-werf-email.de",
    "women-at-work.org",
    "wouldilie.com",
    "mail2panama.com",
    "fudgerub.com",
    "wi.rr.com",
    "yahoo.no",
    "mail2vickie.com",
    "tmailinator.com",
    "technologist.com",
    "liquidinformation.net",
    "wrexham.net",
    "yahoo.com.ph",
    "soon.com",
    "linuxfreemail.com",
    "bobmail.info",
    "classicalfan.com",
    "centrum.sk",
    "asia-links.com",
    "leonlai.net",
    "realradiomail.com",
    "mantrafreenet.com",
    "allmail.net",
    "ec.rr.com",
    "1netdrive.com",
    "gaza.net",
    "adexec.com",
    "kalpoint.com",
    "enter.net",
    "3email.com",
    "cumbriamail.com",
    "adfarrow.com",
    "webdream.com",
    "mail2tennessee.com",
    "from-holland.com",
    "eposta.hu",
    "deneg.net",
    "london.com",
    "columnist.com",
    "mail2environmentalist.com",
    "highveldmail.co.za",
    "gmail.om",
    "interfree.it",
    "spamavert.com",
    "emailaccount.com",
    "go.com",
    "mail2uncle.com",
    "atmc.net",
    "businessman.net",
    "chong-mail.com",
    "examnotes.net",
    "fromidaho.com",
    "ghanamail.com",
    "mail2egypt.com",
    "mail2israel.com",
    "mail2katie.com",
    "mail2mexican.com",
    "mail2surfer.com",
    "mail2trekkie.com",
    "muell.icu",
    "nimail.com",
    "the-african.com",
    "sympatico.ca",
    "alice-dsl.net",
    "go2.pl",
    "sina.com.cn",
    "slingshot.co.nz",
    "uk7.net",
    "brasilia.net",
    "busta-rhymes.com",
    "curio-city.com",
    "from-canada.com",
    "fromoregon.net",
    "hu2.ru",
    "ich-bin-verrueckt-nach-dir.de",
    "mail2coastguard.com",
    "mail2intense.com",
    "mail2jenny.com",
    "mail2kristin.com",
    "mail2ron.com",
    "mail2skater.com",
    "mail2zambia.com",
    "marijuana.com",
    "miho-nakayama.com",
    "outlook.com.pe",
    "parkjiyoon.com",
    "skeefmail.com",
    "tmail.ws",
    "ig.com.br",
    "optimum.net",
    "wanadoo.es",
    "spambog.de",
    "fmailbox.com",
    "5iron.com",
    "surfy.net",
    "phayze.com",
    "mail2rich.com",
    "alternativagratis.com",
    "catcha.com",
    "cooooool.com",
    "fastmail.se",
    "footard.com",
    "lavache.com",
    "mail2jessie.com",
    "mail2keen.com",
    "mail2webtv.com",
    "mail2westvirginia.com",
    "muskelshirt.de",
    "mythirdage.com",
    "n2software.com",
    "net-shopping.com",
    "royal.net",
    "rubyridge.com",
    "stipte.nl",
    "webtopmail.com",
    "hanmail.net",
    "centurylink.net",
    "carolina.rr.com",
    "yours.com",
    "mail2kurt.com",
    "lovemail.com",
    "8848.net",
    "brew-meister.com",
    "cybercafemaui.com",
    "fastmitsubishi.com",
    "fishfuse.com",
    "imstations.com",
    "mail2cell.com",
    "mail2firm.com",
    "mail2fred.com",
    "mail2hercules.com",
    "mail2ice-cream.com",
    "mail2stockholm.com",
    "mail2taxidermist.com",
    "mail2valentines.com",
    "mail2vietnam.com",
    "mailchoose.co",
    "meetingmall.com",
    "navy.org",
    "olypmall.ru",
    "partyheld.de",
    "sunsgame.com",
    "survivormail.com",
    "dandikmail.com",
    "fromarizona.com",
    "eqqu.com",
    "melodymail.com",
    "iwmail.com",
    "mail15.com",
    "mail2whether.com",
    "mail2coach.com",
    "fakeinbox.com",
    "the-american.com",
    "freemail.org.mk",
    "btinternet.com",
    "mail2sara.com",
    "mail2trick.com",
    "presidency.com",
    "ubbi.com.br",
    "mail2mime.com",
    "virtualmail.com",
    "mailroom.com",
    "malayalamtelevision.net",
    "ureach.com",
    "alive.cz",
    "mail2margie.com",
    "laposte.net",
    "posteo.us",
    "anti-social.com",
    "mail2atom.com",
    "mail2heather.com",
    "bharatmail.com",
    "subram.com",
    "truckers.com",
    "ace-of-base.com",
    "itmom.com",
    "foxmail.com",
    "mail2namibia.com",
    "mail2psycho.com",
    "mail2adore.com",
    "m-hmail.com",
    "automotiveauthority.com",
    "oceanfree.net",
    "swissinfo.org",
    "sailormoon.com",
    "email.nu",
    "me.com",
    "oldies104mail.com",
    "mail2venezuela.com",
    "mail2edwin.com",
    "hey.to",
    "tvcablenet.be",
    "wegwerfemail.de",
    "nfmail.com",
    "pobox.hu",
    "mail2pilot.com",
    "peopleweb.com",
    "anote.com",
    "mttestdriver.com",
    "mail2russell.com",
    "smileyface.comsmithemail.net",
    "fnmail.com",
    "rattle-snake.com",
    "indyracers.com",
    "host-it.com.sg",
    "studenti.unisannio.it",
    "popaccount.com",
    "cotas.net",
    "fire-brigade.com",
    "mail2oslo.com",
    "hamptonroads.com",
    "theraces.com",
    "the-madman.com",
    "ozemail.com.au",
    "yourwap.com",
    "rrohio.com",
    "metacrawler.com",
    "vikenfiber.no",
    "mail2register.com",
    "posteo.es",
    "deltanet.com",
    "boom.ru",
    "libertysurf.fr",
    "guessmail.com",
    "fastmail.es",
    "netspeedway.com",
    "mypad.com",
    "mail2amanda.com",
    "mail2earth.com",
    "mail2artemus.com",
    "ranmamail.com",
    "dunlopdriver.com",
    "yoursubdomain.findhere.com",
    "forfree.at",
    "yoursubdomain.zzn.com",
    "ewetel.net",
    "mail2italy.com",
    "from-mexico.com",
    "okname.net",
    "frompennsylvania.com",
    "mail2webmaster.com",
    "spartapiet.com",
    "city-of-lichfield.com",
    "glendale.net",
    "osite.com.br",
    "students.swinburne.edu.my",
    "nandomail.com",
    "gmail.comm",
    "freeaccess.nl",
    "snowboarding.com",
    "mail2timothy.com",
    "mail2ryan.com",
    "mail2tara.com",
    "1me.net",
    "earthlink.net",
    "mail2socialist.com",
    "mail2estonia.com",
    "mail2michigan.com",
    "lexis-nexis-mail.com",
    "ilovechocolate.com",
    "aliceposta.it",
    "davegracey.com",
    "mail2www.com",
    "oso.com",
    "asurfer.com",
    "netgenie.com",
    "geekmail.com",
    "spamfree24.eu",
    "promessage.com",
    "mail.entrepeneurmag.com",
    "epost.de",
    "gardener.com",
    "icmsconsultants.com",
    "mail2why.com",
    "ngs.ru",
    "netsquare.com",
    "msn.cn",
    "mygo.com",
    "fastemailer.com",
    "orange.nl",
    "educastmail.com",
    "live.dk",
    "mail2sudan.com",
    "mail.r-o-o-t.com",
    "sohu.com",
    "pacbell.net",
    "uniroma1.it",
    "centurytel.net",
    "insurer.com",
    "indiatimes.com",
    "pediatrician.com",
    "mail2john.com",
    "anytimenow.com",
    "batuta.net",
    "bleib-bei-mir.de",
    "blushmail.com",
    "fastmail.in",
    "instant-mail.de",
    "mail2bryan.com",
    "mail2optometrist.com",
    "plusmail.com.br",
    "slo.net",
    "vodafone.nl",
    "webprogramming.com",
    "yourteacher.net",
    "onenet.com.ar",
    "covad.net",
    "mail2grandpa.com",
    "mail2sandra.com",
    "singapore.com",
    "web-mail.com.ar",
    "live.com.pt",
    "e-mail.ru",
    "websurfer.co.za",
    "une.net.co",
    "mail2seychelles.com",
    "urgentmail.biz",
    "mail2courtney.com",
    "mail2whitney.com",
    "i-mail.com.au",
    "telia.com",
    "mail2virgo.com",
    "mail2director.com",
    "mail2tracy.com",
    "libero.it",
    "hotamail.com",
    "tampabay.rr.com",
    "cluemail.com",
    "4warding.net",
    "chance2mail.com",
    "china.com",
    "financemail.net",
    "ilkposta.com",
    "krunis.com",
    "lags.us",
    "mail2brian.com",
    "mail2croatia.com",
    "mail2female.com",
    "mail2french.com",
    "mail2julian.com",
    "mail2volleyball.com",
    "mailbomb.net",
    "mailzi.ru",
    "naplesnews.net",
    "reallyfast.info",
    "reply.ticketmaster.com",
    "sweetville.net",
    "mail2azerbaijan.com",
    "primposta.com",
    "wolf-web.com",
    "vote-republicans.com",
    "hotmail.it",
    "mail2greg.com",
    "mail2no.com",
    "mail2yes.com",
    "4warding.org",
    "mail2policeman.com",
    "mail2southcarolina.com",
    "atlink.com",
    "mail2lucky.com",
    "di-ve.com",
    "hotmail.cl",
    "hotmail.sg",
    "uol.com.co",
    "thegooner.com",
    "034.pfr.ru",
    "imstressed.com",
    "mail2convict.com",
    "pharmacymail.com",
    "hotmail.ch",
    "0-mail.com",
    "index.ua",
    "physicist.net",
    "shitware.nl",
    "tempmaildemo.com",
    "mail2taz.com",
    "aol.in",
    "mailservice.ms",
    "smoothmail.com",
    "mail2czechrepublic.com",
    "hackermail.net",
    "from-outerspace.com",
    "mail2tiffany.com",
    "mail2tv.com",
    "mailhood.com",
    "mail2capeverde.com",
    "frommissouri.com",
    "playersodds.com",
    "fastmail.com",
    "votenet.com",
    "fut.es",
    "email.ru",
    "thedoghousemail.com",
    "mypersonalemail.com",
    "mail2traveler.com",
    "t-online.de",
    "temporaryinbox.com",
    "the-astronaut.com",
    "tyldd.com",
    "sp.nl",
    "myopera.com",
    "sialkotoye.com",
    "mail2memphis.com",
    "snip.net",
    "mail2hungry.com",
    "mail2podiatrist.com",
    "mail2capricorn.com",
    "iprimus.com.au",
    "mycool.com",
    "coxinet.net",
    "mail2france.com",
    "mail2truck.com",
    "posteo.pl",
    "mail2platinum.com",
    "takuyakimura.com",
    "mailhaven.com",
    "qudsmail.com",
    "myremarq.com",
    "yahoo.com",
    "online.fr",
    "footballmail.com",
    "mailstart.com",
    "zcities.com",
    "premiumservice.com",
    "vjmail.com",
    "care2.com",
    "luukku.com",
    "mail2elizabeth.com",
    "rocketmail.com",
    "excite.co.jp",
    "mail2dude.com",
    "1mail.net",
    "atozasia.com",
    "city-of-edinburgh.com",
    "computer-freak.com",
    "cornells.com",
    "expressasia.com",
    "mail2chocolate.com",
    "mail2dinosaur.com",
    "mail2everything.com",
    "mail2jerry.com",
    "mail2sanmarino.com",
    "mailingweb.com",
    "mailsac.com",
    "pconnections.net",
    "servemymail.com",
    "tcc.on.ca",
    "valemail.net",
    "xagloo.com",
    "gmail.ru",
    "alum.mit.edu",
    "ziggo.nl",
    "narod.ru",
    "africamail.com",
    "clubhonda.net",
    "thankyou2010.com",
    "212.com",
    "disposemail.com",
    "starspath.com",
    "backpackers.com",
    "bounces.amazon.com",
    "doclist.bounces.google.com",
    "every1.net",
    "joinme.com",
    "kube93mail.com",
    "mail2bride.com",
    "mail2thailand.com",
    "mail2virginia.com",
    "net4you.at",
    "outlook.de",
    "showslow.de",
    "swedenmail.com",
    "vickaentb.tk",
    "globo.com",
    "spamherelots.com",
    "lavabit.com",
    "w.cn",
    "2-mail.com",
    "telkom.net",
    "mail2queen.com",
    "mail2ray.com",
    "mail2franklin.com",
    "boximail.com",
    "emailproxsy.com",
    "eyepaste.com",
    "gonavy.net",
    "herediano.com",
    "mail2eastend.com",
    "mail2joseph.com",
    "mail2secretagent.com",
    "resgedvgfed.tk",
    "send.hu",
    "suhabi.com",
    "topmail.com.ar",
    "typemail.com",
    "forthnet.gr",
    "skynet.be",
    "dfwatson.com",
    "icqmail.com",
    "netradiomail.com",
    "altavista.net",
    "gmail.co.uk",
    "moonman.com",
    "wp.pl",
    "animalhouse.com",
    "mail2la.com",
    "uaemail.com",
    "yourlover.net",
    "doityourself.com",
    "hotmail.se",
    "timein.net",
    "trashmail.at",
    "live.missouristate.edu",
    "gospelfan.com",
    "mail2bradley.com",
    "mailtag.com",
    "fastermail.com",
    "club4x4.net",
    "the-pentagon.com",
    "turkey.com",
    "integra.net",
    "lakmail.com",
    "mini-mail.com",
    "dazedandconfused.com",
    "foodmail.com",
    "ourbrisbane.com",
    "hccnet.nl",
    "caere.it",
    "bitmail.com",
    "astroboymail.com",
    "cartestraina.ro",
    "spamify.com",
    "mail2jon.com",
    "mail.gvsu.edu",
    "inicia.es",
    "mail2nebraska.com",
    "acmemail.net",
    "mail-box.cz",
    "mail2rainmaker.com",
    "mail2latvia.com",
    "polbox.com",
    "mail2touch.com",
    "sify.com",
    "mail.sisna.com",
    "acm.org",
    "front.ru",
    "buryfans.com",
    "marsattack.com",
    "mail2dancer.com",
    "gazeta.pl",
    "mail2music.com",
    "rednecks.com",
    "dangerous-minds.com",
    "bellnet.ca",
    "mail2evelyn.com",
    "parsmail.com",
    "netzero.net",
    "mierdamail.com",
    "mail2shuttle.com",
    "www.com",
    "ukmax.com",
    "mail2djibouti.com",
    "mahmoodweb.com",
    "lovingjesus.com",
    "cataloniamail.com",
    "collegebeat.com",
    "snowdonia.net",
    "mekhong.com",
    "samerica.com",
    "mail.telepac.pt",
    "posteo.be",
    "mail2milkyway.com",
    "mail2dealer.com",
    "thepokerface.com",
    "basketballmail.com",
    "teleline.es",
    "fromthestates.com",
    "progressmail.net",
    "mail2myplane.com",
    "mail2simon.com",
    "mighty.co.za",
    "moldovacc.com",
    "mail2aphrodite.com",
    "mail2sports.com",
    "mail.by",
    "ono.com",
    "busymail.com",
    "felicitymail.com",
    "dispostable.com",
    "amrer.net",
    "mail2samurai.com",
    "mail2raymond.com",
    "xtra.co.nz",
    "pousa.com",
    "mail2nun.com",
    "kc.rr.com",
    "mail2richard.com",
    "theteebox.com",
    "concentric.net",
    "icloud.com",
    "rambler.ru",
    "o2.pl",
    "tiscali.nl",
    "r7.com",
    "warpmail.net",
    "poetic.com",
    "navigator.lv",
    "croeso.com",
    "alskens.dk",
    "mail2graham.com",
    "74.ru",
    "7mail.ga",
    "asiancityweb.com",
    "bounce.net",
    "bumpymail.com",
    "cmail.net",
    "fdfdsfds.com",
    "inbox.si",
    "m4ilweb.info",
    "mail2anything.com",
    "mail2farmer.com",
    "mail2george.com",
    "mail2jimmy.com",
    "mail2matt.com",
    "mail2nepal.com",
    "mail2tennisfan.com",
    "mail2wilbur.com",
    "married-not.com",
    "messages.to",
    "quikmail.com",
    "ratt-n-roll.com",
    "thaimail.net",
    "wosaddict.com",
    "yomail.info",
    "aol.com",
    "yahoo.it",
    "facebook.com",
    "freenet.de",
    "teletu.it",
    "hush.com",
    "mailnew.com",
    "avia-tonic.fr",
    "corporatedirtbag.com",
    "emailasso.net",
    "fast-mail.fr",
    "fromnevada.com",
    "info-media.de",
    "mail2ashley.com",
    "mail2janice.com",
    "mail2jew.com",
    "mail2kenya.com",
    "mail2mankind.com",
    "mail2peter.com",
    "mail2sos.com",
    "mindless.com",
    "momslife.com",
    "the-country.com",
    "yahoo.ch",
    "suremail.info",
    "dublin.com",
    "graffiti.net",
    "emailuser.net",
    "worldemail.com",
    "brfree.com.br",
    "tenderkiss.com",
    "crazysexycool.com",
    "emailem.com",
    "from-israel.com",
    "hockeymail.com",
    "hot-mail.gq",
    "kiwibox.com",
    "levele.com",
    "louiskoo.com",
    "mail2color.com",
    "mail2kimberly.com",
    "mail2pennsylvania.com",
    "mailproxsy.com",
    "miesto.sk",
    "msgbox.com",
    "public.usa.com",
    "radicalz.com",
    "tempmail.us",
    "gotmail.com",
    "kabelmail.de",
    "live.co.kr",
    "broadpark.no",
    "airpost.net",
    "vnn.vn",
    "discardmail.com",
    "imail.ru",
    "mailsent.net",
    "mail2army.com",
    "20minutemail.com",
    "spaml.com",
    "alumni.com",
    "art-en-ligne.pro",
    "byom.de",
    "critterpost.com",
    "fromsouthcarolina.com",
    "gentlemansclub.de",
    "guju.net",
    "info66.com",
    "keg-party.com",
    "lowandslow.com",
    "mail2fond.com",
    "mail2whitehouse.com",
    "milmail.com",
    "nicebush.com",
    "sndt.net",
    "spambog.net",
    "speedrules.com",
    "sportsmail.com",
    "the-monkey.com",
    "thedorm.com",
    "free.fr",
    "mail.bg",
    "email.de",
    "me.de",
    "clerk.com",
    "postinbox.com",
    "yahoo.ru",
    "alpenjodel.de",
    "angelic.com",
    "antispam24.de",
    "city-of-liverpool.com",
    "europemail.com",
    "flashbox.5july.org",
    "ijustdontcare.com",
    "mail2america.com",
    "mail2casey.com",
    "mail2kansas.com",
    "mail2karate.com",
    "mail2liberia.com",
    "mail2marines.com",
    "mail2marty.com",
    "mail2rave.com",
    "netizen.com.ar",
    "shinedyoureyes.com",
    "snkmail.com",
    "the-galaxy.net",
    "the-whitehouse.net",
    "themillionare.net",
    "yehey.com",
    "netscape.net",
    "vip.sina.com",
    "aon.at",
    "writeme.com",
    "getmail.no",
    "geologist.com",
    "fastwebmail.it",
    "ymail.ru",
    "spamfree24.org",
    "csinibaba.hu",
    "artlover.com.au",
    "cookiemonster.com",
    "cyclefanz.com",
    "domforfb1.tk",
    "eastmail.com",
    "eurosport.com",
    "ezmail.ru",
    "from-belgium.com",
    "ignmail.com",
    "mail2biker.com",
    "mail2finance.com",
    "mail2jeffrey.com",
    "mail2lust.com",
    "mail2maryland.com",
    "mail2northcarolina.com",
    "mailme24.com",
    "netbounce.com",
    "perso.be",
    "postaweb.com",
    "pwrby.com",
    "richmondhill.com",
    "scotland.com",
    "zionweb.org",
    "10minutemail.co.za",
    "ist-ganz-allein.de",
    "outlook.jp",
    "plus.com",
    "shockinmytown.cu.cc",
    "live.ca",
    "yahoo.dk",
    "satx.rr.com",
    "yahoo.com.vn",
    "veryspeedy.net",
    "mail.gr",
    "wowmail.com",
    "badtzmail.com",
    "mail2nathan.com",
    "everyday.com.kh",
    "adelphia.net",
    "bright.net",
    "bumerang.ro",
    "celineclub.com",
    "clubnetnoir.com",
    "collegeclub.com",
    "disposable.com",
    "domforfb7.tk",
    "etrademail.com",
    "extended.com",
    "friendlymail.co.uk",
    "mail2affection.com",
    "mail2allison.com",
    "mail2alyssa.com",
    "mail2art.com",
    "mail2ca.com",
    "mail2illinois.com",
    "mail2portugal.com",
    "mail2seth.com",
    "mail2venous.com",
    "music.com",
    "muslim.com",
    "netc.pl",
    "outlook.nl",
    "temp.headstrong.de",
    "tempemail.biz",
    "the-captain.com",
    "webmail.co.yu",
    "shaw.ca",
    "eim.ae",
    "yahoo.ie",
    "yetnet.ch",
    "mynet.com",
    "nospammail.net",
    "hawaiiantel.net",
    "clubducati.com",
    "mail.co.za",
    "kulturbetrieb.info",
    "briefemail.com",
    "communityconnect.com",
    "from-germany.net",
    "fromminnesota.com",
    "insidebaltimore.net",
    "ist-einmalig.de",
    "jaydemail.com",
    "mail2country.com",
    "mail2farm.com",
    "mail2henry.com",
    "mail2italian.com",
    "mail2jeremy.com",
    "mail2ken.com",
    "mail2soldier.com",
    "medscape.com",
    "merda.usa.cc",
    "netbroadcaster.com",
    "telinco.net",
    "themail.com",
    "topmail-files.de",
    "hotmail.ca",
    "bellsouth.net",
    "forum.dk",
    "gotomy.com",
    "switzerland.org",
    "belice.com",
    "forgetmail.com",
    "fromkansas.com",
    "kommespaeter.de",
    "lolito.tk",
    "mail-awu.de",
    "mail2dough.com",
    "mail2pat.com",
    "mail2princess.com",
    "mail2togo.com",
    "mailimate.com",
    "nonpartisan.com",
    "outlook.it",
    "spoko.pl",
    "the-marine.com",
    "turual.com",
    "vaasfc4.tk",
    "email.women.com",
    "teleserve.dynip.com",
    "mail2connecticut.com",
    "mail.com",
    "gawab.com",
    "theracetrack.com",
    "mail2party.com",
    "filzmail.com",
    "mail2sean.com",
    "eastcoast.co.za",
    "hotepmail.com",
    "mailme.dk",
    "sol.dk",
    "xuno.com",
    "azimiweb.com",
    "brefmail.com",
    "fromvermont.com",
    "bullsfan.com",
    "live.co.za",
    "mail2bolivia.com",
    "thoic.com",
    "torchmail.com",
    "lawyer.com",
    "mail2calvin.com",
    "quackquack.com",
    "emailacc.com",
    "iwan-fals.com",
    "prodigy.net",
    "verizonmail.com",
    "mail2chicago.com",
    "gamebox.net",
    "mp4.it",
    "dabsol.net",
    "mail2kim.com",
    "infomart.or.jp",
    "dodgeit.com",
    "mail2devotion.com",
    "mail2irving.com",
    "mail2willie.com",
    "teamdiscovery.com",
    "dslextreme.com",
    "anonbox.net",
    "klzlk.com",
    "coolgoose.ca",
    "freemail.c3.hu",
    "live.ru",
    "mail.freetown.com",
    "hongkong.com",
    "mail2elsalvador.com",
    "hoymail.com",
    "aberystwyth.com",
    "mailru.com",
    "mail2dyke.com",
    "unican.es",
    "m4.org",
    "ivillage.com",
    "mail2mel.com",
    "cmpmail.com",
    "mail2dirk.com",
    "mail2dreamer.com",
    "mail2april.com",
    "sweb.cz",
    "ahaa.dk",
    "mail2saudi.com",
    "selfdestructingmail.com",
    "mail2tickets.com",
    "posteo.jp",
    "rediffmailpro.com",
    "iol.pt",
    "academycougars.com",
    "plasa.com",
    "terra.com.ar",
    "praize.com",
    "www2000.net",
    "gmx.fr",
    "winning.com",
    "mail2cute.com",
    "insorg-mail.info",
    "sociologist.com",
    "3126.com",
    "alphafrau.de",
    "baptistmail.com",
    "cghost.s-a-d.de",
    "chirk.com",
    "deadlymob.org",
    "fahr-zur-hoelle.org",
    "mail2brazil.com",
    "mail2caterer.com",
    "mail2cory.com",
    "mail2jonathan.com",
    "mail2luxury.com",
    "mail2racer.com",
    "pcusers.otherinbox.com",
    "swingfan.com",
    "virginbroadband.com.au",
    "webm4il.info",
    "yahoo.pt",
    "zahadum.com",
    "emailigo.de",
    "yahoo.co.jp",
    "netcourrier.com",
    "frisurf.no",
    "mail2mom.com",
    "goplay.com",
    "glay.org",
    "15meg4free.com",
    "careerbuildermail.com",
    "cyber-africa.net",
    "docs.google.com",
    "e-mails.ru",
    "goldmail.ru",
    "graduate.org",
    "grandmasmail.com",
    "imgv.de",
    "iqemail.com",
    "mail2dylan.com",
    "mail2kennedy.com",
    "mail2liz.com",
    "mail2norman.com",
    "mytemp.email",
    "pfui.ru",
    "purpleturtle.com",
    "usermail.com",
    "dump-email.info",
    "spamspot.com",
    "student.unsw.edu.au",
    "yahoo.es",
    "chello.at",
    "consultant.com",
    "maine.rr.com",
    "fibertel.com.ar",
    "volcanomail.com",
    "0815.su",
    "amorki.pl",
    "asianavenue.com",
    "cyberdude.com",
    "falseaddress.com",
    "fornow.eu",
    "hotletter.com",
    "indo-mail.com",
    "mail2marriage.com",
    "mail2suriname.com",
    "minister.com",
    "netnet.com.sg",
    "outlook.sk",
    "qwestoffice.net",
    "zoemail.org",
    "bigfoot.com",
    "weekmail.com",
    "fastmail.tw",
    "another.com",
    "mail3000.com",
    "mail2bernard.com",
    "mail2honduras.com",
    "mail2fighter.com",
    "mail2mike.com",
    "mail2gail.com",
    "sesmail.com",
    "x-mail.net",
    "grabmail.com",
    "mail2smith.com",
    "imailbox.com",
    "keromail.com",
    "4newyork.com",
    "mail.md",
    "mail2patricia.com",
    "mail2oasis.com",
    "yandex.com",
    "hotmail.dk",
    "tut.by",
    "mweb.co.za",
    "ix.netcom.com",
    "optushome.com.au",
    "cgac.es",
    "justemail.net",
    "donemail.ru",
    "mail2online.com",
    "mail2consultant.com",
    "3g.ua",
    "abusemail.de",
    "atheist.com",
    "bigramp.com",
    "emails.ru",
    "hilarious.com",
    "instructor.net",
    "mail2donald.com",
    "mail2java.com",
    "mail2nigeria.com",
    "mail2noel.com",
    "mail2sierraleone.com",
    "mail2sylvia.com",
    "mailops.com",
    "thecriminals.com",
    "visualcities.com",
    "email.unc.edu",
    "supermailer.jp",
    "mail2greece.com",
    "mail2biologist.com",
    "1webhighway.com",
    "mail2india.com",
    "o-tay.com",
    "go.ro",
    "mail2democrat.com",
    "mail2texas.com",
    "freeler.nl",
    "mail2oops.com",
    "okbank.com",
    "anfmail.com",
    "mail2imam.com",
    "mail2architect.com",
    "deskpilot.com",
    "coxmail.com",
    "dailypioneer.com",
    "uk2k.com",
    "freedomlover.com",
    "oaklandas-fan.com",
    "posteo.ie",
    "dragracer.com",
    "einrot.com",
    "lazyinbox.com",
    "mailme.gq",
    "polandmail.com",
    "qmail.com",
    "schafmail.de",
    "scottsboro.org",
    "shortmail.com",
    "sweetxxx.de",
    "cs.com",
    "mailftp.com",
    "australiamail.com",
    "tempalias.com",
    "smellfear.com",
    "mac.me",
    "ac20mail.in",
    "amuro.net",
    "arcticmail.com",
    "aristotle.org",
    "billsfan.com",
    "dodo.com.au",
    "dogmail.co.uk",
    "fastchevy.com",
    "findmail.com",
    "fromjupiter.com",
    "gtmc.net",
    "interlap.com.ar",
    "junkmail.com",
    "mail2algeria.com",
    "mail2dow.com",
    "mail2juan.com",
    "mail2marilyn.com",
    "myfastmail.com",
    "okmad.com",
    "opoczta.pl",
    "outlook.co.il",
    "outlook.co.th",
    "outlook.com.au",
    "picusnet.com",
    "sms.at",
    "stinkefinger.net",
    "verlass-mich-nicht.de",
    "vote-hillary.com",
    "wefjo.grn.cc",
    "wongfaye.com",
    "zoemail.com",
    "zzom.co.uk",
    "mail2trex.com",
    "mail2mars.com",
    "slotter.com",
    "pickupman.com",
    "mail2homer.com",
    "mail2bookmark.com",
    "freeola.net",
    "ole.com",
    "ya.com",
    "newmail.com",
    "mail2fever.com",
    "bornnaked.com",
    "mail2sydney.com",
    "fastmail.fr",
    "kayafmmail.co.za",
    "shuf.com",
    "emailengine.org",
    "beethoven.com",
    "helter-skelter.com",
    "mail2vanuatu.com",
    "housemail.com",
    "freemail.com.pk",
    "yahoo.cl",
    "hotmail.co.th",
    "sharklasers.com",
    "iwon.com",
    "despam.it",
    "mail2dallas.com",
    "freemail.et",
    "lex.bg",
    "ballyfinance.com",
    "docmail.cz",
    "free-org.com",
    "fresnomail.com",
    "llangollen.com",
    "lycos.ne.jp",
    "mail2chuck.com",
    "mail2crazy.com",
    "mail2geneva.com",
    "mail2golfer.com",
    "mail2iraq.com",
    "mailingaddress.org",
    "mittalweb.com",
    "office-dateien.de",
    "singles4jesus.com",
    "soulfoodcookbook.com",
    "viewcastmedia.com",
    "vivavelocity.com",
    "zzz.pl",
    "tempthe.net",
    "sprintmail.com",
    "cosmorph.com",
    "mail.kmsp.com",
    "freepizzamail.org",
    "usa.net",
    "mail.goo.ne.jp",
    "mailworks.org",
    "mt2009.com",
    "mail2president.com",
    "progetplus.it",
    "yyhmail.com",
    "allsaintsfan.com",
    "atlaswebmail.com",
    "bigassweb.com",
    "freenet.kg",
    "i-france.com",
    "labetteraverouge.at",
    "mail2marvin.com",
    "mail2sexy.com",
    "mail2technician.com",
    "ntelos.net",
    "theplate.com",
    "topgamers.co.uk",
    "uswestmail.net",
    "felicity.com",
    "nhmail.com",
    "188.com",
    "myrambler.ru",
    "partybombe.de",
    "zoominternet.net",
    "techemail.com",
    "jetable.com",
    "powdahound.com",
    "bangkok2000.com",
    "probemail.com",
    "snail-mail.ney",
    "dwp.net",
    "mail2son.com",
    "freewebemail.com",
    "orbitel.bg",
    "fastmail.ca",
    "jokes.com",
    "homelocator.com",
    "globetrotter.net",
    "mariahc.com",
    "ziplip.com",
    "sabreshockey.com",
    "ml1.net",
    "mail2telephone.com",
    "coldmail.com",
    "mail2way.com",
    "hotmail.co.il",
    "mail2cliff.com",
    "mail2salaam.com",
    "friends-cafe.com",
    "comcast.net",
    "airtel.in",
    "live.no",
    "mail.pt",
    "n2business.com",
    "mail2baby.com",
    "mail2bahamas.com",
    "mail2leo.com",
    "mail2faith.com",
    "postaccesslite.com",
    "saintly.com",
    "mail2shoot.com",
    "canwetalk.com",
    "ultrapostman.com",
    "mail2taboo.com",
    "mail2hal.com",
    "wanadoo.nl",
    "virginmedia.com",
    "spamfree24.com",
    "virgilio.it",
    "live.in",
    "munich.com",
    "hispavista.com",
    "uk8.net",
    "dublin.ie",
    "musicscene.org",
    "ass.pp.ua",
    "digibel.be",
    "infomail.es",
    "iremail.de",
    "mail2armenia.com",
    "mail2bulgaria.com",
    "mail2maine.com",
    "mail2mississippi.com",
    "mail2rent.com",
    "mail2rome.com",
    "mail2srilanka.com",
    "mail2wally.com",
    "privymail.de",
    "regspaces.tk",
    "schreib-doch-mal-wieder.de",
    "yert.ye.vc",
    "alice.it",
    "embarqmail.com",
    "saudia.com",
    "hotmail.ru",
    "chemist.com",
    "mail2english.com",
    "0sg.net",
    "autograf.pl",
    "azazazatashkent.tk",
    "calendar-server.bounces.google.com",
    "fathersrightsne.org",
    "freeaccount.com",
    "gazibooks.com",
    "gotti.otherinbox.com",
    "kapoorweb.com",
    "mail2blonde.com",
    "mail2culture.com",
    "mail2football.com",
    "mail2german.com",
    "mail2musician.com",
    "mail2oman.com",
    "mail2russian.com",
    "message.myspace.com",
    "migmail.net",
    "postmark.net",
    "skafan.com",
    "spam.2012-2016.ru",
    "spamfree24.info",
    "the-dutchman.com",
    "thezhangs.net",
    "xmastime.com",
    "livemail.tw",
    "poczta.fm",
    "centrum.cz",
    "spamgourmet.com",
    "yahoo.co.th",
    "ubbi.com",
    "punkass.com",
    "mail2persian.com",
    "sniper.hu",
    "beddly.com",
    "fromtennessee.com",
    "grungecafe.com",
    "ieh-mail.de",
    "kinki-kids.com",
    "lobbyist.com",
    "lopezclub.com",
    "mail2dance.com",
    "mail2hephaestus.com",
    "mail2madagascar.com",
    "mail2noah.com",
    "mail2stockmarket.com",
    "mail2ukraine.com",
    "roosh.com",
    "seekstoyboy.com",
    "sexmagnet.com",
    "dacoolest.com",
    "mail2idaho.com",
    "web-police.com",
    "mail2finland.com",
    "animal.net",
    "y7mail.com",
    "cia-agent.com",
    "trust-me.com",
    "htp-tel.de",
    "mail2switzerland.com",
    "seductive.com",
    "packersfan.com",
    "mail2doug.com",
    "land.ru",
    "get2mail.fr",
    "sent.as",
    "mail2crystal.com",
    "online.ie",
    "mail2mindreader.com",
    "youareadork.com",
    "hardcorefreak.com",
    "email.wm.edu",
    "mail2hestia.com",
    "stockracer.com",
    "lycos.com",
    "visitweb.com",
    "mail2patrick.com",
    "conexcol.com",
    "live.nl",
    "apmail.com",
    "mikrotamanet.com",
    "mail2brunette.com",
    "marijuana.nl",
    "vivianhsu.net",
    "earthling.net",
    "love.com",
    "mail2utah.com",
    "hotvoice.com",
    "doctor.com",
    "usit.net",
    "priest.com",
    "mail2laurie.com",
    "mail2wired.com",
    "canadianmail.com",
    "lycosemail.com",
    "mail2lebanon.com",
    "snoopymail.com",
    "bellatlantic.net",
    "flashemail.com",
    "zdnetmail.com",
    "perthmail.com",
    "singpost.com",
    "dallas.theboys.com",
    "mac.fr",
    "postino.ch",
    "gamespotmail.com",
    "mail2leon.com",
    "mail2bobby.com",
    "pchome.com.tw",
    "tempemail.net",
    "discofan.com",
    "coollist.com",
    "china.net.vg",
    "mail2nelson.com",
    "email.cz",
    "myself.com",
    "wwdg.com",
    "mail2southpole.com",
    "mail2smooth.com",
    "iinet.net.au",
    "jetable.net",
    "telus.net",
    "mail2nevada.com",
    "your-house.com",
    "america.hm",
    "cia.hu",
    "mail2iowa.com",
    "123qwe.co.uk",
    "cyberbabies.com",
    "mail2sweden.com",
    "mail2belize.com",
    "portugalnet.com",
    "kabelfoon.nl",
    "zoznam.sk",
    "rogers.com",
    "mail2floyd.com",
    "uymail.com",
    "thewizzard.com",
    "bitpage.net",
    "bigfoot.de",
    "yourssincerely.com",
    "athenachu.net",
    "mail2swim.com",
    "mail2hope.com",
    "mail2007.com",
    "mailbox.hu",
    "mail2ophthalmologist.com",
    "globalpagan.com",
    "altavista.se",
    "mail2southkorea.com",
    "n2.com",
    "aol.es",
    "10mail.org",
    "aircraftmail.com",
    "hab-verschlafen.de",
    "lastmail.co",
    "soodomail.com",
    "viditag.com",
    "yahoo.de",
    "home.nl",
    "hispeed.ch",
    "zonnet.nl",
    "live.com.my",
    "arnet.com.ar",
    "cutey.com",
    "petml.com",
    "acceso.or.cr",
    "she.com",
    "2911.net",
    "atl.lv",
    "beeebank.com",
    "cabacabana.com",
    "clubmember.org",
    "emeil.ir",
    "fastnissan.com",
    "freeandsingle.com",
    "internetdrive.com",
    "mail2black.com",
    "mail2kathleen.com",
    "mail2kosher.com",
    "mail2matthew.com",
    "mail2potatohead.com",
    "mailquack.com",
    "mailrock.biz",
    "press.co.jp",
    "sky.com",
    "azet.sk",
    "students.towson.edu",
    "consolidated.net",
    "0815.ru",
    "thisisnotmyrealemail.com",
    "spambox.us",
    "legislator.com",
    "centermail.at",
    "emailz.ga",
    "everymail.net",
    "funkfan.com",
    "hello.net.au",
    "joelonsoftware.com",
    "mail2artist.com",
    "mail2barter.com",
    "mail2harold.com",
    "mail2louis.com",
    "mail2model.com",
    "mail2sa.com",
    "mail2u4me.com",
    "mail2whip.com",
    "radiku.ye.vc",
    "ruttolibero.com",
    "rvshop.com",
    "sudoweb.net",
    "the-snake.com",
    "trashdevil.de",
    "usaaccess.net",
    "yourlifesucks.cu.cc",
    "ualberta.ca",
    "ftml.net",
    "me.com.br",
    "no-spam.ws",
    "the-fastest.net",
    "mail2anna.com",
    "mail2broker.com",
    "baldpapa.de",
    "bladesmail.net",
    "burstmail.info",
    "cyberleports.com",
    "from-america.com",
    "get.pp.ua",
    "grandmamail.com",
    "justicemail.com",
    "lionsfan.com.au",
    "mail2computer.com",
    "mail2diana.com",
    "mail2k.ru",
    "mail2madrid.com",
    "mail2psychiatrist.com",
    "mailinatar.com",
    "orgmail.net",
    "pinoymail.com",
    "shootmail.com",
    "vip.onet.pl",
    "vkcode.ru",
    "vote4gop.org",
    "hotmail.com.br",
    "aim.com",
    "excite.com",
    "live.com.sg",
    "xsmail.com",
    "ayna.com",
    "bonbon.net",
    "mail2dana.com",
    "123box.net",
    "dasdasdascyka.tk",
    "fatcock.net",
    "fromcolorado.com",
    "fromoklahoma.com",
    "gocollege.com",
    "gyorsposta.hu",
    "ipoo.org",
    "lolfreak.net",
    "mail2aaron.com",
    "mail2christian.com",
    "mail2cyprus.com",
    "mail2government.com",
    "nervhq.org",
    "oikrach.com",
    "opayq.com",
    "sinnlos-mail.de",
    "upf.org",
    "volloeko.de",
    "vorsicht-scharf.de",
    "wilemail.com",
    "wombles.com",
    "bkkmail.com",
    "ckaazaza.tk",
    "emailage.gq",
    "littleapple.com",
    "ro.ru",
    "will-hier-weg.de",
    "yahoo.co.za",
    "hotmail.con",
    "arcor.de",
    "usa.com",
    "hotmail.om",
    "mail2network.com",
    "60minutemail.com",
    "aamail.net",
    "aichi.com",
    "h-mail.us",
    "hotfire.net",
    "kansascity.com",
    "mail2american.com",
    "mail2andrea.com",
    "mail2baptist.com",
    "mail2catwalk.com",
    "mail2devoted.com",
    "mail2emily.com",
    "mail2in.com",
    "mail2jake.com",
    "mail2nasdaq.com",
    "message.hu",
    "reply.hu",
    "saynotospams.com",
    "seanet.com",
    "shitaway.gq",
    "the-airforce.com",
    "the18th.com",
    "thecoolguy.com",
    "daum.net",
    "ptd.net",
    "tele2.nl",
    "execs.com",
    "swissmail.net",
    "mailpride.com",
    "ciaoweb.it",
    "amnetsal.com",
    "dearriba.com",
    "elvis.com",
    "ezcybersearch.com",
    "mail2aries.com",
    "mail2darlene.com",
    "mail2eddie.com",
    "mail2irwin.com",
    "mail2martin.com",
    "mail2stock.com",
    "mail4trash.com",
    "nonspam.eu",
    "nxt.ru",
    "okhuman.com",
    "outlook.com.tr",
    "saintmail.net",
    "smapxsmap.net",
    "yahoo.com.is",
    "zzn.com",
    "billsfan.net",
    "stones.com",
    "juniormail.com",
    "speedymail.org",
    "baseballmail.com",
    "posteo.co.uk",
    "posteo.cr",
    "fetchmail.com",
    "socceramerica.net",
    "inoutbox.com",
    "home-email.com",
    "i-plus.net",
    "163.com",
    "msn.com",
    "bbox.fr",
    "superonline.com",
    "mailmight.com",
    "mail2juggler.com",
    "jazzandjava.com",
    "cooperationtogo.net",
    "cybertrains.org",
    "deagot.com",
    "inmano.com",
    "mail2billy.com",
    "mail2donna.com",
    "mail2spectrum.com",
    "mail2terri.com",
    "maxmail.co.uk",
    "my.com",
    "our.st",
    "partlycloudy.com",
    "telstra.com",
    "twinstarsmail.com",
    "zipido.com",
    "xs4all.nl",
    "ntlworld.com",
    "mail2beauty.com",
    "mail2rhodeisland.com",
    "berlin.de",
    "tatanova.com",
    "mail2diamond.com",
    "rock.com",
    "mail2perry.com",
    "mail2carolyn.com",
    "mail2brussels.com",
    "yebox.com",
    "mail2gemini.com",
    "mailite.com",
    "xmsnet.nl",
    "html.tou.com",
    "yahoo.com.ar",
    "adam.com.au",
    "msa.hinet.net",
    "snet.net",
    "yahoo.jp",
    "ttml.co.in",
    "mail2uae.com",
    "dumpyemail.com",
    "kuwait-mail.com",
    "mail2dentist.com",
    "mail2ethan.com",
    "mail2milton.com",
    "mail2visionary.com",
    "mauritius.com",
    "planetaccess.com",
    "strongguy.com",
    "hismail.cc",
    "herono1.com",
    "mail2leslie.com",
    "prolaunch.com",
    "mail2southafrica.com",
    "mail2myboat.com",
    "wkbwmail.com",
    "netsero.net",
    "seguros.com.br",
    "fromwyoming.com",
    "zeepost.nl",
    "mscold.com",
    "mail2admiral.com",
    "monemail.fr.nf",
    "iespana.es",
    "mail2philippines.com",
    "ezmail.egine.com",
    "ados.fr",
    "pigpig.net",
    "mail2mexico.com",
    "qprfans.com",
    "mail2cherry.com",
    "me.it",
    "fmgirl.com",
    "city-of-bath.org",
    "444.net",
    "amuromail.com",
    "uole.com.ve",
    "ukdreamcast.com",
    "telecomitalia.it",
    "windstream.net",
    "mchsi.com",
    "t-online.hu",
    "eastlink.ca",
    "1mum.com",
    "pro.hu",
    "6mail.cf",
    "email.su",
    "go2net.com",
    "imtoosexy.com",
    "mail2mildred.com",
    "mailforspam.com",
    "mailpost.zzn.com",
    "pezeshkpour.com",
    "serga.com.ar",
    "sportemail.com",
    "t2mail.com",
    "teenagedirtbag.com",
    "trickmail.net",
    "yemenmail.com",
    "oxidiser.net",
    "wh4f.org",
    "techseek.com",
    "zeeks.com",
    "telebot.net",
    "incognitomail.net",
    "altavista.com",
    "emailmiser.com",
    "bluemail.dk",
    "dygo.com",
    "epix.net",
    "lovergirl.com",
    "mail2alcoholic.com",
    "mail2cynthia.com",
    "mail2desert.com",
    "mail2grab.com",
    "mail2guatemala.com",
    "mail2kirk.com",
    "mail2malawi.com",
    "mail2normal.com",
    "mail2victor.com",
    "mailboom.com",
    "talkcity.com",
    "the-boss.com",
    "risquemail.com",
    "live.cl",
    "musician.org",
    "korea.com",
    "uku.co.uk",
    "baptized.com",
    "coolmail.net",
    "dadacasa.com",
    "data54.com",
    "existiert.net",
    "heartthrob.com",
    "hotpop3.com",
    "mail2andy.com",
    "mail2anne.com",
    "mail2concert.com",
    "mail2costarica.com",
    "mail2cowgirl.com",
    "mail2joan.com",
    "mail2mambo.com",
    "mail2newmexico.com",
    "mail2park.com",
    "mail2phoenix.com",
    "mail2think.com",
    "mail2wyoming.com",
    "mail2xfiles.com",
    "rin.ru",
    "sbcglobal.com",
    "the-newsletter.net",
    "posteo.is",
    "simnet.is",
    "mail2dillon.com",
    "onet.eu",
    "posta.ro",
    "lopl.co.cc",
    "fromiowa.com",
    "webave.com",
    "tom.com",
    "mail2cowboy.com",
    "telerymd.com",
    "mail2helen.com",
    "fromwestvirginia.com",
    "scarlet.be",
    "gmail.com.br",
    "jordanmail.com",
    "gua.net",
    "mortaza.com",
    "flashmail.com",
    "recycler.com",
    "popstar.com",
    "aliyun.com",
    "mail2scott.com",
    "bunko.com",
    "mailinator2.com",
    "operamail.com",
    "maileater.com",
    "mail2rachel.com",
    "webmail.hu",
    "classicmail.co.za",
    "mail2ralph.com",
    "looksmart.com",
    "mail2lao.com",
    "mail2roberta.com",
    "cornerpub.com",
    "btopenworld.co.uk",
    "happemail.com",
    "mail2marcia.com",
    "hehe.com",
    "mail2poet.com",
    "kgb.hu",
    "mundomail.net",
    "veryfast.biz",
    "aliceadsl.fr",
    "stdmail.kku.ac.th",
    "mail2blues.com",
    "aaahmail.com",
    "from-asia.com",
    "mail2bruce.com",
    "dmailman.com",
    "end-war.com",
    "nativeweb.net",
    "freemail.nl",
    "mynetaddress.com",
    "vcmail.com",
    "mail.theboys.com",
    "deutschland-net.com",
    "freesurf.nl",
    "throwawayemailaddress.com",
    "andylau.net",
    "mailisent.com",
    "fromflorida.net",
    "mail2one.com",
    "mail2wine.com",
    "student.umass.edu",
    "mail2yahalla.com",
    "psi.net",
    "web-mail-service.de",
    "mail2kenny.com",
    "olg.com",
    "jazzfan.com",
    "usma.net",
    "alltel.net",
    "positive-thinking.com",
    "mail2leone.com",
    "internet-police.com",
    "caramail.com",
    "mail2eos.com",
    "mail2miami.com",
    "hotmail.fr",
    "nativestar.net",
    "mail2hypnos.com",
    "mail2erin.com",
    "mail2jordan.com",
    "skizo.hu",
    "ifoward.com",
    "mail2diplomat.com",
    "yam.com",
    "jippii.fi",
    "mail2travis.com",
    "interaccess.com",
    "fromnewjersey.com",
    "internetemails.net",
    "mail2brook.com",
    "online.nl",
    "mail2wow.com",
    "fastmail.nl",
    "mailexcite.com",
    "posteo.no",
    "jakuza.hu",
    "gmai.com",
    "mail4u.nl",
    "yahoo.co.nz",
    "mail2christie.com",
    "mail2rose.com",
    "netzero.com",
    "150ml.com",
    "mail2rwanda.com",
    "mail2letter.com",
    "mail2idontknow.com",
    "guy.com",
    "studiocom.com",
    "zeelandnet.nl",
    "knology.net",
    "bofthew.com",
    "zippymail.info",
    "beefmilk.com",
    "zybermail.com",
    "vodamail.co.za",
    "hotmail.com.tr",
    "mail2tourist.com",
    "legalactions.com",
    "mail2hungary.com",
    "mail2steve.com",
    "mobilbatam.com",
    "norikomail.com",
    "blackplanet.com",
    "mail2sabrina.com",
    "net4b.pt",
    "mail2sam.com",
    "city-of-swansea.com",
    "coid.biz",
    "tsamail.co.za",
    "3ammagazine.com",
    "mail2curt.com",
    "writemeback.com",
    "cinci.rr.com",
    "gmx.us",
    "wanadoo.fr",
    "publicist.com",
    "mail2lawrence.com",
    "adios.net",
    "rezai.com",
    "desertmail.com",
    "mail2ask.com",
    "sale-sale-sale.com",
    "fromnewhampshire.com",
    "newyork.com",
    "mail2northdakota.com",
    "mailcan.com",
    "mail2mandy.com",
    "over-the-rainbow.com",
    "start.com.au",
    "freemail.de",
    "accessgcc.com",
    "mail2hugh.com",
    "jazzgame.com",
    "the-englishman.com",
    "mail2mp3.com",
    "mailpanda.com",
    "pmail.net",
    "copacabana.com",
    "mail2litigator.com",
    "noos.fr",
    "nospam4.us",
    "mail2eros.com",
    "strompost.com",
    "operafan.com",
    "mail2larry.com",
    "linuxmail.org",
    "mail2keith.com",
    "boatracers.com",
    "mail2nancy.com",
    "crwmail.com",
    "cubiclink.com",
    "mail2dorothy.com",
    "mail2tyler.com",
    "pcpostal.com",
    "mauimail.com",
    "letsgomets.net",
    "mail2race.com",
    "mail2brittany.com",
    "fastmail.jp",
    "mail2recruiter.com",
    "3dmail.com",
    "comprendemail.com",
    "itesm.mx",
    "doglover.com",
    "virgin.net",
    "firemail.de",
    "buckeyemail.osu.edu",
    "qatarmail.com",
    "scottishmail.co.uk",
    "mail2joy.com",
    "mail2michael.com",
    "mail2student.com",
    "mail2lionel.com",
    "24horas.com",
    "parrot.com",
    "rescueteam.com",
    "cityoflondon.org",
    "ns.sympatico.ca",
    "a1.net",
    "wowway.com",
    "mailnator.com",
    "anonymbox.com",
    "courrieltemporaire.com",
    "bluewin.ch",
    "sc.rr.com",
    "iol.it",
    "cybernet.it",
    "mail2aha.com",
    "connect4free.net",
    "depechemode.com",
    "donjuan.com",
    "gustr.com",
    "hopemail.biz",
    "hypernautica.com",
    "karbasi.com",
    "love.cz",
    "net-c.ca",
    "nur-fuer-spam.de",
    "ourklips.com",
    "the-russian.com",
    "uk2net.com",
    "xzapmail.com",
    "scryptmail.com",
    "email.sc.edu",
    "gwmail.gwu.edu",
    "mail2hawaii.com",
    "tech4peace.org",
    "mail2zeus.com",
    "cyberforeplay.net",
    "oddpost.com",
    "talk21.com",
    "warrior.hu",
    "shaniastuff.com",
    "mail2poland.com",
    "austrosearch.net",
    "ummah.org",
    "stade.fr",
    "mail2bob.com",
    "mail2flexible.com",
    "bikeracers.net",
    "temporaryemail.net",
    "hotamil.com",
    "mailmetrash.com",
    "ca.rr.com",
    "jumpy.it",
    "mail2tango.com",
    "antongijsen.com",
    "casablancaresort.com",
    "ethos.st",
    "filipinolinks.com",
    "free.com.pe",
    "from-china.net",
    "gamegeek.com",
    "golfmail.be",
    "gorontalo.net",
    "indexa.fr",
    "l33r.eu",
    "maennerversteherin.de",
    "mail-me.com",
    "mail2ballerina.com",
    "mail2galaxy.com",
    "mail2heaven.com",
    "mail2moslem.com",
    "maltesemail.com",
    "ralib.com",
    "surfree.com",
    "the-big-apple.com",
    "188mail.com",
    "amilegit.com",
    "ymail.com",
    "bigmir.net",
    "zipmail.com",
    "diplomats.com",
    "aeiou.pt",
    "sofort-mail.de",
    "mail2usa.com",
    "hotbrev.com",
    "mail2create.com",
    "123india.com",
    "aaronkwok.net",
    "domozmail.com",
    "fakemailz.com",
    "hollywoodkids.com",
    "last-chance.pro",
    "mail2kyle.com",
    "mail2ship.com",
    "mailto.de",
    "migumail.com",
    "onlinewiz.com",
    "shitaway.cu.cc",
    "sialkotian.com",
    "u2club.com",
    "walkmail.ru",
    "web-mail.pp.ua",
    "mail.dk",
    "mail.pf",
    "hotmail.com.au",
    "aol.fr",
    "detik.com",
    "the-quickest.com",
    "mail2pop.com",
    "dezigner.ru",
    "from-japan.net",
    "fromtexas.com",
    "gol.com",
    "mail2abc.com",
    "mail2cuba.com",
    "mail2eva.com",
    "mail2liquid.com",
    "mail2oklahoma.com",
    "mail2phil.com",
    "mail2rita.com",
    "mailseal.de",
    "racingfan.com.au",
    "sudomail.com",
    "tech-center.com",
    "yournightmare.com",
    "mail2many.com",
    "mail2maybe.com",
    "mail2tommy.com",
    "mail2lovable.com",
    "realemail.net",
    "iki.fi",
    "ihug.co.nz",
    "4warding.com",
    "kickassmail.com",
    "freeukisp.co.uk",
    "centoper.it",
    "gramszu.net",
    "engineer.com",
    "riopreto.com.br",
    "geocities.com",
    "coolkiwi.com",
    "nenter.com",
    "fromohio.com",
    "mail2sevenseas.com",
    "workmail.com",
    "mail2sailor.com",
    "tfanus.com.er",
    "mac.com",
    "yandex.ru",
    "spambob.net",
    "city-of-lincoln.com",
    "clubalfa.com",
    "rome.com",
    "perfectmail.com",
    "ismart.net",
    "mail2join.com",
    "mail2mauritania.com",
    "mail2dc.com",
    "mail2kelsey.com",
    "powerfan.com",
    "roughnet.com",
    "fakeinformation.com",
    "ist-allein.info",
    "mailismagic.com",
    "millionairemail.com",
    "outlook.dk",
    "wo.com.cn",
    "rcn.com",
    "mailup.net",
    "mytrashmail.com",
    "coder.hu",
    "uyuyuy.com",
    "autoescuelanerja.com",
    "cheyenneweb.com",
    "enel.net",
    "mail2atlas.com",
    "mail2bombay.com",
    "mail2dawn.com",
    "mail2jamaica.com",
    "mail2jeweler.com",
    "mail2kay.com",
    "mail2lois.com",
    "mail2minister.com",
    "mail2niger.com",
    "mail2senate.com",
    "mail2tramp.com",
    "offroadwarrior.com",
    "shitaway.tk",
    "spacetowns.com",
    "storksite.com",
    "sudolife.me",
    "vomoto.com",
    "www.e4ward.com",
    "posteo.si",
    "qis.net",
    "email.cbes.net",
    "facebookmail.com",
    "sudoverse.com",
    "astrosfan.net",
    "2bmail.co.uk",
    "mailenvelopes.com",
    "buzzlemail.com",
    "frontiernet.net",
    "jnxjn.com",
    "mail2tanzania.com",
    "mail2sound.com",
    "globomail.com",
    "mailzilla.org",
    "dynamitemail.com",
    "jmail.co.za",
    "emailinfive.com",
    "mail2botswana.com",
    "blackburnmail.com",
    "mail2oceanographer.com",
    "birdowner.net",
    "mail2kendall.com",
    "mixmail.com",
    "mail2glen.com",
    "chek.com",
    "mail2stephanie.com",
    "cuemail.com",
    "mailstartplus.com",
    "naz.com",
    "mail2eu.com",
    "amele.com",
    "haltospam.com",
    "test.com",
    "students.ecu.edu",
    "webstation.com",
    "space-travel.com",
    "hotpop.com",
    "caltanet.it",
    "mail2parker.com",
    "mail2xox.com",
    "ukr.net",
    "postafree.com",
    "mailasia.com",
    "switchboardmail.com",
    "mail2guy.com",
    "mail2resort.com",
    "cais.net",
    "brittonsign.com",
    "kimo.com",
    "mail2miracle.com",
    "pobox.sk",
    "mail2jasmine.com",
    "latemodels.com",
    "mail2iceland.com",
    "netmongol.com",
    "mail2sleek.com",
    "mail2painter.com",
    "tradermail.info",
    "loveable.com",
    "mail.uc.edu",
    "moldova.cc",
    "mail2japanese.com",
    "windowslive.com",
    "city-of-york.net",
    "jump.com",
    "dbmail.com",
    "deal-maker.com",
    "mail2alpha.com",
    "neo.rr.com",
    "mail2skier.com",
    "macbox.com",
    "019.pfr.ru",
    "doramail.com",
    "mail2northamerica.com",
    "live.hk",
    "sammimail.com",
    "stealthmail.com",
    "lick101.com",
    "spamex.com",
    "heesun.net",
    "gee-wiz.com",
    "tempinbox.co.uk",
    "letterbox.com",
    "tot.net",
    "mail.byte.it",
    "hotmail.com.mx",
    "posteo.uk",
    "netcom.no",
    "fansonlymail.com",
    "hailmail.net",
    "kiwitown.com",
    "levele.hu",
    "mail2lance.com",
    "snafu.de",
    "emailpinoy.com",
    "miatadriver.com",
    "coolmail.com",
    "littleblueroom.com",
    "mail2zephir.com",
    "mundo-r.com",
    "xoom.com",
    "headbone.com",
    "email2me.net",
    "astrolover.com",
    "junk1e.com",
    "e4ward.com",
    "hhdevel.com",
    "interia.pl",
    "mail2jaime.com",
    "mail2jamie.com",
    "mail2libertarian.com",
    "adinet.com.uy",
    "mail2nicole.com",
    "mail2warren.com",
    "wyrm.supernews.com",
    "hotmail.co",
    "trashymail.com",
    "ehmail.com",
    "yahoo.gr",
    "hotmail.gr",
    "mail2laugh.com",
    "mail2mongolia.com",
    "cliffhanger.com",
    "kellychen.com",
    "mail2jessica.com",
    "hotbot.com",
    "ematic.com",
    "marchmail.com",
    "mail2popular.com",
    "mail2lola.com",
    "mail2weird.com",
    "mail2reggie.com",
    "mail2married.com",
    "okuk.com",
    "india.com",
    "mail2kazakhstan.com",
    "tele2.ch",
    "versatel.nl",
    "nepwk.com",
    "prtnx.com",
    "mail2agent.com",
    "yahoo.fr",
    "shahweb.net",
    "mail2fondness.com",
    "4email.net",
    "mail2freudian.com",
    "tele2.at",
    "nowmymail.com",
    "mail2valerie.com",
    "mail2pm.com",
    "truthmail.com",
    "stalag13.com",
    "mail2green.com",
    "umpire.com",
    "posteo.eu",
    "the-hooligan.com",
    "hsuchi.net",
    "mail2edgar.com",
    "krongthip.com",
    "mail2mali.com",
    "live.cn",
    "mail2rodney.com",
    "erols.com",
    "medmail.com",
    "oi.com.br",
    "ovi.com",
    "ihateclowns.com",
    "dartmail.net",
    "263.net",
    "maxleft.com",
    "mail2rosie.com",
    "mail.be",
    "mail2millionaire.com",
    "vodafone.de",
    "mail2wild.com",
    "mail2cindy.com",
    "pacific.net.sg",
    "mail2ballplayer.com",
    "iraqmail.com",
    "ravemail.com",
    "highquality.com",
    "mjfrogmail.com",
    "hawaii.rr.com",
    "mail2phonecall.com",
    "freeuk.net",
    "freesurf.fr",
    "mail2mark.com",
    "ttmail.com",
    "myphantomemail.com",
    "advalvas.be",
    "dc.rr.com",
    "mail2cat.com",
    "assala.com",
    "ksanmail.com",
    "mail2paula.com",
    "unitybox.de",
    "mail2athena.com",
    "from-france.net",
    "mail2therapy.com",
    "abv.bg",
    "deskmail.com",
    "bettergolf.net",
    "mail2search.com",
    "mail2films.com",
    "modomail.com",
    "mail2my.com",
    "mail2josh.com",
    "soccermail.com",
    "mailoye.com",
    "mail2missionary.com",
    "freemail.gr",
    "easy.to",
    "s-mail.com",
    "mail2mozambique.com",
    "wowgirl.com",
    "mail2stacy.com",
    "archaeologist.com",
    "aol.jp",
    "inbox.ru",
    "sbcglobal.net",
    "mail2mauritius.com",
    "e-tapaal.com",
    "fromconnecticut.com",
    "mail2marhaba.com",
    "mail2paraguay.com",
    "the-genius.com",
    "mail2ghana.com",
    "mail2golfclub.com",
    "spacebank.com",
    "chinamail.com",
    "coolsite.net",
    "gelitik.in",
    "herr-der-mails.de",
    "humanoid.net",
    "merda.flu.cc",
    "web-contact.info",
    "mail2clark.com",
    "geek.hu",
    "pakistanoye.com",
    "scandalmail.com",
    "mail2joanna.com",
    "mail2sharon.com",
    "mail2justme.com",
    "mail2robin.com",
    "emailgroups.net",
    "mail2yachtclub.com",
    "mail2phyllis.com",
    "mail2pickup.com",
    "mail2morocco.com",
    "mail2becky.com",
    "fromgeorgia.com",
    "infovia.com.ar",
    "mailpuppy.com",
    "netpiper.com",
    "frommaryland.com",
    "mail2rex.com",
    "mail2catlover.com",
    "mail2swimmer.com",
    "sunrise.ch",
    "teleworm.com",
    "wuzupmail.net",
    "fr33mail.info",
    "seznam.cz",
    "atlas.cz",
    "gurlmail.com",
    "gmail.fr",
    "ajacied.com",
    "netlimit.com",
    "mail2liechtenstein.com",
    "approvers.net",
    "mail2angela.com",
    "aeneasmail.com",
    "icestorm.com",
    "everyone.net",
    "mail2arabic.com",
    "mail2maxwell.com",
    "mail2politician.com",
    "tiscali.co.uk",
    "mail2mason.com",
    "atina.cl",
    "mail2jay.com",
    "mail2jazz.com",
    "hookup.net",
    "weedmail.com",
    "mailas.com",
    "mail2gavin.com",
    "gt.rr.com",
    "10minutemail.com",
    "edtnmail.com",
    "eml.cc",
    "fightallspam.com",
    "inet.net.au",
    "mailcc.com",
    "medical.net.au",
    "ntscan.com",
    "online.ms",
    "outlook.kr",
    "xaker.ru",
    "posteo.se",
    "mail.spaceports.com",
    "yahoo.co.id",
    "yopmail.com",
    "yeah.net",
    "lyse.net",
    "c2i.net",
    "pochta.ru",
    "poste.it",
    "latinmail.com",
    "mail2slim.com",
    "spamthis.co.uk",
    "ajaxapp.net",
    "boyzoneclub.com",
    "chez.com",
    "churchusa.com",
    "fromnorthdakota.com",
    "hidzz.com",
    "i.am",
    "isp9.net",
    "machinecandy.com",
    "mail2aether.com",
    "mail2horse.com",
    "mail2leonard.com",
    "mail2plato.com",
    "mail2sarah.com",
    "mail2taiwan.com",
    "mail2turkmenistan.com",
    "mox.pp.ua",
    "tiscali.se",
    "posteo.dk",
    "talktalk.co.uk",
    "mail2gloria.com",
    "123mail.cl",
    "frontier.com",
    "deseretmail.com",
    "internetbiz.com",
    "backstreet-boys.com",
    "boardermail.com",
    "science.com.au",
    "speedpost.net",
    "mail2judge.com",
    "mail2belgium.com",
    "mail2marries.com",
    "mail2chemist.com",
    "mail2sanfrancisco.com",
    "pool-sharks.com",
    "razormail.com",
    "fea.st",
    "mail2palau.com",
    "outlook.com",
    "posteo.af",
    "happycounsel.com",
    "mac.hush.com",
    "dott.it",
    "heremail.com",
    "popmail.com",
    "swingeasyhithard.com",
    "csi.com",
    "kinglibrary.net",
    "trashymail.net",
    "mail2laura.com",
    "mail2fireman.com",
    "trash-mail.de",
    "leehom.net",
    "mail2europe.com",
    "mail2eat.com",
    "spamday.com",
    "mail2amber.com",
    "spinfinder.com",
    "wheelweb.com",
    "unforgettable.com",
    "telefonica.net",
    "rediff.com",
    "stu.owensboro.kyschools.us",
    "quicknet.nl",
    "mail2dad.com",
    "mail2breakfast.com",
    "from-england.com",
    "soldier.hu",
    "onebox.com",
    "yahoo.co.uk",
    "gmx.net",
    "yahoo.com.hk",
    "gishpuppy.com",
    "newmail.ru",
    "euskaltel.net",
    "add3000.pp.ua",
    "free-email.ga",
    "frommassachusetts.com",
    "mail2debbie.com",
    "mail2diver.com",
    "mail2irresistible.com",
    "mail2pakistan.com",
    "mail2slovenia.com",
    "mail2stlouis.com",
    "tkcity.com",
    "yada-yada.com",
    "cute-girl.com",
    "happypuppy.com",
    "cyber4all.com",
    "protonmail.com",
    "mail2apollo.com",
    "mail2haiti.com",
    "mail2vermont.com",
    "mail2genes.com",
    "afreeinternet.com",
    "scientist.com",
    "mail2ruth.com",
    "mail2white.com",
    "barcelona.com",
    "arabtop.net",
    "mail2malaysia.com",
    "pobox.com",
    "thisgirl.com",
    "mail2netherlands.com",
    "deadaddress.com",
    "collegemail.com",
    "binkmail.com",
    "wiz.cc",
    "close2you.net",
    "id-base.com",
    "racefanz.com",
    "mail2rebecca.com",
    "duno.com",
    "mail2jackie.com",
    "mail2ted.com",
    "blazemail.com",
    "conk.com",
    "fastmail.org",
    "speedrulz.com",
    "marketing.lu",
    "hotmail.nl",
    "rediffmail.com",
    "eyou.com",
    "asia.com",
    "live.ie",
    "tin.it",
    "new.rr.com",
    "mailbox.co.za",
    "city-of-coventry.com",
    "frommontana.com",
    "mail.wtf",
    "mail2lee.com",
    "mail2maldives.com",
    "mail2ride.com",
    "mochamail.com",
    "mycity.com",
    "ournet.md",
    "reality-concept.club",
    "samilan.net",
    "sogou.com",
    "the-ministry.com",
    "vorsicht-bissig.de",
    "wahoye.com",
    "gmail.it",
    "mail2found.com",
    "fastmessaging.com",
    "spamfree24.net",
    "yclub.com",
    "mail2newyork.com",
    "naver.com",
    "camidge.com",
    "freedom.usa.com",
    "ukbuilder.com",
    "bradfordfans.com",
    "mail2college.com",
    "coolsend.com",
    "abcflash.net",
    "mail2bahrain.com",
    "mail2delicious.com",
    "live.com",
    "iamawoman.com",
    "horrormail.com",
    "incredimail.com",
    "newmail.net",
    "mail2elliot.com",
    "gamail.com",
    "mail2woman.com",
    "hushmail.com",
    "tiscalinet.it",
    "freemail.lt",
    "nwldx.com",
    "dplanet.ch",
    "teewars.org",
    "magicmail.co.za",
    "4mg.com",
    "aport2000.ru",
    "bagherpour.com",
    "bolando.com",
    "dontgotmail.com",
    "fromalaska.com",
    "iamwasted.com",
    "isleuthmail.com",
    "jovem.te.pt",
    "looksmart.co.uk",
    "mail.bulgaria.com",
    "mail2dilemma.com",
    "mail2dominica.com",
    "mail2florence.com",
    "mail2gene.com",
    "mail2jennifer.com",
    "mail2muslim.com",
    "mail2sat.com",
    "mailfa.tk",
    "myworldmail.com",
    "searchwales.com",
    "vote-democrats.com",
    "worldmailer.com",
    "catsrule.garfield.com",
    "youvegotmail.net",
    "2ndmail.com",
    "swift-mail.com",
    "bluehyppo.com",
    "mail2ohio.com",
    "the-brazilian.com",
    "zuzzurello.com",
    "clearwire.net",
    "the-mailinglist.com",
    "emailx.net",
    "mail2romania.com",
    "mail2chef.com",
    "mail2star.com",
    "mail2methodist.com",
    "callnetuk.com",
    "asiapoint.net",
    "mail2beth.com",
    "mail2hyperspace.com",
    "mail2open.com",
    "beep.ru",
    "spacewar.com",
    "guyanafriends.com",
    "mail2kevin.com",
    "mail2victoria.com",
    "mail2bankrupt.com",
    "incognitomail.com",
    "rccgmail.org",
    "fastmail.mx",
    "live.com.ar",
    "muellemail.com",
    "hotmail.be",
    "netcologne.de",
    "139.com",
    "zipmail.com.br",
    "sent.com",
    "webspeed.dk",
    "nycap.rr.com",
    "mailforce.net",
    "zmail.ru",
    "optician.com",
    "antisocial.com",
    "beenhad.com",
    "big1.us",
    "cool.br",
    "curryworld.de",
    "earthdome.com",
    "getairmail.com",
    "jsrsolutions.com",
    "localbar.com",
    "looksmart.com.au",
    "mail2dionysos.com",
    "mail2engineer.com",
    "mail2hespera.com",
    "mail2linux.com",
    "northgates.net",
    "onobox.com",
    "tvstar.com",
    "abcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyzabcdefghijk.com",
    "anotherdomaincyka.tk",
    "neue-dateien.de",
    "ninfan.com",
    "slave-auctions.net",
    "svk.jp",
    "trayna.com",
    "att.net",
    "phreaker.net",
    "peachworld.com",
    "mail2abby.com",
    "mail2blackbelt.com",
    "mail2protect.com",
    "from-italy.net",
    "la.com",
    "maktoob.com",
    "terra.es",
    "eatmydirt.com",
    "srilankan.net",
    "witty.com",
    "discardmail.de",
    "mail2storage.com",
    "posteo.at",
    "mail2spain.com",
    "yesbox.net",
    "mail2mycar.com",
    "cnnsimail.com",
    "westnet.com.au",
    "posteo.pt",
    "trialbytrivia.com",
    "onewaymail.com",
    "mail2seattle.com",
    "folkfan.com",
    "mymail-in.net",
    "mail2reed.com",
    "mail2superstar.com",
    "canada.com",
    "mail2doctor.com",
    "mail2teletubbie.com",
    "mail2taurus.com",
    "mail2jim.com",
    "myownfriends.com",
    "webjump.com",
    "mail2msright.com",
    "mail2mechanic.com",
    "rochester.rr.com",
    "telecable.es",
    "mail2qatar.com",
    "mail2nauru.com",
    "mailme.lv",
    "wooow.it",
    "vlmail.com",
    "megago.com",
    "1033edge.com",
    "hotmail.com",
    "mail2vodka.com",
    "1under.com",
    "kpnplanet.nl",
    "fromkentucky.com",
    "australia.edu",
    "mail2gina.com",
    "otenet.gr",
    "chandrasekar.net",
    "mail2power.com",
    "mail2fly.com",
    "cry4helponline.com",
    "fromnewyork.net",
    "mail2tajikistan.com",
    "fastmail.im",
    "thundermail.com",
    "mail2vienna.com",
    "mail2heidi.com",
    "latino.com",
    "bimamail.com",
    "posteo.pm",
    "qq.com",
    "live.it",
    "optonline.net",
    "yahoo.co.in",
    "trash-mail.com",
    "yahoo.se",
    "ebnett.no",
    "mintemail.com",
    "icq.com",
    "beer.com",
    "lamer.hu",
    "anotherwin95.com",
    "codec.ro",
    "mail2infinity.com",
    "mail2ireland.com",
    "mail2noway.com",
    "muellmail.com",
    "myownemail.com",
    "starmail.com",
    "tempail.com",
    "weekonline.com",
    "3d-painting.com",
    "mail2rocker.com",
    "the-japanese.com",
    "comic.com",
    "lankamail.com",
    "bredband.net",
    "mail2yugoslavia.com",
    "webcity.ca",
    "mail2cambodia.com",
    "orange.fr",
    "cuteandcuddly.com",
    "programozo.hu",
    "freenet.com",
    "mail2goddess.com",
    "qwest.net",
    "pisem.net",
    "6paq.com",
    "acdcfan.com",
    "blutig.me",
    "goodnewsmail.com",
    "greenmail.net",
    "streber24.de",
    "cox.net",
    "tlen.pl",
    "bak.rr.com",
    "mailcity.com",
    "terra.cl",
    "boxemail.com",
    "chocaholic.com.au",
    "city-of-nottingham.com",
    "cybermail.net",
    "edmail.com",
    "fansworldwide.de",
    "fastchrysler.com",
    "femenino.com",
    "homemail.com",
    "kimsdisk.com",
    "mail2comedian.com",
    "mail2eritrea.com",
    "mail2heal.com",
    "mail2senegal.com",
    "mail2studio.com",
    "mail2terry.com",
    "mailandnews.com",
    "moakt.com",
    "penpen.com",
    "postmaster.twitter.com",
    "qualityservice.com",
    "sunrise-sunset.com",
    "tenchiclub.com",
    "the-master.com",
    "toomail.biz",
    "tropicalstorm.com",
    "wmail.cf",
    "live.jp",
    "hotmail.com.tw",
    "nyc.com",
    "bigblue.net.au",
    "apexmail.com",
    "mbx.cc",
    "mail2kerry.com",
    "boxfrog.com",
    "11mail.com",
    "alhilal.net",
    "fromnorthcarolina.com",
    "i-p.com",
    "mail-center.com",
    "mail2electron.com",
    "mail2frankfurt.com",
    "me-mail.hu",
    "muslimsonline.com",
    "pp.inet.fi",
    "public-files.de",
    "the-mexican.com",
    "webcammail.com",
    "yahoo.be",
    "email4u.info",
    "jet-renovation.fr",
    "racedriver.com",
    "shared-files.de",
    "temp-mail.com",
    "verizon.net",
    "solcon.nl",
    "sanook.com",
    "yepmail.net",
    "jetemail.net",
    "mail2japan.com",
    "astrosfan.com",
    "fantasticmail.com",
    "gorillaswithdirtyarmpits.com",
    "mail2helpdesk.com",
    "mail2looking.com",
    "mail2realtor.com",
    "mail2trillionaire.com",
    "rodrun.com",
    "swissmail.com",
    "usmc.net",
    "viewcastmedia.net",
    "wtvhmail.com",
    "yahoo.cz",
    "webindia123.com",
    "ua.fm",
    "secret-police.com",
    "city-of-westminster.com",
    "outlook.fr",
    "odmail.com",
    "techie.com",
    "hughes.net",
    "mail2angola.com",
    "mail2neal.com",
    "mail2hades.com",
    "email-london.co.uk",
    "telfort.nl",
    "v-sexi.com",
    "the-biker.com",
    "airforceemail.com",
    "emailstar.net",
    "politikerclub.de",
    "proconnect-mail.com",
    "posteo.fi",
    "freestamp.com",
    "pbadmail.com",
    "wideopenwest.com",
    "check.com",
    "gnwmail.com",
    "startrekmail.com",
    "ionet.net",
    "animail.net",
    "imgof.com",
    "mailinblack.com",
    "solution4u.com",
    "zweb.in",
    "flashcom.net",
    "lycos.es",
    "mail2nemesis.com",
    "ssl-mail.com",
    "mail2joann.com",
    "kaixo.com",
    "mail2song.com",
    "representative.com",
    "mail2evan.com",
    "mail2sponsor.com",
    "berkscounty.com",
    "posteo.tn",
    "mailinator.net",
    "musclemail.com",
    "studentcenter.org",
    "mail2me4u.com",
    "thepostmaster.net",
    "posteo.li",
    "truemail.co.th",
    "fromru.com",
    "fbi-agent.com",
    "posteo.lu",
    "euroseek.com",
    "mail2california.com",
    "hotmail.kz",
    "galamb.net",
    "from-spain.net",
    "mail2turbo.com",
    "ladymail.cz",
    "oicexchange.com",
    "aaamail.zzn.com",
    "mail2fairy.com",
    "coolgoose.com",
    "mail2jan.com",
    "mail2troy.com",
    "mail2china.com",
    "spamhole.com",
    "mail2uk.com",
    "homeworkcentral.com",
    "tiscali.at",
    "mail2jane.com",
    "masrawy.com",
    "sunumail.sn",
    "topteam.bg",
    "mail2ben.com",
    "e-apollo.lv",
    "journalist.com",
    "abdulnour.com",
    "travel.li",
    "poond.com",
    "oldies1041.com",
    "mail2todd.com",
    "the-wild-west.com",
    "mail2jumbo.com",
    "uol.com.mx",
    "lovelygirl.net",
    "guerillamail.com",
    "mail2denmark.com",
    "mail2close.com",
    "au.ru",
    "playful.com",
    "bigboab.com",
    "student.tuwien.ac.at",
    "swirve.com",
    "mail2clinic.com",
    "nospamfor.us",
    "games.com",
    "visto.com",
    "juno.com",
    "city-of-birmingham.com",
    "mail2cook.com",
    "student.ua.ac.be",
    "zoho.com",
    "hotmaill.com",
    "gmail.cpm",
    "mail2indiana.com",
    "myway.com",
    "pjjkp.com",
    "apollo.lv",
    "umail.iu.edu",
    "mail2jesus.com",
    "yahoo.com.au",
    "nomail2me.com",
    "imel.org",
    "fromsouthdakota.com",
    "wildmail.com",
    "mail2lipstick.com",
    "mail2wallstreet.com",
    "mail2deer.com",
    "btconnect.com",
    "cairomail.com",
    "mail2harry.com",
    "casema.nl",
    "ukcool.com",
    "mail2lou.com",
    "clixser.com",
    "epage.ru",
    "maennerversteherin.com",
    "photo-impact.eu",
    "toothfairy.com",
    "bigpond.net.au",
    "sneakemail.com",
    "mytoys-mail.de",
    "mail2ricky.com",
    "gmail.com.tw",
    "mail2uganda.com",
    "mail2adoration.com",
    "mail2cool.com",
    "iobox.com",
    "mail2debby.com",
    "mail2eli.com",
    "warmmail.com",
    "thelanddownunder.com",
    "technisamail.co.za",
    "access4less.net",
    "alex4all.com",
    "wam.co.za",
    "the-german.com",
    "nicholastse.net",
    "mail2minneapolis.com",
    "mail2jody.com",
    "emailchoice.com",
    "freemail.com.au",
    "mail2scientist.com",
    "mail2erinyes.com",
    "cloudme.com",
    "get1mail.com",
    "emailwarden.com",
    "recode.me",
    "lookugly.com",
    "the-animal.com",
    "sunpoint.net",
    "mail2arizona.com",
    "mail2willard.com",
    "sharmaweb.com",
    "mail2gsm.com",
    "twcny.rr.com",
    "extenda.net",
    "fake-mail.ga",
    "fastest.cc",
    "freundin.ru",
    "lr7.us",
    "mailmate.com",
    "pagina.de",
    "sent.at",
    "shitaway.cf",
    "stoned.com",
    "tafmail.com",
    "yandex.ua",
    "tempinbox.com",
    "mindspring.com",
    "mail2karen.com",
    "mail2psychologist.com",
    "redsfans.com",
    "mail2pisces.com",
    "frostbyte.uk.net",
    "mail2notus.com",
    "argentina.com",
    "fromdelaware.com",
    "freeola.com",
    "prontomail.com",
    "city-of-oxford.com",
    "programmer.net",
    "lover-boy.com",
    "mail2adventure.com",
    "spamfree24.de",
    "trillianpro.com",
    "austin.rr.com",
    "myfairpoint.net",
    "jetable.org",
    "hotmai.it",
    "mailc.net",
    "outgun.com",
    "dontreg.com",
    "albawaba.com",
    "backstreetboysclub.com",
    "bikeracer.com",
    "connectbox.com",
    "eelmail.com",
    "elsitio.com",
    "giga4u.de",
    "globalfree.it",
    "i-connect.com",
    "mail2batter.com",
    "mail2betty.com",
    "mail2bonn.com",
    "mail2crave.com",
    "mail2friendship.com",
    "mail2libya.com",
    "mail2mypager.com",
    "mail2pay.com",
    "mail2rare.com",
    "mail2waiter.com",
    "mail2wave.com",
    "pathfindermail.com",
    "socialworker.net",
    "stopdropandroll.com",
    "the-beauty.com",
    "the-lair.com",
    "xy9ce.tk",
    "yopmail.pp.ua",
    "cpaonline.net",
    "appleid.com",
    "2prong.com",
    "quiklinks.com",
    "motormania.com",
    "mail2save.com",
    "fastem.com",
    "lcbcmail.com",
    "netralink.com",
    "members.student.com",
    "frommississippi.com",
    "mail2rudy.com",
    "velocall.com",
    "mail2athlete.com",
    "movieluver.com",
    "alumnidirector.com",
    "nycmail.com",
    "trashmail.com",
    "cheerful.com",
    "hairdresser.net",
    "mail2lori.com",
    "wxs.nl",
    "whale-mail.com",
    "suddenlink.net",
    "fastmail.de",
    "cincinow.net",
    "tds.net",
    "vip.163.com",
    "fastmail.gr",
    "islamonline.net",
    "itelefonica.com.br",
    "go2.com.py",
    "capu.net",
    "purinmail.com",
    "hotail.com",
    "googlemail.de",
    "schweiz.org",
    "death-star.com",
    "surf3.net",
    "mailclub.fr",
    "computermail.net",
    "mbox.com.au",
    "mail2hiphop.com",
    "algeria.com",
    "sfr.fr",
    "triad.rr.com",
    "btopenworld.com",
    "tempe-mail.com",
    "swva.net",
    "megapoint.com",
    "posteo.ee",
    "wrestlingpages.com",
    "mail1st.com",
    "posteo.hr",
    "jahoopa.com",
    "space-bank.com",
    "army.net",
    "cristianemail.com",
    "ecardmail.com",
    "schoolmail.com",
    "netcom.com",
    "cyberinbox.com",
    "mail2cancer.com",
    "yogotemail.com",
    "mail2vacation.com",
    "imneverwrong.com",
    "law.com",
    "karachioye.com",
    "n2mail.com",
    "lagerlouts.com",
    "o2.co.uk",
    "mail2producer.com",
    "bachelorboy.com",
    "mail2colin.com",
    "wptamail.com",
    "e-mail.dk",
    "swipermail.zzn.com",
    "ananzi.co.za",
    "dontsendmespam.de",
    "alvilag.hu",
    "netcenter-vn.net",
    "fromalabama.com",
    "mail2karl.com",
    "mail2martha.com",
    "mail2melanie.com",
    "mail2marsha.com",
    "snakemail.com",
    "dansegulvet.com",
    "cable.net.co",
    "yourname.freeservers.com",
    "mail2sandy.com",
    "nicolastse.com",
    "tiscali.be",
    "mail2grace.com",
    "mail2movies.com",
    "broadcast.net",
    "bikerider.com",
    "mail2lauren.com",
    "irangate.net",
    "guy2.com",
    "paran.com",
    "numericable.fr",
    "mail2feeling.com",
    "rushpost.com",
    "infectgmail.com",
    "mail2fisherman.com",
    "mail2professor.com",
    "claramail.com",
    "mail2zenith.com",
    "gmail.cm",
    "mail2fanatic.com",
    "netspace.net.au",
    "fast-mail.org",
    "mail2cameroon.com",
    "netscape.com",
    "safetymail.info",
    "catholic.org",
    "live.co.uk",
    "mypartyclip.de",
    "blacksburg.net",
    "boun.cr",
    "cartelera.org",
    "centermail.de",
    "instruction.com",
    "secure-mail.cc",
    "spameater.org",
    "wirsindcool.de",
    "posteo.in",
    "mail2judy.com",
    "yahoo.in",
    "mail2000.com.tw",
    "welsh-lady.com",
    "mail2aim.com",
    "mail2hecate.com",
    "mail2monty.com",
    "mail.nu",
    "mail2southamerica.com",
    "mail2alabama.com",
    "tycoonmail.com",
    "pt.lu",
    "spambox.info",
    "great-host.in",
    "cicciociccio.com",
    "attglobal.net",
    "indocities.com",
    "ivebeenframed.com",
    "misery.net",
    "mail2lunch.com",
    "topchat.com",
    "333.com",
    "gtemail.net",
    "stargateradio.com",
    "ecompare.com",
    "mail2germany.com",
    "posteo.sg",
    "mail2barbados.com",
    "chello.nl",
    "4x4man.com",
    "redseven.de",
    "shop.de",
    "posteo.lt",
    "sinamail.com",
    "net-pager.net",
    "gocubs.com",
    "trashmail.net",
    "sacbeemail.com",
    "ecbsolutions.net",
    "yahoo.com.mx",
    "bigpond.au",
    "chammy.info",
    "dumpmail.com",
    "fettabernett.de",
    "keinpardon.de",
    "suomi24.fi",
    "jewishmail.com",
    "rotfl.com",
    "conok.com",
    "fastmail.to",
    "autorambler.ru",
    "diemailbox.de",
    "innocent.com",
    "ynnmail.com",
    "speedy.com.ar",
    "resumemail.com",
    "allracing.com",
    "angelfan.com",
    "vr9.com",
    "everytg.ml",
    "hartbot.de",
    "wolke7.net",
    "mail114.net",
    "oath.com",
    "outlawspam.com",
    "outlook.co.id",
    "yandex.pl",
    "mac-email.com",
    "direcway.com",
    "gmx.ch",
    "walla.com",
    "post.pl",
    "gmx.co.uk",
    "hvc.rr.com",
    "dsl.pipex.com",
    "name.com",
    "3xl.net",
    "e-mailanywhere.com",
    "mail2derek.com",
    "dnsmadeeasy.com",
    "xmsg.com",
    "1zhuan.com",
    "30minutesmail.com",
    "dodgit.org",
    "freemeil.gq",
    "khosropour.com",
    "kissfans.com",
    "mail.usa.com",
    "mail2care.com",
    "mail2denise.com",
    "mail2divorced.com",
    "mail2footballfan.com",
    "mail2rage.com",
    "mail2shawn.com",
    "mail2wayne.com",
    "mymacmail.com",
    "sharedmailbox.org",
    "spamcero.com",
    "thanksnospam.info",
    "posteo.pe",
    "bootybay.de",
    "freelance-france.eu",
    "gotmail.org",
    "home.de",
    "hotmail.fi",
    "magspam.net",
    "polyfaust.com",
    "spainmail.com",
    "20email.eu",
    "baldmama.de",
    "discard.gq",
    "emil.com",
    "manybrain.com",
    "streetwisemail.com",
    "war-im-urlaub.de",
    "quepasa.com",
    "reallyfast.biz",
    "ieee.org",
    "thaimail.com",
    "stny.rr.com",
    "supereva.it",
    "mail2time.com",
    "mail2monaco.com",
    "mail.az",
    "mail2savings.com",
    "orange.es",
    "buffymail.com",
    "hiphopfan.com",
    "pettypool.com",
    "mail2saturn.com",
    "mail2doglover.com",
    "portableoffice.com",
    "vtr.net",
    "cww.de",
    "mail2business.com",
    "inmail.sk",
    "postmaster.co.uk",
    "mail2cardiologist.com",
    "aol.it",
    "uol.com.br",
    "mail2dearest.com",
    "lycos.it",
    "atrus.ru",
    "collector.org",
    "email-fake.gq",
    "outlook.my",
    "mobile.me",
    "1ce.us",
    "bluebottle.com",
    "cable.comcast.com",
    "emailz.gq",
    "lovecat.com",
    "secretary.net",
    "upc.nl",
    "ezy.net",
    "garbagemail.com",
    "live.unc.edu",
    "xoxy.net",
    "hushmail.me",
    "ownmail.net",
    "mail2honey.com",
    "mail.zp.ua",
    "mobileme.com",
    "asia-mail.com",
    "bangkok.com",
    "crosshairs.com",
    "francemel.fr",
    "ieatspam.eu",
    "inmynetwork.tk",
    "mail2bar.com",
    "mail2cutey.com",
    "mail2london.com",
    "mail2mgz.com",
    "mail2mypalm.com",
    "mail2randy.com",
    "mail2stuntman.com",
    "mail2titanic.com",
    "nwytg.net",
    "topletter.com",
    "webcontact-france.eu",
    "wetrainbayarea.com",
    "pokepost.com",
    "trash2011.com",
    "wir-haben-nachwuchs.de",
    "fastmail.cn",
    "eintagsmail.de",
    "eml.pp.ua",
    "hotmail.co.za",
    "netterchef.de",
    "nextmail.ru",
    "savelife.ml",
    "terminverpennt.de",
    "wollan.info",
    "xing886.uu.gl",
    "megaboymail.com",
    "whyspam.me",
    "mail2anthony.com",
    "incamail.com",
    "mail2ellen.com",
    "mail2zurich.com",
    "luxsci.com",
    "mail2zoo.com",
    "abolition-now.com",
    "mail2museum.com",
    "nm.ru",
    "liontrucks.com",
    "mail2dale.com",
    "mail2valley.com",
    "givepeaceachance.com",
    "mail2lisa.com",
    "superdada.com",
    "optusnet.com.au",
    "mail2alaska.com",
    "eudoramail.com",
    "1internetdrive.com",
    "city2city.com",
    "emailcorner.net",
    "toolsource.com",
    "fastmail.net",
    "destin.com",
    "drotposta.hu",
    "axoskate.com",
    "ilovejesus.com",
    "noclickemail.com",
    "spamobox.com",
    "insight.rr.com",
    "hotmail.com.hk",
    "gala.net",
    "trash2009.com",
    "mailbox.gr",
    "3000.it",
    "97rock.com",
    "animalwoman.net",
    "die-optimisten.de",
    "dunloprider.com",
    "fromlouisiana.com",
    "graphic-designer.com",
    "ip4.pp.ua",
    "ireland.com",
    "mail2alec.com",
    "mail2money.com",
    "mail2teacher.com",
    "mantraonline.com",
    "mehrani.com",
    "monumentmail.com",
    "pacific-re.com",
    "personales.com",
    "surat.com",
    "weibsvolk.org",
    "mexicomail.com",
    "pacificwest.com",
    "moose-mail.com",
    "fromwashingtondc.com",
    "alexandria.cc",
    "mail2smile.com",
    "mail2arabia.com",
    "theheadoffice.com",
    "trmailbox.com",
    "mail2houston.com",
    "mail2walter.com",
    "singnet.com.sg",
    "cooperation.net",
    "1musicrow.com",
    "yopolis.com",
    "mail2bill.com",
    "bigmailbox.com",
    "mail2roy.com",
    "artlover.com",
    "city-of-brighton.org",
    "aemail4u.com",
    "woh.rr.com",
    "gmx.de",
    "hotmail.com.ar",
    "vfemail.net",
    "fastmail.us",
    "doneasy.com",
    "dcemail.com",
    "go.ru",
    "address.com",
    "ahk.jp",
    "asianwired.net",
    "baudoinconsulting.com",
    "business-man.com",
    "countrylover.com",
    "dm.w3internet.co.uk",
    "emailplanet.com",
    "emailplus.org",
    "freeghana.com",
    "freeyellow.com",
    "fromarkansas.com",
    "fromindiana.com",
    "mail.hitthebeach.com",
    "mail2clint.com",
    "mail2turkey.com",
    "mail2zack.com",
    "mvrht.com",
    "nightmail.com",
    "the-canuck.com",
    "tunisiamail.com",
    "usanetmail.com",
    "vip.gr",
    "webuser.in",
    "yahoo.nl",
    "spambox.irishspringrealty.com",
    "bk.ru",
    "live.be",
    "email.arizona.edu",
    "yahoo.ca",
    "gmail.co",
    "sogetthis.com",
    "peru.com",
    "ragingbull.com",
    "angelfire.com",
    "mail2man.com",
    "mail2air.com",
    "88.am",
    "bootmail.com",
    "brusseler.com",
    "catchamail.com",
    "hello.to",
    "hotmail.kg",
    "mail2ecuador.com",
    "mail2gilbert.com",
    "meine-fotos.info",
    "syom.com",
    "temtulsa.net",
    "truckracers.com",
    "uno.ee",
    "uole.com",
    "wegwerfmail.info",
    "yourinbox.com",
    "zhouemail.510520.org",
    "spray.se",
    "bvimailbox.com",
    "mail2dominicanrepublic.com",
    "desilota.com",
    "mail2beverly.com",
    "winmail.com.au",
    "spazmail.com",
    "mail2argentina.com",
    "thestreetfighter.com",
    "freeuk.com",
    "ravearena.com",
    "uae.ac",
    "from-brazil.com",
    "tiscali.lu",
    "terra.com",
    "skim.com",
    "eresmas.com",
    "mail2westend.com",
    "vip.qq.com",
    "charter.net",
    "poczta.onet.pl",
    "shinternet.ch",
    "mail333.com",
    "starmedia.com",
    "freegates.be",
    "boltonfans.com",
    "mail.austria.com",
    "cocoonemail.com",
    "abbeyroadlondon.co.uk",
    "avh.hu",
    "bcvibes.com",
    "britneyclub.com",
    "imaginemail.com",
    "mail2basketball.com",
    "mail2bosnia.com",
    "mail2grenada.com",
    "mail2mygsm.com",
    "mail2onfire.com",
    "mail2riley.com",
    "meloo.com",
    "metta.lk",
    "salehi.net",
    "sayhi.net",
    "starmail.org",
    "truckerz.com",
    "zipmax.com",
    "mailinator.com",
    "mailexpire.com",
    "tigermail.auburn.edu",
    "bikemechanics.com",
    "eriga.lv",
    "eramail.co.za",
    "mail2freedom.com",
    "mail2lucy.com",
    "agoodmail.com",
    "mail2margaret.com",
    "epatra.com",
    "mail2hotel.com",
    "mail2hebe.com",
    "etoast.com",
    "mail2mymac.com",
    "mail2newhampshire.com",
    "planet.nl",
    "doctors.org.uk",
    "hulapla.de",
    "mailslite.com",
    "mail-tester.com",
    "mailueberfall.de",
    "sofortmail.de",
    "spamoff.de",
    "stuffmail.de",
    "home.se",
    "devotedcouples.com",
    "the-canadian.com",
    "mail2tom.com",
    "gateway.net",
    "shotgun.hu",
    "mail2priest.com",
    "hkstarphoto.com",
    "from-africa.com",
    "fromrhodeisland.com",
    "mail2madison.com",
    "mail2holly.com",
    "mail2nick.com",
    "kichimail.com",
    "live.com.mx",
    "mail2moldova.commail2molly.com",
    "mail2gerald.com",
    "hotmail.co.nz",
    "fastmail.com.au",
    "neeva.net",
    "s0ny.net",
    "pipeline.com",
    "citeweb.net",
    "yourname.ddns.org",
    "150mail.com",
    "dirtracer.com",
    "farang.net",
    "fullmail.com",
    "techpointer.com",
    "ato.check.com",
    "didamail.com",
    "fan.theboys.com",
    "uu.net",
    "letterboxes.org",
    "posteo.net",
    "cox.com",
    "israelmail.com",
    "mailfree.gq",
    "quickhosts.com",
    "teleworm.us",
    "temporaryemail.us",
    "migmail.pl",
    "net-c.nl",
    "pokemonpost.com",
    "shitaway.usa.cc",
    "sudoworld.net",
    "whtjddn.33mail.com",
    "33mail.com",
    "amail.com",
    "contrasto.cu.cc",
    "mail.svenz.eu",
    "tempymail.com",
    "ultra.fyi",
    "dogit.com",
    "dotmsg.com",
    "net-c.fr",
    "netcmail.com",
    "btconnect.co.uk",
    "mailpokemon.com",
    "rklips.com",
    "sudoverse.net",
    "torontomail.com",
    "321media.com",
    "asiafind.com",
    "bin-wieder-da.de",
    "brazilmail.com",
    "collectiblesuperstore.com",
    "grapplers.com",
    "internet-e-mail.com",
    "je-recycle.info",
    "naui.net",
    "outlook.cl",
    "rhyta.com",
    "scotlandmail.com",
    "slipry.net",
    "sukhumvit.net",
    "used-product.fr",
    "aapt.net.au",
    "inbox.com",
    "ath.forthnet.gr",
    "2die4.com",
    "hot-shot.com",
    "emailtemporario.com.br",
    "pulp-fiction.com",
    "crazedanddazed.com",
    "die-besten-bilder.de",
    "faroweb.com",
    "fromwashington.com",
    "itloox.com",
    "mail2allan.com",
    "mail2ann.com",
    "mail2band.com",
    "mail2bangladesh.com",
    "mail2fiji.com",
    "mail2grant.com",
    "mail2hank.com",
    "mail2hip.com",
    "mail2mitch.com",
    "mail2mylaptop.com",
    "sbcglbal.net",
    "schizo.com",
    "spambob.org",
    "speedemail.net",
    "sperke.net",
    "the-eagles.com",
    "the-prayer.com",
    "u14269.ml",
    "aver.com",
    "cyber-wizard.com",
    "fastyamaha.com",
    "abyssmail.com",
    "c51vsgq.com",
    "chacuo.net",
    "dropmail.me",
    "shitaway.ml",
    "superrito.com",
    "unterderbruecke.de",
    "azmeil.tk",
    "europamel.net",
    "fastmazda.com",
    "fireman.net",
    "golfilla.info",
    "mailguard.me",
    "mailinator.org",
    "metaping.com",
    "net-c.lu",
    "polizisten-duzer.de",
    "salesperson.net",
    "tempmailer.com",
    "trash-mail.ga",
    "betriebsdirektor.de",
    "indeedemail.com",
    "locos.com",
    "playstation.sony.com",
    "uroid.com",
    "msn.nl",
    "planetmail.net",
    "quickmail.nl",
    "reincarnate.com",
    "dnainternet.net",
    "brew-master.com",
    "planetmail.com",
    "example.com",
    "myrealbox.com",
    "peoplepc.com",
    "postpro.net",
    "excite.it",
    "mail2joe.com",
    "webmails.com",
    "fastmailbox.net",
    "onmilwaukee.com",
    "blader.com",
    "domforfb4.tk",
    "fromnewmexico.com",
    "fromvirginia.com",
    "jpopmail.com",
    "mail2alan.com",
    "mail2from.com",
    "mail2julie.com",
    "mail2moscow.com",
    "mail2ned.com",
    "mail2subscribe.com",
    "mailinator.us",
    "mydotcomaddress.com",
    "netexecutive.com",
    "silkroad.net",
    "the-aliens.com",
    "username.e4ward.com",
    "visitmail.com",
    "x-networks.net",
    "yifan.net",
    "annsmail.com",
    "fax.ru",
    "spamstack.net",
    "yahoo.at",
    "bboy.zzn.com",
    "madcreations.com",
    "mail.pharmacy.com",
    "populus.net",
    "youpy.com",
    "mail.qip.ru",
    "trademailer.de",
    "rai.com.ua",
    "example.\u03B4\u03BF\u03BA\u03B9\u03BC\u03AE",
    "posteo.hn",
    "megabox.ru",
    "4hismail.com",
    "yehaa.com",
    "posteo.gl",
    "edge.net",
    "ygm.com",
    "bestweb.net",
    "nomorespamemails.com",
    "dmv.com",
    "orange.net",
    "posteo.hu",
    "mail.salu.net",
    "mciworldcom.net",
    "posteo.mx",
    "aport.ru",
    "bigpond.net",
    "cash4u.com",
    "wazabi.club",
    "fasttoyota.com",
    "grr.la",
    "spybox.de",
    "fleckens.hu",
    "inerted.com",
    "letthemeatspam.com",
    "telfortglasvezel.nl",
    "meine-dateien.info",
    "turboprinz.de",
    "wir-sind-cool.org",
    "comhem.se",
    "roadrunner.com",
    "runbox.com",
    "tx.rr.com",
    "spambog.ru",
    "mailnull.com",
    "oninet.pt",
    "home.ro",
    "homestead.com",
    "mailmij.nl",
    "zip.net",
    "bachelorgal.com",
    "clear.net.nz",
    "dogsnob.net",
    "fux0ringduh.com",
    "galaxy5.com",
    "imap.cc",
    "inbox.net",
    "kukamail.com",
    "mail2arthur.com",
    "mail2auction.com",
    "mail2diane.com",
    "mail2kathy.com",
    "mail2mors.com",
    "mail2peace.com",
    "matmail.com",
    "mor19.uu.gl",
    "mybox.it",
    "nospamthanks.info",
    "saeuferleber.de",
    "surgical.net",
    "theglobe.com",
    "weibsvolk.de",
    "starting-point.com",
    "fcc.net",
    "starpower.net",
    "a45.in",
    "emails.incisivemedia.com",
    "etranquil.net",
    "force9.co.uk",
    "indomail.com",
    "macfreak.com",
    "mobileninja.co.uk",
    "outlook.com.vn",
    "ozbytes.net.au",
    "urhen.com",
    "certifiedmail.com",
    "emails.ga",
    "mailed.ro",
    "outlook.cz",
    "turboprinzessin.de",
    "zomg.info",
    "e-mail.ua",
    "boxformail.in",
    "info-radio.ml",
    "neuro.md",
    "pokemail.net",
    "rocketship.com",
    "telstra.com.au",
    "list.ru",
    "live.com.au",
    "u.northwestern.edu",
    "exemail.com.au",
    "cfl.rr.com",
    "studenti.unimi.it",
    "quickinbox.com",
    "tamil.com",
    "mail2strong.com",
    "africamel.net",
    "c4.com",
    "chong-mail.net",
    "jerusalemmail.com",
    "mail2alicia.com",
    "mail2champaign.com",
    "mail2linda.com",
    "mail2poseidon.com",
    "mail2steven.com",
    "mail2tracey.com",
    "netc.fr",
    "nettaxi.com",
    "freemails.ga",
    "vahoo.com",
    "ephemail.net",
    "fake-mail.ml",
    "germanymail.com",
    "junkmail.gq",
    "westnet.com",
    "moscowmail.com",
    "n2baseball.com",
    "net-c.it",
    "webinbox.com",
    "virtualactive.com",
    "trashmailer.com",
    "posteo.com.br",
    "litedrop.com",
    "netmanor.com",
    "posteo.gr",
    "posteo.cz",
    "gh2000.com",
    "crosslink.net",
    "dejanews.com",
    "wow.com",
    "voo.be",
    "posteo.ru",
    "mailme.ir",
    "internetmci.com",
    "armymail.com",
    "outel.com",
    "ccnmail.com",
    "blazenet.net",
    "subnetwork.com",
    "planetdirect.com",
    "xpressmail.zzn.com",
    "bossofthemoss.com",
    "mariah-carey.ml.org",
    "discoverymail.com",
    "cybergal.com",
    "medione.net",
    "ag.us.to",
    "die-optimisten.net",
    "netc.lu",
    "outlook.in",
    "bigstring.com",
    "dispomail.eu",
    "jetable.de",
    "merda.igg.biz",
    "twcny.com",
    "xoxox.cc",
    "loobie.com",
    "posteo.me",
    "domforfb8.tk",
    "emailer.hubspot.com",
    "fake-email.pp.ua",
    "netc.it",
    "netnoir.net",
    "outlook.hu",
    "social-mailer.tk",
    "mailgate.gr",
    "cyberspace-asia.com",
    "unomail.com",
    "adoption.com",
    "maildrop.cc",
    "realtyagent.com",
    "safrica.com",
    "christianmail.net",
    "netcom.ca",
    "1mail.ml",
    "californiamail.com",
    "easytrashmail.com",
    "hackermail.com",
    "posteo.la",
    "sina.com",
    "eircom.net",
    "hotmail.my",
    "joymail.com",
    "mail2dave.com",
    "hello.hu",
    "mail2allen.com",
    "mail2beijing.com",
    "mail2hot.com",
    "mail2james.com",
    "mail2junk.com",
    "mail2maria.com",
    "mail2montana.com",
    "mail2morpheus.com",
    "mail2norway.com",
    "mail2sal.com",
    "mail2swiss.com",
    "nicegal.com",
    "the-student.net",
    "uplipht.com",
    "walkmail.net",
    "wickmail.net",
    "wovz.cu.cc",
    "yahoo.ae",
    "planetall.com",
    "888.nu",
    "sativa.ro.org",
    "0clickemail.com",
    "cyber-matrix.com",
    "emailit.com",
    "freudenkinder.de",
    "oida.icu",
    "temp-mail.de",
    "vampirehunter.com",
    "amazonses.com",
    "rootprompt.org",
    "webstable.net",
    "posteo.my",
    "mycampus.com",
    "chinalook.com",
    "kmail.com.au",
    "sharewaredevelopers.com",
    "adultmail.tv",
    "ziplink.net",
    "imail.org",
    "bev.net",
    "yawmail.com",
    "bannertown.net",
    "clrmail.com",
    "comporium.net",
    "coole-files.de",
    "openmailbox.org",
    "outlook.sg",
    "protestant.com",
    "put2.net",
    "sudoworld.com",
    "trimix.cn",
    "webname.com",
    "zetmail.com",
    "bareed.ws",
    "download-privat.de",
    "humn.ws.gy",
    "newsboysmail.com",
    "yahoo.co",
    "bt.com",
    "gti.net",
    "wanadoo.co.uk",
    "football.theboys.com",
    "posteo.cl",
    "amnestymail.com",
    "fullchannel.net",
    "homeart.com",
    "webmail.bellsouth.net",
    "nogmailspam.info",
    "reggafan.com",
    "posteo.ch",
    "email60.com",
    "mrpost.com",
    "posta.net",
    "arcademaster.com",
    "attbi.com",
    "megapathdsl.net",
    "posteo.org",
    "fixmail.tk",
    "instantemailaddress.com",
    "lvie.com.sg",
    "muehlacker.tk",
    "myspaceinc.net",
    "hurting.com",
    "n2soccer.com",
    "programist.ru",
    "toke.com",
    "7mail.ml",
    "wfgdfhj.tk",
    "ecolo-online.fr",
    "lass-es-geschehen.de",
    "liebt-dich.info",
    "madonnafan.com",
    "seckinmail.com",
    "vnet.citiz.net",
    "worker.com",
    "yahoo.hu",
    "chechnya.conf.work",
    "foothills.net",
    "knol-power.nl",
    "monemail.com",
    "mt2015.com",
    "nullbox.info",
    "outlook.co.nz",
    "outlook.sa",
    "therapist.net",
    "club-internet.fr",
    "talktalk.net",
    "21cn.com",
    "movistar.es",
    "tempemail.com",
    "myfamily.com",
    "mail2dan.com",
    "aa.net",
    "belizehome.com",
    "btcmail.pw",
    "disinfo.net",
    "feinripptraeger.de",
    "getairmail.cf",
    "harakirimail.com",
    "hunsa.com",
    "ilovetocollect.net",
    "internetegypt.com",
    "iservejesus.com",
    "kcks.com",
    "mail2fashion.com",
    "mail2luxembourg.com",
    "mail2milano.com",
    "mail2rod.com",
    "planetearthinter.net",
    "the-cowboy.com",
    "townisp.com",
    "whartontx.com",
    "activist.com",
    "adrenalinefreak.com",
    "girl4god.com",
    "kaffeeschluerfer.de",
    "mamber.net",
    "sraka.xyz",
    "copper.net",
    "inboxalias.com",
    "mail4u.info",
    "merda.nut.cc",
    "myspamless.com",
    "plus.google.com",
    "tortenboxer.de",
    "klassmaster.net",
    "lenta.ru",
    "login-email.ga",
    "phpbb.uu.gl",
    "vip.21cn.com",
    "wee.my",
    "mail-easy.fr",
    "asdasd.nl",
    "elisanet.fi",
    "instantmail.fr",
    "lovefall.ml",
    "mail.misterpinball.de",
    "vubby.com",
    "zaktouni.fr",
    "2980.com",
    "computer4u.com",
    "englandmail.com",
    "ficken.de",
    "i2pmail.org",
    "kolumbus.fi",
    "solvemail.info",
    "songwriter.net",
    "zxcv.com",
    "geography.net",
    "mailbox72.biz",
    "mypacks.net",
    "net-c.cat",
    "prydirect.info",
    "smashmail.de",
    "spamdecoy.net",
    "web-emailbox.eu",
    "googlegroups.com",
    "herp.in",
    "mt2016.com",
    "spamgoes.in",
    "blockfilter.com",
    "hacccc.com",
    "maildx.com",
    "sendspamhere.com",
    "advantimo.com",
    "domforfb3.tk",
    "inbound.plus",
    "loveyouforever.de",
    "schmusemail.de",
    "1pad.de",
    "6ip.us",
    "crapmail.org",
    "dodsi.com",
    "ftc-i.net",
    "maildrop.gq",
    "null.net",
    "smellrear.com",
    "centermail.info",
    "facebook-email.ga",
    "ano-mail.net",
    "lovesea.gq",
    "anonmails.de",
    "brennendesreich.de",
    "disciples.com",
    "emailthe.net",
    "luv2.us",
    "phus8kajuspa.cu.cc",
    "smap.4nmv.ru",
    "spambooger.com",
    "net-c.be",
    "omen.ru",
    "sonnenkinder.org",
    "teachers.org",
    "trash-mail.ml",
    "walala.org",
    "mailtemp.info",
    "my10minutemail.com",
    "totalmail.de",
    "discard.ga",
    "freemail.ms",
    "sudolife.net",
    "bund.us",
    "emailto.de",
    "netzidiot.de",
    "pemail.net",
    "housefan.com",
    "charm.net",
    "willselfdestruct.com",
    "bosnianmail.com",
    "finfin.com",
    "tempmail.it",
    "posteo.nz",
    "govolsfan.com",
    "kozmail.com",
    "hempseed.com",
    "planet-mail.com",
    "emumail.com",
    "bcpl.net",
    "itol.com",
    "ilovethemovies.com",
    "acmecity.com",
    "dca.net",
    "mail2go.com",
    "imails.info",
    "posteo.nl",
    "bla-bla.com",
    "posteo.co",
    "patmedia.net",
    "ibm.net",
    "toughguy.net",
    "giantsfan.com",
    "wickedmail.com",
    "sprynet.com",
    "safarimail.com",
    "spaceart.com",
    "onvillage.com",
    "posteo.ro",
    "privaterelay.appleid.com"
]);
var $8acea9a2b2a9060b$export$2e2bcd8739ae039 = $8acea9a2b2a9060b$var$personalEmailsDomains;

});

parcelRegister("9xhTf", function(module, exports) {
$parcel$export(module.exports, "isEmailFormat", function () { return $54ff13c389f0ffff$export$ca3873bda3d4c03b; });
$parcel$export(module.exports, "isPersonalDomain", function () { return $54ff13c389f0ffff$export$fb4ff965f818da6; });
$parcel$export(module.exports, "submitContactForm", function () { return $54ff13c389f0ffff$export$dc48f71ddf9c5e1c; });
$parcel$export(module.exports, "getProductPlans", function () { return $54ff13c389f0ffff$export$8b8bd1c6772f09e0; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $PE2DD = parcelRequire("PE2DD");

var $ai7AF = parcelRequire("ai7AF");

var $2gCne = parcelRequire("2gCne");

var $Ie188 = parcelRequire("Ie188");
const $54ff13c389f0ffff$var$STARGATE_BASE_URL = "https://www.atlassian.com/gateway/api";
const $54ff13c389f0ffff$var$stargateClient = new (0, $PE2DD.BxpWebStargateClient)({
    baseUrl: $54ff13c389f0ffff$var$STARGATE_BASE_URL
});
const $54ff13c389f0ffff$var$streamhubClient = new (0, $Ie188.StreamhubClient)();
const $54ff13c389f0ffff$export$ca3873bda3d4c03b = (value)=>{
    if (value) {
        const emailRegex = new RegExp(/^[\w-]+(\.[\w-]+)*@([a-z0-9-]+\.)+[a-z]{2,7}$/);
        return emailRegex.test(value);
    }
    return false;
};
const $54ff13c389f0ffff$export$fb4ff965f818da6 = (value)=>{
    if (value) {
        if (!$54ff13c389f0ffff$export$ca3873bda3d4c03b(value)) return false;
        const emailDomain = value.split("@")[1];
        return (0, $ai7AF.default).has(String(emailDomain));
    }
    return false;
};
const $54ff13c389f0ffff$var$submitSuccess = (state, createAnalyticsEvent)=>{
    if (state.status == 200) window.location.href = state.redirect + window.location.search;
    else {
        state.mainFormContainer.style.display = "none";
        state.postSubmitMessage.style.display = "block";
    }
    createAnalyticsEvent({
        event: "Contact Sales Form",
        action: "Submitted",
        actionSubject: "Contact Sales Form",
        eventType: "ui",
        origin: "web",
        platform: "web",
        product: "marketing",
        source: "none",
        userIdType: "atlassianAccount",
        attributes: {
            atlJSVersion: "1.0.0",
            event: "Submitted",
            eventComponent: "Contact Sales Form",
            page_path: location.pathname,
            url: location.href
        }
    }).fire();
};
const $54ff13c389f0ffff$var$submitFailure = (createAnalyticsEvent)=>{
    createAnalyticsEvent({
        event: "Contact Sales Form",
        action: "Failed",
        actionSubject: "Contact Sales Form",
        eventType: "ui",
        origin: "web",
        platform: "web",
        product: "marketing",
        source: "none",
        userIdType: "atlassianAccount",
        attributes: {
            event: "Failed",
            eventComponent: "Contact Sales Form",
            page_path: location.pathname,
            url: location.href,
            atlJSVersion: "1.0.0"
        }
    }).fire();
};
const $54ff13c389f0ffff$var$getCookie = (name)=>{
    var _parts_pop;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return (_parts_pop = parts.pop()) === null || _parts_pop === void 0 ? void 0 : _parts_pop.split(";").shift();
    return "";
};
// @ts-ignore
const $54ff13c389f0ffff$var$sendToStreamhub = async (formValues, formType, createAnalyticsEvent)=>{
    var _getCookie, _getCookie1;
    const currentTime = new Date();
    const random = Math.round(Math.random() * 10000);
    const { locale: locale } = await $54ff13c389f0ffff$var$stargateClient.getConsentConfig();
    const formTypeMap = {
        "pricing-quotes": "Pricing & Quotes",
        "migration-options": "Migration Options",
        "product-features": "Product Features"
    };
    const streamHubInfo = {
        gmoiLocale: String(locale),
        formType: formTypeMap[formType],
        formDef: "contactSales",
        formSubmissionId: random + currentTime.getTime(),
        created_at: currentTime,
        marketoCookieId: $54ff13c389f0ffff$var$getCookie("_mkto_trk") || "",
        anonymousId: ((_getCookie = $54ff13c389f0ffff$var$getCookie("ajs_anonymous_id")) === null || _getCookie === void 0 ? void 0 : _getCookie.replace(/%22/g, "")) || "",
        atlassianId: ((_getCookie1 = $54ff13c389f0ffff$var$getCookie("ajs_user_id")) === null || _getCookie1 === void 0 ? void 0 : _getCookie1.replace(/%22/g, "")) || "",
        submitted: currentTime.toString(),
        source_sequence: currentTime.getTime(),
        userAgent: window.navigator.userAgent,
        isIntercomTracking: false,
        intercomAppId: "",
        intercomMapping: {}
    };
    const payload = Object.assign(formValues, streamHubInfo);
    const streamhubEndpoint = "contactsalesv2";
    await $54ff13c389f0ffff$var$streamhubClient.postObject(payload, streamhubEndpoint, (state)=>$54ff13c389f0ffff$var$submitSuccess(state, createAnalyticsEvent));
};
const $54ff13c389f0ffff$export$dc48f71ddf9c5e1c = async (form, formType, createAnalyticsEvent)=>{
    let editionValue = "";
    if (form["edition"]) {
        const value = form["edition"].split(" ")[1];
        if (value) editionValue = value;
    }
    if (form["name"]) {
        form["firstName"] = form["name"].split(" ")[0];
        form["lastName"] = form["name"].split(" ").slice(1).join(" ");
    }
    if (!form["company"]) {
        const parsedEmail = form["email"].split("@")[1];
        form["company"] = parsedEmail.split(".")[0];
    }
    const marketingContext = (0, $2gCne.getLocalStorage)("marketingContext", true);
    let parsedMarketingContext;
    try {
        parsedMarketingContext = marketingContext ? JSON.parse(marketingContext) : null;
    } catch (error) {
        console.error("Failed to parse marketingContext from localStorage");
    }
    const { sfdcCampaignId: sfdcCampaignId = "", source: source = "", medium: medium = "", campaign: campaign = "", content: content = "" } = (parsedMarketingContext === null || parsedMarketingContext === void 0 ? void 0 : parsedMarketingContext.utm) || {};
    form["utm_sfdc-campaign_id"] = sfdcCampaignId;
    form["utm_source"] = source;
    form["utm_medium"] = medium;
    form["utm_campaign"] = campaign;
    form["utm_content"] = content;
    const formValues = (0, $dPABA._)((0, $6ogO3._)({}, form), {
        edition: editionValue ? editionValue : undefined
    });
    try {
        await $54ff13c389f0ffff$var$sendToStreamhub(formValues, formType, createAnalyticsEvent);
    } catch (error) {
        console.error("Failed to submit form", error);
        $54ff13c389f0ffff$var$submitFailure(createAnalyticsEvent);
        throw error;
    }
};
const $54ff13c389f0ffff$export$8b8bd1c6772f09e0 = (selectedProduct)=>{
    if (selectedProduct === "Atlassian Guard" || selectedProduct === "Bitbucket" || selectedProduct === "Compass" || selectedProduct === "Jira Product Discovery") return [
        {
            name: "plan",
            label: "Cloud Standard",
            value: "Cloud Standard"
        },
        {
            name: "plan",
            label: "Cloud Premium",
            value: "Cloud Premium"
        }
    ];
    else if (selectedProduct === "Loom") return [
        {
            name: "plan",
            label: "Loom Business",
            value: "Loom Business"
        },
        {
            name: "plan",
            label: "Loom Business + AI",
            value: "Loom Business + AI"
        },
        {
            name: "plan",
            label: "Loom Enterprise",
            value: "Loom Enterprise"
        }
    ];
    else if (selectedProduct === "Jira Cloud Backup and Restore" || selectedProduct === "Jira Service Management Cloud Backup and Restore" || selectedProduct === "Confluence Cloud Backup and Restore") // Backup and Restore products have Cloud Premium and Cloud Enterprise
    return [
        {
            name: "plan",
            label: "Cloud Premium",
            value: "Cloud Premium"
        },
        {
            name: "plan",
            label: "Cloud Enterprise",
            value: "Cloud Enterprise"
        }
    ];
    else if (selectedProduct === "Jira Additional Sandbox" || selectedProduct === "Confluence Additional Sandbox" || selectedProduct === "Jira Service Management Additional Sandbox" || selectedProduct === "Jira Product Discovery Additional Sandbox") // Additional Sandbox products have Cloud Premium and Cloud Enterprise
    return [
        {
            name: "plan",
            label: "Cloud Premium",
            value: "Cloud Premium"
        },
        {
            name: "plan",
            label: "Cloud Enterprise",
            value: "Cloud Enterprise"
        }
    ];
    else // Default plans for other products
    return [
        {
            name: "plan",
            label: "Cloud Standard",
            value: "Cloud Standard"
        },
        {
            name: "plan",
            label: "Cloud Premium",
            value: "Cloud Premium"
        },
        {
            name: "plan",
            label: "Cloud Enterprise",
            value: "Cloud Enterprise"
        }
    ];
};

});
parcelRegister("Ie188", function(module, exports) {
$parcel$export(module.exports, "StreamhubClient", function () { return $c0688d0cc57a7567$export$df36629759e22bfa; });

var $hhKQf = parcelRequire("hhKQf");
class $c0688d0cc57a7567$export$df36629759e22bfa {
    getEndpoint() {
        return this.endpoint;
    }
    async postObject(object, path, responseHandler, errorHandler) {
        try {
            const response = await (0, $hhKQf.default).post(`${this.endpoint}/streamhub/${path}`, object);
            responseHandler(response);
        } catch (error) {
            console.error("Failed to post object to endpoint", error);
            if (errorHandler) errorHandler(error);
            throw error;
        }
    }
    constructor(){
        this.endpoint = "https://www.atlassian.com/endpoint";
    }
}

});


parcelRegister("8Fvhz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de9efdf87e9265fa$export$2e2bcd8739ae039; });
/* mo-resource-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $7iXNu = parcelRequire("7iXNu");
const $de9efdf87e9265fa$var$resourceCardStyling = null;
const $de9efdf87e9265fa$var$MigrationOptionsResourceCards = ()=>{
    const intl = (0, $8e22h.default)();
    const startAssessmentText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.StartAssessment",
        defaultMessage: "Find a partner"
    });
    const learnAboutMigrationText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.LearnAboutMigration",
        defaultMessage: "Learn about migration"
    });
    const browseTheGuideText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.BrowseTheGuide",
        defaultMessage: "Browse the guide"
    });
    const migrationOptionsResourceCards = [
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.MigrationAssessment",
                defaultMessage: "Migration partners"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.MigrationAssessment.dsc",
                defaultMessage: "Certified partners offer end-to-end 1:1 support for complex migrations."
            }),
            buttonText: startAssessmentText,
            url: (0, $kooLp.useLocalizedHref)("/migration/help/find-migration-partner")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.AtlassianMigration",
                defaultMessage: "Atlassian Migration Program"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.AtlassianMigration.dsc",
                defaultMessage: "Find tools, resources, and support to guide you through a migration."
            }),
            buttonText: learnAboutMigrationText,
            url: (0, $kooLp.useLocalizedHref)("/migration")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.CloudMigration",
                defaultMessage: "Cloud migration guide"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.CloudMigration.dsc",
                defaultMessage: "Explore each phase of your migration journey with our guide."
            }),
            buttonText: browseTheGuideText,
            url: (0, $kooLp.useLocalizedHref)("/migration/plan/cloud-guide")
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: migrationOptionsResourceCards.map((cardProps)=>/*#__PURE__*/ (0, $1oC0p.createElement)((0, $7iXNu.default), (0, $dPABA._)((0, $6ogO3._)({}, cardProps), {
                key: cardProps.header
            })))
    });
};
var $de9efdf87e9265fa$export$2e2bcd8739ae039 = $de9efdf87e9265fa$var$MigrationOptionsResourceCards;

});


parcelRegister("9Dk5S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2d171a99d4a2171f$export$2e2bcd8739ae039; });
/* pricing-quotes.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $3L8ZR = parcelRequire("3L8ZR");

var $lX14w = parcelRequire("lX14w");
var $ff3wF = parcelRequire("ff3wF");
var $igGC3 = parcelRequire("igGC3");
var $gacwQ = parcelRequire("gacwQ");
var $kR3EL = parcelRequire("kR3EL");

var $9BG80 = parcelRequire("9BG80");

var $2vYc0 = parcelRequire("2vYc0");

var $8KJ2x = parcelRequire("8KJ2x");

var $fJP6M = parcelRequire("fJP6M");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $1rGpC = parcelRequire("1rGpC");

var $32ng3 = parcelRequire("32ng3");

var $hhv63 = parcelRequire("hhv63");

var $2ve7k = parcelRequire("2ve7k");

var $lBgvn = parcelRequire("lBgvn");

var $3bkHm = parcelRequire("3bkHm");

var $izhAl = parcelRequire("izhAl");

var $e0MOs = parcelRequire("e0MOs");

var $9xhTf = parcelRequire("9xhTf");

var $eodOk = parcelRequire("eodOk");
const $2d171a99d4a2171f$var$containerStyle = null;
const $2d171a99d4a2171f$var$innerContainerStyle = null;
const $2d171a99d4a2171f$var$formStyle = null;
const $2d171a99d4a2171f$var$textContainer = null;
const $2d171a99d4a2171f$var$PricingQuotes = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [fieldHasError, setFieldHasError] = (0, $1oC0p.useState)({});
    const [errorMessageText, setErrorMessageText] = (0, $1oC0p.useState)("");
    const [selectedProduct, setSelectedProduct] = (0, $1oC0p.useState)("");
    const [changeContactInfo, setChangeContactInfo] = (0, $1oC0p.useState)(false);
    const [isInvalid, setIsInvalid] = (0, $1oC0p.useState)(true);
    const intl = (0, $8e22h.default)();
    const userInfo = (0, $2ve7k.useLoggedInUser)();
    const redirectPath = (0, $kooLp.useLocalizedHref)(`/enterprise/contact-thanks?formType=pricing-quotes`);
    const NEXT_PUBLIC_IDENTITY_BASE_URL = "https://id.atlassian.com";
    const getSwitchAccountURL = (continueUrlParam)=>{
        const continueUrl = continueUrlParam ? continueUrlParam : window.location.href;
        return `${NEXT_PUBLIC_IDENTITY_BASE_URL}/login/select-account?continue=${encodeURIComponent(continueUrl)}`;
    };
    const getOrAsk = intl.formatMessage({
        id: "pricingQuotes.getOrAsk",
        defaultMessage: "Get a quote or ask pricing questions about a product or service you might purchase."
    });
    const yourCompanyEmail = intl.formatMessage({
        id: "pricingQuotes.yourCompanyEmail",
        defaultMessage: "Your company email"
    }) + " *";
    const personalEmailDomainsError = intl.formatMessage({
        id: "pricingQuotes.personalEmailDomainsError",
        defaultMessage: "Personal email domains will result in an error."
    });
    const conditionalFields = (product, getState, setFieldValue)=>{
        const options = (0, $9xhTf.getProductPlans)(selectedProduct);
        const numberOfPeopleSupported = intl.formatMessage({
            id: "pricingQuotes.numberOfPeople",
            defaultMessage: "Number of people your agents will support"
        }) + " *";
        const numberOfDevelopersOnTeam = intl.formatMessage({
            id: "pricingQuotes.numberOfDevelopers",
            defaultMessage: "Number of developers on your team"
        }) + " *";
        const numberOfPeopleOnTeam = intl.formatMessage({
            id: "pricingQuotes.numberOfPeopleOnTeam",
            defaultMessage: "Number of people on your team"
        }) + " *";
        const numberOfAssets = intl.formatMessage({
            id: "productFeatures.numberOfAssets",
            defaultMessage: "Number of Assets you want to store"
        }) + " *";
        const numberOfAgentConversations = intl.formatMessage({
            id: "productFeatures.numberOfAgentConversations",
            defaultMessage: "Estimated number of virtual service agent conversations per month"
        }) + " *";
        const enterpriseRolloutGuard = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-guard");
        const enterpriseRolloutCompass = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-compass");
        const enterpriseRolloutLoom = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-loom");
        const enterpriseRolloutJPD = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-jpd");
        const enterpriseRolloutTWC = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-twc");
        const serviceCollectionEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8165EnterpriseContactServiceCollection);
        const backupRestoreEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9763BackupRestoreContactForm);
        const additionalSandboxEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9608AdditionalSandboxContactForm);
        const productsWithPlans = [
            "Jira Software",
            "Jira",
            "Confluence",
            "Jira Service Management",
            "Bitbucket"
        ];
        if (enterpriseRolloutGuard) productsWithPlans.push("Atlassian Guard");
        if (enterpriseRolloutCompass) productsWithPlans.push("Compass");
        if (enterpriseRolloutLoom) productsWithPlans.push("Loom");
        if (enterpriseRolloutJPD) productsWithPlans.push("Jira Product Discovery");
        if (enterpriseRolloutTWC) productsWithPlans.push("Teamwork Collection");
        if (serviceCollectionEnabled) productsWithPlans.push("Service Collection");
        if (backupRestoreEnabled) {
            productsWithPlans.push("Jira Cloud Backup and Restore");
            productsWithPlans.push("Jira Service Management Cloud Backup and Restore");
            productsWithPlans.push("Confluence Cloud Backup and Restore");
        }
        if (additionalSandboxEnabled) {
            productsWithPlans.push("Jira Additional Sandbox");
            productsWithPlans.push("Confluence Additional Sandbox");
            productsWithPlans.push("Jira Service Management Additional Sandbox");
            productsWithPlans.push("Jira Product Discovery Additional Sandbox");
        }
        return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
            children: [
                productsWithPlans.includes(product) && getState().values["platform"] === "Cloud" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                    name: "plan",
                    label: intl.formatMessage({
                        id: "pricingQuotes.plan",
                        defaultMessage: "Which plan are you interested in?"
                    }) + " *",
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2vYc0.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                    options: options,
                                    onChange: (edition)=>{
                                        const value = edition.currentTarget.value;
                                        setFieldValue("edition", value);
                                        setFieldValue("plan", value);
                                        fieldProps.onChange;
                                    }
                                })),
                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                    children: planErrorMessage
                                })
                            ]
                        })
                }),
                [
                    "Jira Software",
                    "Jira",
                    "Confluence",
                    "Jira Service Management",
                    "Bitbucket",
                    "Jira Work Management",
                    "Atlassian Access",
                    "Atlassian Guard",
                    "Opsgenie",
                    "Trello",
                    "Jira Align",
                    "Jira Product Discovery",
                    "Compass",
                    "Atlas",
                    "Loom",
                    "Jira Service Management Assets",
                    "Jira Service Management Virtual Service Agent",
                    "Teamwork Collection",
                    "Strategy Collection",
                    "Service Collection"
                ].includes(product) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                    name: "numberOfUsers",
                    label: product === "Jira Service Management" ? numberOfPeopleSupported : product === "Jira Align" || product === "Jira Product Discovery" || product === "Compass" || product === "Atlas" ? numberOfDevelopersOnTeam : product === "Jira Service Management Assets" ? numberOfAssets : product === "Jira Service Management Virtual Service Agent" ? numberOfAgentConversations : numberOfPeopleOnTeam,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3bkHm.NumberOfUsersInput), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                    onChangeHandler: (numberOfUsers)=>{
                                        setFieldValue("numberOfUsers", Number(numberOfUsers));
                                        fieldProps.onChange;
                                    }
                                })),
                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                    children: product === "Jira Service Management" ? numberOfPeopleJSMErrorMessage : product === "Jira Service Management Assets" || product === "Jira Service Management Virtual Service Agent" ? genericRequiredFieldErrorMessage : numberOfPeopleOnTeamErrorMessage
                                })
                            ]
                        })
                })
            ]
        });
    };
    const handleBlurEvent = (event)=>{
        const { name: name, value: value } = event.target;
        if (name === "email") {
            if (!value) {
                setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                    [name]: true
                }));
                setErrorMessageText("NOT_EMAIL");
                setIsInvalid(true);
            } else if ((0, $9xhTf.isEmailFormat)(value) && !(0, $9xhTf.isPersonalDomain)(value)) {
                setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                    [name]: false
                }));
                setErrorMessageText("IS_VALID");
                setIsInvalid(false);
            } else {
                setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                    [name]: true
                }));
                setIsInvalid(true);
                if (!(0, $9xhTf.isEmailFormat)(value)) setErrorMessageText("NOT_EMAIL");
                else if ((0, $9xhTf.isPersonalDomain)(value)) setErrorMessageText("PERSONAL_DOMAIN");
            }
        } else {
            setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                [name]: !value
            }));
            setIsInvalid(!value);
        }
    };
    /*
      Error Messages
  */ const personalDomainErrorMessage = intl.formatMessage({
        id: "pricingQuotes.personalDomainErrorMessage",
        defaultMessage: "Enter an email with a company domain."
    });
    const notEmailErrorMessage = intl.formatMessage({
        id: "pricingQuotes.notEmailErrorMessage",
        defaultMessage: "Enter a valid email address."
    });
    const jobTitleErrorMessage = intl.formatMessage({
        id: "pricingQuotes.jobTitleErrorMessage",
        defaultMessage: "Your job title is required."
    });
    const firstNameErrorMessage = intl.formatMessage({
        id: "pricingQuotes.firstNameErrorMessage",
        defaultMessage: "Your first name is required."
    });
    const lastNameErrorMessage = intl.formatMessage({
        id: "pricingQuotes.lastNameErrorMessage",
        defaultMessage: "Your last name is required."
    });
    const companyErrorMessage = intl.formatMessage({
        id: "pricingQuotes.companyErrorMessage",
        defaultMessage: "Your company name is required."
    });
    const productErrorMessage = intl.formatMessage({
        id: "pricingQuotes.productErrorMessage",
        defaultMessage: "Select a product or service to continue."
    });
    const planErrorMessage = intl.formatMessage({
        id: "pricingQuotes.planErrorMessage",
        defaultMessage: "Select any cloud plan to continue."
    });
    const numberOfPeopleOnTeamErrorMessage = intl.formatMessage({
        id: "pricingQuotes.numberOfPeopleOnTeamErrorMessage",
        defaultMessage: "Your team size is required."
    });
    const numberOfPeopleJSMErrorMessage = intl.formatMessage({
        id: "pricingQuotes.numberOfPeopleSupportedErrorMessage",
        defaultMessage: "We need to know how many people contact your service desk."
    });
    const genericRequiredFieldErrorMessage = intl.formatMessage({
        id: "pricingQuotes.genericRequiredFieldErrorMessage",
        defaultMessage: "This field is required."
    });
    const HandleSubmit = (form)=>{
        const errors = {};
        // eslint-disable-next-line @typescript-eslint/no-for-in-array
        for(const field in form)if (form[field] === undefined || fieldHasError[field]) {
            const errorFields = [
                "email",
                "firstName",
                "lastName",
                "company",
                "title",
                "product",
                "plan",
                "numberOfUsers",
                "opportunity_Description__c"
            ];
            if (errorFields.includes(field)) errors[field] = true;
        }
        if (Object.keys(errors).length > 0) return errors;
        else return (0, $9xhTf.submitContactForm)(form, "pricing-quotes", createAnalyticsEvent).then(()=>{
            window.location.assign(redirectPath);
        }).catch(()=>{
            var _document_querySelector;
            (_document_querySelector = document.querySelector(".post-submit")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.replace("post-submit", "post-submit-error");
        });
    };
    const pricingQuoteSubmitText = intl.formatMessage({
        id: "pricingQuotes.submit",
        defaultMessage: "Submit"
    });
    const loggedOutView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhv63.ConsentHubClientConfigProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
            selectedProduct: selectedProduct,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syaz1533 _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
                ]),
                style: {
                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syaz1533"
                                ]),
                                style: {
                                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: getOrAsk
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                                onSubmit: HandleSubmit,
                                children: ({ formProps: formProps, setFieldValue: setFieldValue, getState: getState })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                                        className: (0, $2jatx.default)([
                                            "_18dc18gv _ytel1j6v _jgjs8pqr _wdh21uxz _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _1lqt1txw _1t901bp4 _1bsb1osq _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961uxz _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1rga _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r3x1v _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _121j1h6o _16w9idpf _lyghidpf _x68d1rga _1c8s1j28 _wqgk8pqr _16im8pqr _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1uxz"
                                        ]),
                                        style: {
                                            "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                                            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                    name: "email",
                                                    label: yourCompanyEmail,
                                                    validate: (value)=>{
                                                        setFieldValue("email", value);
                                                    },
                                                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                    value: fieldProps.value || "",
                                                                    onBlur: handleBlurEvent
                                                                })),
                                                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                    children: errorMessageText === "PERSONAL_DOMAIN" ? personalDomainErrorMessage : notEmailErrorMessage
                                                                }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                    children: personalEmailDomainsError
                                                                })
                                                            ]
                                                        })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                        layout: "6-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "firstName",
                                                                label: intl.formatMessage({
                                                                    id: "pricingQuotes.forename",
                                                                    defaultMessage: "First name"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                                value: fieldProps.value || ""
                                                                            })),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: firstNameErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "lastName",
                                                                label: intl.formatMessage({
                                                                    id: "pricingQuotes.surname",
                                                                    defaultMessage: "Last name"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                                value: fieldProps.value || ""
                                                                            })),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: lastNameErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                        layout: "6-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "company",
                                                                label: intl.formatMessage({
                                                                    id: "pricingQuotes.company",
                                                                    defaultMessage: "Company"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                                value: fieldProps.value || ""
                                                                            })),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: companyErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "title",
                                                                label: intl.formatMessage({
                                                                    id: "pricingQuotes.title",
                                                                    defaultMessage: "Job title"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                                value: fieldProps.value || ""
                                                                            })),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: jobTitleErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                    name: "product",
                                                    label: intl.formatMessage({
                                                        id: "pricingQuotes.product",
                                                        defaultMessage: "Which product or service are you inquiring about?"
                                                    }) + " *",
                                                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.ProductSelector), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                    pageType: "pricing-quotes",
                                                                    onChangeHandler: (product, platform)=>{
                                                                        setFieldValue("product", product);
                                                                        setFieldValue("platform", platform);
                                                                        fieldProps.onChange;
                                                                        setSelectedProduct(product);
                                                                    }
                                                                })),
                                                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                    children: productErrorMessage
                                                                }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                    children: intl.formatMessage({
                                                                        id: "pricingQuotes.productHelper",
                                                                        defaultMessage: "If you\u2019re asking about multiple products, select the one with the most users."
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                })
                                            }),
                                            conditionalFields(selectedProduct, getState, setFieldValue),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: (0, $e0MOs.QuestionField)("pricing-quotes", handleBlurEvent)
                                            }),
                                            (0, $lBgvn.ConsentInfo)(setFieldValue),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gacwQ.default), {
                                                align: "start",
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                                                            inputType: "button",
                                                            text: pricingQuoteSubmitText,
                                                            "aria-label": pricingQuoteSubmitText,
                                                            type: "primary",
                                                            color: isInvalid ? "gray" : "darkblue",
                                                            onClick: ()=>{
                                                                formProps.onSubmit();
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: "post-submit",
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                            children: intl.formatMessage({
                                                                id: "pricingQuotes.submitError",
                                                                defaultMessage: "An error has occurred. Please try again later."
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eodOk.default), {})
                ]
            })
        })
    });
    const loggedInView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhv63.ConsentHubClientConfigProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
            selectedProduct: selectedProduct,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syaz1533 _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
                ]),
                style: {
                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syaz1533"
                                ]),
                                style: {
                                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: getOrAsk
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                                    onSubmit: HandleSubmit,
                                    children: ({ formProps: formProps, setFieldValue: setFieldValue, getState: getState })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                                            className: (0, $2jatx.default)([
                                                "_18dc18gv _ytel1j6v _jgjs8pqr _wdh21uxz _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _1lqt1txw _1t901bp4 _1bsb1osq _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961uxz _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1rga _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r3x1v _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _121j1h6o _16w9idpf _lyghidpf _x68d1rga _1c8s1j28 _wqgk8pqr _16im8pqr _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1uxz"
                                            ]),
                                            style: {
                                                "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                                                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    children: intl.formatMessage({
                                                        id: "pricingQuotes.contactInfo",
                                                        defaultMessage: "You're logged in as:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                                    children: setFieldValue("email", userInfo.email)
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                                    children: setFieldValue("name", userInfo.name)
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyb1k92"
                                                    ]),
                                                    children: [
                                                        userInfo.name,
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                                        userInfo.email
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyboqnp _syaz1ep1 _59381r31 _yha2glyw _1nmznqa1 _43ds1ep1 _1r8v1ul9 _1hw71o8l _1enu1j6v _6b8d1j28"
                                                    ]),
                                                    style: {
                                                        "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                            href: "#changeContactInfo",
                                                            onClick: ()=>{
                                                                setChangeContactInfo(true);
                                                            },
                                                            children: [
                                                                intl.formatMessage({
                                                                    id: "pricingQuotes.updateInfo",
                                                                    defaultMessage: "Update contact info"
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_z6uan7od"
                                                                    ]),
                                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                        label: ""
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                            href: getSwitchAccountURL(),
                                                            children: [
                                                                intl.formatMessage({
                                                                    id: "pricingQuotes.differentAccount",
                                                                    defaultMessage: "Log in with a different Atlassian account"
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_z6uan7od"
                                                                    ]),
                                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                        label: ""
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                        name: "title",
                                                        label: intl.formatMessage({
                                                            id: "pricingQuotes.yourJobTitle",
                                                            defaultMessage: "Your job title"
                                                        }) + " *",
                                                        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                        value: fieldProps.value || "",
                                                                        onBlur: handleBlurEvent
                                                                    })),
                                                                    error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                        children: jobTitleErrorMessage
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                        children: intl.formatMessage({
                                                                            id: "pricingQuotes.yourJobTitleHelper",
                                                                            defaultMessage: "We ask this to connect you to the best expert for your role."
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                        name: "product",
                                                        label: intl.formatMessage({
                                                            id: "pricingQuotes.product",
                                                            defaultMessage: "Which product or service are you inquiring about?"
                                                        }) + " *",
                                                        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.ProductSelector), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                        pageType: "pricing-quotes",
                                                                        onChangeHandler: (product, platform)=>{
                                                                            setFieldValue("product", product);
                                                                            setFieldValue("platform", platform);
                                                                            fieldProps.onChange;
                                                                            setSelectedProduct(product);
                                                                        }
                                                                    })),
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                        children: intl.formatMessage({
                                                                            id: "pricingQuotes.productHelper",
                                                                            defaultMessage: "If you\u2019re asking about multiple products, select the one with the most users."
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                }),
                                                conditionalFields(selectedProduct, getState, setFieldValue),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: (0, $e0MOs.QuestionField)("pricing-quotes", handleBlurEvent)
                                                }),
                                                (0, $lBgvn.ConsentInfo)(setFieldValue),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gacwQ.default), {
                                                    align: "start",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                                                                inputType: "button",
                                                                text: pricingQuoteSubmitText,
                                                                "aria-label": pricingQuoteSubmitText,
                                                                type: "primary",
                                                                color: isInvalid ? "gray" : "darkblue",
                                                                onClick: ()=>{
                                                                    formProps.onSubmit();
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: "post-submit",
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                                children: intl.formatMessage({
                                                                    id: "pricingQuotes.submitError",
                                                                    defaultMessage: "An error has occurred. Please try again later."
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eodOk.default), {})
                ]
            })
        })
    });
    if (userInfo.isUserLoggedIn) {
        if (userInfo.email) {
            if ((0, $9xhTf.isPersonalDomain)(userInfo.email) || userInfo.email.includes("atlassian.com") || changeContactInfo) return loggedOutView;
            else return loggedInView;
        }
    }
    return loggedOutView;
};
var $2d171a99d4a2171f$export$2e2bcd8739ae039 = $2d171a99d4a2171f$var$PricingQuotes;

});
parcelRegister("eodOk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1c1ffd96b6eaa0fb$export$2e2bcd8739ae039; });
/* pq-resource-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $7iXNu = parcelRequire("7iXNu");
const $1c1ffd96b6eaa0fb$var$resourceCardStyling = null;
const $1c1ffd96b6eaa0fb$var$PricingQuotesResourceCards = ()=>{
    const intl = (0, $8e22h.default)();
    const getEstimateText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.GetEstimate",
        defaultMessage: "Get estimate"
    });
    const compareCosts = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CompareCosts",
        defaultMessage: "Compare costs"
    });
    const enterSENsText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.enterSENs",
        defaultMessage: "Enter SENs"
    });
    const pricingQuotesResourceCards = [
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudPricing",
                defaultMessage: "Cloud pricing calculator"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudPricing.dsc",
                defaultMessage: "Estimate your bill for key Cloud products on Premium plans."
            }),
            buttonText: getEstimateText,
            url: (0, $kooLp.useLocalizedHref)("/software/pricing-calculator")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudValue",
                defaultMessage: "Cloud value calculator"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudValue.dsc",
                defaultMessage: "Compare the total cost of your server products to Cloud."
            }),
            buttonText: compareCosts,
            url: (0, $kooLp.useLocalizedHref)("/migration/assess/calculate-pricing")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.DataCenter",
                defaultMessage: "Data Center comparison"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.DataCenter.dsc",
                defaultMessage: "See what it would cost to upgrade your server SENs to Data Center."
            }),
            buttonText: enterSENsText,
            url: (0, $kooLp.useLocalizedHref)("/purchase/upgrade/datacenter")
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: pricingQuotesResourceCards.map((cardProps)=>/*#__PURE__*/ (0, $1oC0p.createElement)((0, $7iXNu.default), (0, $dPABA._)((0, $6ogO3._)({}, cardProps), {
                key: cardProps.header
            })))
    });
};
var $1c1ffd96b6eaa0fb$export$2e2bcd8739ae039 = $1c1ffd96b6eaa0fb$var$PricingQuotesResourceCards;

});


parcelRegister("g06pB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dcd2ef245dc372ce$export$2e2bcd8739ae039; });
/* product-features.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $3L8ZR = parcelRequire("3L8ZR");

var $lX14w = parcelRequire("lX14w");
var $ff3wF = parcelRequire("ff3wF");
var $igGC3 = parcelRequire("igGC3");
var $gacwQ = parcelRequire("gacwQ");
var $kR3EL = parcelRequire("kR3EL");

var $9BG80 = parcelRequire("9BG80");

var $2vYc0 = parcelRequire("2vYc0");

var $8KJ2x = parcelRequire("8KJ2x");

var $fJP6M = parcelRequire("fJP6M");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $1rGpC = parcelRequire("1rGpC");

var $32ng3 = parcelRequire("32ng3");

var $hhv63 = parcelRequire("hhv63");

var $2ve7k = parcelRequire("2ve7k");

var $lBgvn = parcelRequire("lBgvn");

var $3bkHm = parcelRequire("3bkHm");

var $izhAl = parcelRequire("izhAl");

var $e0MOs = parcelRequire("e0MOs");

var $9xhTf = parcelRequire("9xhTf");

var $dzInA = parcelRequire("dzInA");
const $dcd2ef245dc372ce$var$containerStyle = null;
const $dcd2ef245dc372ce$var$innerContainerStyle = null;
const $dcd2ef245dc372ce$var$formStyle = null;
const $dcd2ef245dc372ce$var$textContainer = null;
const $dcd2ef245dc372ce$var$ProductFeatures = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [fieldHasError, setFieldHasError] = (0, $1oC0p.useState)({});
    const [errorMessageText, setErrorMessageText] = (0, $1oC0p.useState)("");
    const [selectedProduct, setSelectedProduct] = (0, $1oC0p.useState)("");
    const [changeContactInfo, setChangeContactInfo] = (0, $1oC0p.useState)(false);
    const [isInvalid, setIsInvalid] = (0, $1oC0p.useState)(true);
    const intl = (0, $8e22h.default)();
    const userInfo = (0, $2ve7k.useLoggedInUser)();
    const redirectPath = (0, $kooLp.useLocalizedHref)(`/enterprise/contact-thanks?formType=product-features`);
    const NEXT_PUBLIC_IDENTITY_BASE_URL = "https://id.atlassian.com";
    const getSwitchAccountURL = (continueUrlParam)=>{
        const continueUrl = continueUrlParam ? continueUrlParam : window.location.href;
        return `${NEXT_PUBLIC_IDENTITY_BASE_URL}/login/select-account?continue=${encodeURIComponent(continueUrl)}`;
    };
    const getOrAsk = intl.formatMessage({
        id: "productFeatures.getOrAsk",
        defaultMessage: "Ask us about the functionality and features of a product or service you might purchase."
    });
    const yourCompanyEmail = intl.formatMessage({
        id: "productFeatures.yourCompanyEmail",
        defaultMessage: "Your company email"
    }) + " *";
    const personalEmailDomainsError = intl.formatMessage({
        id: "productFeatures.personalEmailDomainsError",
        defaultMessage: "Personal email domains will result in an error."
    });
    const conditionalFields = (product, getState, setFieldValue)=>{
        const options = (0, $9xhTf.getProductPlans)(selectedProduct);
        const numberOfPeopleSupported = intl.formatMessage({
            id: "productFeatures.numberOfPeople",
            defaultMessage: "Number of people your agents will support"
        }) + " *";
        const numberOfDevelopersOnTeam = intl.formatMessage({
            id: "productFeatures.numberOfDevelopers",
            defaultMessage: "Number of developers on your team"
        }) + " *";
        const numberOfPeopleOnTeam = intl.formatMessage({
            id: "productFeatures.numberOfPeopleOnTeam",
            defaultMessage: "Number of people on your team"
        }) + " *";
        const numberOfAssets = intl.formatMessage({
            id: "productFeatures.numberOfAssets",
            defaultMessage: "Number of Assets you want to store"
        }) + " *";
        const numberOfAgentConversations = intl.formatMessage({
            id: "productFeatures.numberOfAgentConversations",
            defaultMessage: "Estimated number of virtual service agent conversations per month"
        }) + " *";
        const enterpriseRolloutGuard = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-guard");
        const enterpriseRolloutCompass = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-compass");
        const enterpriseRolloutLoom = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-loom");
        const enterpriseRolloutJPD = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-jpd");
        const enterpriseRolloutTWC = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-twc");
        const serviceCollectionEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8165EnterpriseContactServiceCollection);
        const backupRestoreEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9763BackupRestoreContactForm);
        const additionalSandboxEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9608AdditionalSandboxContactForm);
        const productsWithPlans = [
            "Jira Software",
            "Jira",
            "Confluence",
            "Jira Service Management",
            "Bitbucket"
        ];
        if (enterpriseRolloutGuard) productsWithPlans.push("Atlassian Guard");
        if (enterpriseRolloutCompass) productsWithPlans.push("Compass");
        if (enterpriseRolloutLoom) productsWithPlans.push("Loom");
        if (enterpriseRolloutJPD) productsWithPlans.push("Jira Product Discovery");
        if (enterpriseRolloutTWC) productsWithPlans.push("Teamwork Collection");
        if (serviceCollectionEnabled) productsWithPlans.push("Service Collection");
        if (backupRestoreEnabled) {
            productsWithPlans.push("Jira Cloud Backup and Restore");
            productsWithPlans.push("Jira Service Management Cloud Backup and Restore");
            productsWithPlans.push("Confluence Cloud Backup and Restore");
        }
        if (additionalSandboxEnabled) {
            productsWithPlans.push("Jira Additional Sandbox");
            productsWithPlans.push("Confluence Additional Sandbox");
            productsWithPlans.push("Jira Service Management Additional Sandbox");
            productsWithPlans.push("Jira Product Discovery Additional Sandbox");
        }
        return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
            children: [
                productsWithPlans.includes(product) && getState().values["platform"] === "Cloud" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                    name: "plan",
                    label: intl.formatMessage({
                        id: "productFeatures.plan",
                        defaultMessage: "Which plan are you interested in?"
                    }) + " *",
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2vYc0.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                    options: options,
                                    onChange: (edition)=>{
                                        const value = edition.currentTarget.value;
                                        setFieldValue("edition", value);
                                        setFieldValue("plan", value);
                                        fieldProps.onChange;
                                    }
                                })),
                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                    children: planErrorMessage
                                })
                            ]
                        })
                }),
                [
                    "Jira Software",
                    "Jira",
                    "Confluence",
                    "Jira Service Management",
                    "Bitbucket",
                    "Jira Work Management",
                    "Atlassian Access",
                    "Atlassian Guard",
                    "Opsgenie",
                    "Trello",
                    "Jira Align",
                    "Jira Product Discovery",
                    "Compass",
                    "Atlas",
                    "Rovo",
                    "Loom",
                    "Jira Service Management Assets",
                    "Jira Service Management Virtual Service Agent",
                    "Teamwork Collection",
                    "Strategy Collection",
                    "Service Collection"
                ].includes(product) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                    name: "numberOfUsers",
                    label: product === "Jira Service Management" ? numberOfPeopleSupported : product === "Jira Align" || product === "Jira Product Discovery" || product === "Compass" || product === "Atlas" ? numberOfDevelopersOnTeam : product === "Jira Service Management Assets" ? numberOfAssets : product === "Jira Service Management Virtual Service Agent" ? numberOfAgentConversations : numberOfPeopleOnTeam,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3bkHm.NumberOfUsersInput), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                    onChangeHandler: (numberOfUsers)=>{
                                        setFieldValue("numberOfUsers", Number(numberOfUsers));
                                        fieldProps.onChange;
                                    }
                                })),
                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                    children: product === "Jira Service Management" ? numberOfPeopleJSMErrorMessage : product === "Jira Service Management Assets" || product === "Jira Service Management Virtual Service Agent" ? genericRequiredFieldErrorMessage : numberOfPeopleOnTeamErrorMessage
                                })
                            ]
                        })
                })
            ]
        });
    };
    // @ts-ignore
    const handleBlurEvent = (event)=>{
        const { name: name, value: value } = event.currentTarget;
        if (name === "email") {
            if (!value) {
                setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                    [name]: true
                }));
                setErrorMessageText("NOT_EMAIL");
                setIsInvalid(true);
            } else if ((0, $9xhTf.isEmailFormat)(value) && !(0, $9xhTf.isPersonalDomain)(value)) {
                setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                    [name]: false
                }));
                setErrorMessageText("IS_VALID");
                setIsInvalid(false);
            } else {
                setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                    [name]: true
                }));
                setIsInvalid(true);
                if (!(0, $9xhTf.isEmailFormat)(value)) setErrorMessageText("NOT_EMAIL");
                else if ((0, $9xhTf.isPersonalDomain)(value)) setErrorMessageText("PERSONAL_DOMAIN");
            }
        } else {
            setFieldHasError((0, $dPABA._)((0, $6ogO3._)({}, fieldHasError), {
                [name]: !value
            }));
            setIsInvalid(!value);
        }
    };
    /*
      Error Messages
  */ const personalDomainErrorMessage = intl.formatMessage({
        id: "productFeatures.personalDomainErrorMessage",
        defaultMessage: "Enter an email with a company domain."
    });
    const notEmailErrorMessage = intl.formatMessage({
        id: "productFeatures.notEmailErrorMessage",
        defaultMessage: "Enter a valid email address."
    });
    const jobTitleErrorMessage = intl.formatMessage({
        id: "productFeatures.jobTitleErrorMessage",
        defaultMessage: "Your job title is required."
    });
    const firstNameErrorMessage = intl.formatMessage({
        id: "productFeatures.firstNameErrorMessage",
        defaultMessage: "Your first name is required."
    });
    const lastNameErrorMessage = intl.formatMessage({
        id: "productFeatures.lastNameErrorMessage",
        defaultMessage: "Your last name is required."
    });
    const companyErrorMessage = intl.formatMessage({
        id: "productFeatures.companyErrorMessage",
        defaultMessage: "Your company name is required."
    });
    const productErrorMessage = intl.formatMessage({
        id: "productFeatures.productErrorMessage",
        defaultMessage: "Select a product or service to continue."
    });
    const planErrorMessage = intl.formatMessage({
        id: "productFeatures.planErrorMessage",
        defaultMessage: "Select any cloud plan to continue."
    });
    const numberOfPeopleOnTeamErrorMessage = intl.formatMessage({
        id: "productFeatures.numberOfPeopleOnTeamErrorMessage",
        defaultMessage: "Your team size is required."
    });
    const numberOfPeopleJSMErrorMessage = intl.formatMessage({
        id: "productFeatures.numberOfPeopleSupportedErrorMessage",
        defaultMessage: "We need to know how many people contact your service desk."
    });
    const genericRequiredFieldErrorMessage = intl.formatMessage({
        id: "productFeatures.genericRequiredFieldErrorMessage",
        defaultMessage: "This field is required."
    });
    const HandleSubmit = (form)=>{
        const errors = {};
        // eslint-disable-next-line @typescript-eslint/no-for-in-array
        for(const field in form)if (form[field] === undefined || fieldHasError[field]) {
            const errorFields = [
                "email",
                "firstName",
                "lastName",
                "company",
                "title",
                "product",
                "plan",
                "numberOfUsers",
                "opportunity_Description__c"
            ];
            if (errorFields.includes(field)) errors[field] = true;
        }
        if (Object.keys(errors).length > 0) return errors;
        else return (0, $9xhTf.submitContactForm)(form, "product-features", createAnalyticsEvent).then(()=>{
            window.location.assign(redirectPath);
        }).catch(()=>{
            var _document_querySelector;
            (_document_querySelector = document.querySelector(".post-submit")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.replace("post-submit", "post-submit-error");
        });
    };
    const loggedOutView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhv63.ConsentHubClientConfigProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
            selectedProduct: selectedProduct,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syaz1533 _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
                ]),
                style: {
                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syaz1533"
                                ]),
                                style: {
                                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: getOrAsk
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                                onSubmit: HandleSubmit,
                                children: ({ formProps: formProps, setFieldValue: setFieldValue, getState: getState })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                                        className: (0, $2jatx.default)([
                                            "_18dc18gv _ytel1j6v _jgjs8pqr _wdh21uxz _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _1lqt1txw _1t901bp4 _1bsb1osq _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961uxz _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1rga _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r3x1v _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _121j1h6o _16w9idpf _lyghidpf _x68d1rga _1c8s1j28 _wqgk8pqr _16im8pqr _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1uxz"
                                        ]),
                                        style: {
                                            "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                                            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                    name: "email",
                                                    label: yourCompanyEmail,
                                                    validate: (value)=>{
                                                        setFieldValue("email", value);
                                                    },
                                                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                    value: fieldProps.value || "",
                                                                    onBlur: handleBlurEvent
                                                                })),
                                                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                    children: errorMessageText === "PERSONAL_DOMAIN" ? personalDomainErrorMessage : notEmailErrorMessage
                                                                }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                    children: personalEmailDomainsError
                                                                })
                                                            ]
                                                        })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                        layout: "6-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "firstName",
                                                                label: intl.formatMessage({
                                                                    id: "productFeatures.forename",
                                                                    defaultMessage: "First name"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                                value: fieldProps.value || "",
                                                                                onBlur: handleBlurEvent
                                                                            })),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: firstNameErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "lastName",
                                                                label: intl.formatMessage({
                                                                    id: "productFeatures.surname",
                                                                    defaultMessage: "Last name"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                                value: fieldProps.value || "",
                                                                                onBlur: handleBlurEvent
                                                                            })),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: lastNameErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                        layout: "6-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "company",
                                                                label: intl.formatMessage({
                                                                    id: "productFeatures.company",
                                                                    defaultMessage: "Company"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                                value: fieldProps.value || "",
                                                                                onBlur: handleBlurEvent
                                                                            })),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: companyErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "title",
                                                                label: intl.formatMessage({
                                                                    id: "productFeatures.title",
                                                                    defaultMessage: "Job title"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                                value: fieldProps.value || "",
                                                                                onBlur: handleBlurEvent
                                                                            })),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: jobTitleErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                    name: "product",
                                                    label: intl.formatMessage({
                                                        id: "productFeatures.product",
                                                        defaultMessage: "Which product or service are you inquiring about?"
                                                    }) + " *",
                                                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.ProductSelector), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                    onChangeHandler: (product, platform)=>{
                                                                        setFieldValue("product", product);
                                                                        setFieldValue("platform", platform);
                                                                        setSelectedProduct(product);
                                                                    }
                                                                })),
                                                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                    children: productErrorMessage
                                                                }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                    children: intl.formatMessage({
                                                                        id: "productFeatures.productHelper",
                                                                        defaultMessage: "If you\u2019re asking about multiple products, select the one with the most users."
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                })
                                            }),
                                            conditionalFields(selectedProduct, getState, setFieldValue),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: (0, $e0MOs.QuestionField)("product-features", handleBlurEvent)
                                            }),
                                            (0, $lBgvn.ConsentInfo)(setFieldValue),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gacwQ.default), {
                                                align: "start",
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                                                            inputType: "button",
                                                            text: intl.formatMessage({
                                                                id: "productFeatures.submit",
                                                                defaultMessage: "Submit"
                                                            }),
                                                            type: "primary",
                                                            color: isInvalid ? "gray" : "darkblue",
                                                            onClick: ()=>{
                                                                formProps.onSubmit();
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: "post-submit",
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                            children: intl.formatMessage({
                                                                id: "productFeatures.submitError",
                                                                defaultMessage: "An error has occurred. Please try again later."
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dzInA.default), {})
                ]
            })
        })
    });
    const loggedInView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhv63.ConsentHubClientConfigProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
            selectedProduct: selectedProduct,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syaz1533 _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
                ]),
                style: {
                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syaz1533"
                                ]),
                                style: {
                                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: getOrAsk
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                                    onSubmit: HandleSubmit,
                                    children: ({ formProps: formProps, setFieldValue: setFieldValue, getState: getState })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                                            className: (0, $2jatx.default)([
                                                "_18dc18gv _ytel1j6v _jgjs8pqr _wdh21uxz _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _1lqt1txw _1t901bp4 _1bsb1osq _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961uxz _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1rga _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r3x1v _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _121j1h6o _16w9idpf _lyghidpf _x68d1rga _1c8s1j28 _wqgk8pqr _16im8pqr _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1uxz"
                                            ]),
                                            style: {
                                                "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                                                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    children: intl.formatMessage({
                                                        id: "productFeatures.contactInfo",
                                                        defaultMessage: "You're logged in as:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                                    children: setFieldValue("email", userInfo.email)
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                                    children: setFieldValue("name", userInfo.name)
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyb1k92"
                                                    ]),
                                                    children: [
                                                        userInfo.name,
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                                        userInfo.email
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyboqnp _syaz1ep1 _59381r31 _yha2glyw _1nmznqa1 _43ds1ep1 _1hw71o8l _1r8v1ul9 _1enu1j6v _6b8d1j28"
                                                    ]),
                                                    style: {
                                                        "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                            href: "#changeContactInfo",
                                                            onClick: ()=>setChangeContactInfo(true),
                                                            children: [
                                                                intl.formatMessage({
                                                                    id: "productFeatures.updateInfo",
                                                                    defaultMessage: "Update contact info"
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_z6uan7od"
                                                                    ]),
                                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                        label: ""
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                            href: getSwitchAccountURL(),
                                                            children: [
                                                                intl.formatMessage({
                                                                    id: "productFeatures.differentAccount",
                                                                    defaultMessage: "Log in with a different Atlassian account"
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_z6uan7od"
                                                                    ]),
                                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                        label: ""
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                        name: "title",
                                                        label: intl.formatMessage({
                                                            id: "productFeatures.yourJobTitle",
                                                            defaultMessage: "Your job title"
                                                        }) + " *",
                                                        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                        value: fieldProps.value || "",
                                                                        onBlur: handleBlurEvent
                                                                    })),
                                                                    error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                        children: jobTitleErrorMessage
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                        children: intl.formatMessage({
                                                                            id: "productFeatures.yourJobTitleHelper",
                                                                            defaultMessage: "We ask this to connect you to the best expert for your role."
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                        name: "product",
                                                        label: intl.formatMessage({
                                                            id: "productFeatures.product",
                                                            defaultMessage: "Which product or service are you inquiring about?"
                                                        }) + " *",
                                                        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.ProductSelector), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                                                        onChangeHandler: (product, platform)=>{
                                                                            setFieldValue("product", product);
                                                                            setFieldValue("platform", platform);
                                                                            setSelectedProduct(product);
                                                                        }
                                                                    })),
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                        children: intl.formatMessage({
                                                                            id: "productFeatures.productHelper",
                                                                            defaultMessage: "If you\u2019re asking about multiple products, select the one with the most users."
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                }),
                                                conditionalFields(selectedProduct, getState, setFieldValue),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: (0, $e0MOs.QuestionField)("product-features", handleBlurEvent)
                                                }),
                                                (0, $lBgvn.ConsentInfo)(setFieldValue),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gacwQ.default), {
                                                    align: "start",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                                                                inputType: "button",
                                                                text: intl.formatMessage({
                                                                    id: "productFeatures.submit",
                                                                    defaultMessage: "Submit"
                                                                }),
                                                                type: "primary",
                                                                color: isInvalid ? "gray" : "darkblue",
                                                                onClick: ()=>{
                                                                    formProps.onSubmit();
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: "post-submit",
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                                children: intl.formatMessage({
                                                                    id: "productFeatures.submitError",
                                                                    defaultMessage: "An error has occurred. Please try again later."
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dzInA.default), {})
                ]
            })
        })
    });
    if (userInfo.isUserLoggedIn) {
        if (userInfo.email) {
            if ((0, $9xhTf.isPersonalDomain)(userInfo.email) || userInfo.email.includes("atlassian.com") || changeContactInfo) return loggedOutView;
            else return loggedInView;
        }
    }
    return loggedOutView;
};
var $dcd2ef245dc372ce$export$2e2bcd8739ae039 = $dcd2ef245dc372ce$var$ProductFeatures;

});
parcelRegister("dzInA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1d3e4edc8eee72b$export$2e2bcd8739ae039; });
/* pf-resource-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $7iXNu = parcelRequire("7iXNu");
const $a1d3e4edc8eee72b$var$resourceCardsStyling = null;
const $a1d3e4edc8eee72b$var$ProductFeaturesResourceCards = ()=>{
    const intl = (0, $8e22h.default)();
    const roadMapsText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.ViewRoadmaps",
        defaultMessage: "View roadmaps"
    });
    const advancedFeaturesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.AdvancedFeatures",
        defaultMessage: "See advanced features"
    });
    const browseResourcesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.BrowseResources",
        defaultMessage: "Browse resources"
    });
    const productFeaturesResourceCards = [
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.FeatureRoadmaps",
                defaultMessage: "Feature Roadmaps"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.FeatureRoadmaps.dsc",
                defaultMessage: "See what's in our pipeline for Cloud and Data Center products."
            }),
            buttonText: roadMapsText,
            url: (0, $kooLp.useLocalizedHref)("/roadmap/cloud")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.CloudPremium",
                defaultMessage: "Cloud Premium products"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.CloudPremium.dsc",
                defaultMessage: "Learn about advanced product features for enterprises."
            }),
            buttonText: advancedFeaturesText,
            url: (0, $kooLp.useLocalizedHref)("/software/premium")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.EnterpriseResources",
                defaultMessage: "More enterprise resources"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.EnterpriseResources.dsc",
                defaultMessage: "View resources, filtered by Cloud and Data Center product features."
            }),
            buttonText: browseResourcesText,
            url: (0, $kooLp.useLocalizedHref)("/enterprise/resources?format=&topic=product-features&platform=")
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: productFeaturesResourceCards.map((cardProps)=>/*#__PURE__*/ (0, $1oC0p.createElement)((0, $7iXNu.default), (0, $dPABA._)((0, $6ogO3._)({}, cardProps), {
                key: cardProps.header
            })))
    });
};
var $a1d3e4edc8eee72b$export$2e2bcd8739ae039 = $a1d3e4edc8eee72b$var$ProductFeaturesResourceCards;

});


parcelRegister("5mbMi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5cfb88b10600634a$export$2e2bcd8739ae039; });
/* technical-support.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $fJP6M = parcelRequire("fJP6M");

var $kooLp = parcelRequire("kooLp");
const $5cfb88b10600634a$var$containerStyle = null;
const $5cfb88b10600634a$var$innerContainerStyle = null;
const $5cfb88b10600634a$var$textContainer = null;
const $5cfb88b10600634a$var$buttonStyle = null;
const $5cfb88b10600634a$var$buttonContainer = null;
const $5cfb88b10600634a$var$TechnicalSupport = ()=>{
    const intl = (0, $8e22h.default)();
    const contactSupportText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.techical-support.contact-support",
        defaultMessage: "Contact support"
    });
    const supportServiceText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.techical-support.support-service",
        defaultMessage: ` If your question is related to purchasing additional support services, select \u{201C}product features\u{201D} or \u{201C}pricing & quotes\u{201D}.`
    });
    const assistanceText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.techical-support.assistance",
        defaultMessage: "For assistance with a service you already pay for, please raise a support ticket."
    });
    const localizedURL = "https://support.atlassian.com" + (0, $kooLp.useLocalizedHref)("/contact/");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _p12f1fra _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4y94u"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _p12f1c1k _1ul91ssb"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syazvwuj"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: supportServiceText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: assistanceText
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1pfh1ylp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.default), {
                        text: contactSupportText,
                        "aria-label": contactSupportText,
                        color: "darkblue",
                        url: localizedURL,
                        dataEventProps: {
                            "data-product-key": "jiraSoftwareFeature",
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-label": contactSupportText
                        },
                        className: (0, $2jatx.default)([
                            "_18s81ag2 _k48pbfng _1tke1ylp _3fcw1g80 _s7n41q9y _d5ymcfaq _ect4lnmy _6rth1tcg"
                        ])
                    })
                })
            ]
        })
    });
};
var $5cfb88b10600634a$export$2e2bcd8739ae039 = $5cfb88b10600634a$var$TechnicalSupport;

});






//# sourceMappingURL=enterprise-contact-sales-page.ee19345c.js.map
